var _toConsumableArray = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _possibleConstructorReturn = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _objectSpread = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _objectWithoutProperties = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/runner/work/1/s/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports = function (t) {
  var e = {};

  function n(o) {
    if (e[o]) return e[o].exports;
    var a = e[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return t[o].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, o) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: o
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var o = Object.create(null);
    if (n.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var a in t) {
      n.d(o, a, function (e) {
        return t[e];
      }.bind(null, a));
    }
    return o;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 11);
}([function (t, e) {
  t.exports = require("@tpco/tpco-saturn-types");
}, function (t, e) {
  t.exports = require("util");
}, function (t, e) {
  t.exports = require("moment");
}, function (t, e) {
  t.exports = require("uuid/v4");
}, function (t, e) {
  t.exports = require("aws-sdk");
}, function (t, e) {
  t.exports = require("p-retry");
}, function (t, e) {
  t.exports = require("node-fetch");
}, function (t, e) {
  t.exports = require("@tpco/ad-server.sdk");
}, function (t, e) {
  t.exports = require("uuid");
}, function (t, e) {
  t.exports = require("redis");
}, function (t, e) {
  t.exports = require("crypto");
}, function (t, e, n) {
  "use strict";

  n.r(e);
  var o = {};
  n.r(o), n.d(o, "buildAdvertiser", function () {
    return ae;
  }), n.d(o, "buildCampaign", function () {
    return ie;
  }), n.d(o, "buildInsertion", function () {
    return se;
  }), n.d(o, "buildPvsPage", function () {
    return re;
  }), n.d(o, "buildPage", function () {
    return ce;
  }), n.d(o, "uploadAdvertiser", function () {
    return ue;
  }), n.d(o, "uploadCampaign", function () {
    return ge;
  }), n.d(o, "uploadInsertion", function () {
    return pe;
  }), n.d(o, "uploadCreative", function () {
    return me;
  }), n.d(o, "uploadPage", function () {
    return fe;
  }), n.d(o, "getAdvertiserByName", function () {
    return he;
  }), n.d(o, "getCampaignByName", function () {
    return _e;
  }), n.d(o, "getInsertionsByCampaignId", function () {
    return Ae;
  }), n.d(o, "getInsertionByName", function () {
    return Ce;
  }), n.d(o, "getPageByExternalId", function () {
    return ye;
  }), n.d(o, "makeSmartQueryClient", function () {
    return Wt;
  }), n.d(o, "makeCampaignsApiClient", function () {
    return Kt;
  }), n.d(o, "makeAdvertisersApiClient", function () {
    return Jt;
  }), n.d(o, "makeInsertionsApiClient", function () {
    return Zt;
  }), n.d(o, "makeCreativesApiClient", function () {
    return Xt;
  }), n.d(o, "makePagesApiClient", function () {
    return te;
  }), n.d(o, "makeCampaignName", function () {
    return ne;
  }), n.d(o, "tranformCompanyName", function () {
    return ee;
  }), n.d(o, "makeSnakeCasePageName", function () {
    return oe;
  });
  var a = n(0);

  function i(t) {
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  }

  function s(t, e, n, o) {
    console.log("Creating name for orderType: ", t);
    var s = "";

    switch (e = i(e), t) {
      case a.ProductFulfillmentOrderTypes.AMENDMENT:
        s = "AMEND - ".concat(n, " - ").concat(e);
        break;

      case a.ProductFulfillmentOrderTypes.NEW:
        s = "NEW - ".concat(n, " - ").concat(e);
        break;

      case a.ProductFulfillmentOrderTypes.OPTIMIZATION:
        s = "OPTIMIZE - ".concat(n, " - ").concat(e);
        break;

      case a.ProductFulfillmentOrderTypes.RENEWAL:
        s = "RENEW - ".concat(n, " - ").concat(e);
        break;

      default:
        s = "".concat(a.CONSTANTS.PRODUCT_TYPE_MAP[o], " - ").concat(e);
    }

    return s;
  }

  function r(t) {
    return "Copy - ".concat(t.replace("Copy -", ""));
  }

  function c(t, e) {
    var n = t.toLowerCase();
    return n = function (t, e) {
      var n = new RegExp(/(\/|\(|\)| +)/, "g");
      return t.replace(n, e);
    }(n = function (t) {
      var e = new RegExp(/(,|-|\.|&)/, "g");
      return t.replace(e, "");
    }(n), "_"), n += "--".concat(e);
  }

  var l = n(2),
      d = n.n(l);

  function u() {
    return console.log("process day before end of the month", process.env.REACT_APP_LASTDAYPUBLISH), process.env.REACT_APP_LASTDAYPUBLISH ? parseInt(process.env.REACT_APP_LASTDAYPUBLISH) : 4;
  }

  function g() {
    var t = u(),
        e = d()().endOf("month").endOf("day").subtract(t, "day");
    return console.log("this month cut off day", e.toString()), e;
  }

  function p() {
    var t = d()().endOf("day").endOf("month");
    return console.log("this month last day", t.toString()), t;
  }

  function m() {
    var t = d()().endOf("day").endOf("month").add(1, "day").startOf("day");
    return console.log("next month first day", t.toString()), t;
  }

  function f(t) {
    var e = u(),
        n = d()(t).subtract(1, "month").month().toString(),
        o = d()(t).subtract(1, "month").year().toString(),
        a = d()([o, n, 1]).endOf("month").endOf("day").subtract(e, "day").format("MM/DD/YYYY HH:mm:ss");
    return console.log("last day to publish", a), a;
  }

  function h(t) {
    var e = d()(),
        n = g();
    return console.log("can be locked date", n.toLocaleString()), d()(t).isAfter(e) && d()(t).isAfter(m()) ? (console.log("can be locked true"), !1) : d()(t).isAfter(e) && d()(t).isAfter(f(t)) && d()(e).isAfter(n) ? (console.log("can be locked true", n.toLocaleString()), !0) : (console.log("cannot be locked default"), !1);
  }

  function _(t) {
    var e = d()(),
        n = d()().subtract(1, "month").endOf("month");
    console.log("previus month publish date", n.toString()), console.log(e.toString());
    var o = d()().endOf("month").endOf("day").subtract(u(), "days");
    console.log(e.toString()), console.log("this month publish date", o.toString());
    var a = d()().add(1, "month").endOf("month").endOf("day").subtract(u(), "days");
    console.log("next month publish date", a.toString());
    var i = f(t);
    return console.log("original month publish date", n.toString()), console.log("start date", t), d()(t).isBefore(e) ? i : d()(t).isAfter(e) && d()(t).isAfter(o) ? e.endOf("month").endOf("day") : d()(t).isAfter(e) && d()(t).isBefore(o) ? o : i;
  }

  function C(t, e) {
    return t + 2 * (e > 0 ? e - 1 : 0);
  }

  function A(t) {
    return C(t.rank_points, t.coverage_areas);
  }

  function y(t, e) {
    var n = C(t.rank_points, t.coverage_areas);
    return e.entitled_rank_points === n;
  }

  function T(t, e) {
    return C(w(t), e.length);
  }

  function S(t, e) {
    return t + e.national_purchased_rank_points + e.regional_purchased_rank_points;
  }

  function w(t) {
    return t.reduce(S, 0);
  }

  function O(t, e, n) {
    var o = T(t, e);
    return n.entitled_rank_points === o;
  }

  function b(t, e) {
    return t + e.regional_purchased_rank_points;
  }

  function N(t, e) {
    var n = t.reduce(b, 0),
        o = e.length;
    return n > 0 && o > 0 || 0 === n && 0 === o ? (console.log("match regional points and coverage areas"), !0) : n > 0 && 0 === o || 0 === n && o > 0 ? (console.log("dont match regional points and coverage areas"), !1) : (console.log("error to identify regional points and coverage areas"), !0);
  }

  function I(t, e, n) {
    var o = !0;
    return o = t === C(e, n), console.log("configurationIsValid ".concat(o, " = entitledRankPoints ").concat(t, " === actualPoints ").concat(e, " + 2 * (actualCoverageAreas ").concat(n, " - 1)")), o;
  }

  function v(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var n = d()(),
        o = [];
    var a = 0;
    var i = e ? 10 : d()(n).isSameOrBefore(g()) ? 1 : 2,
        s = e ? d()().subtract(i, "month").startOf("month") : d()().add(i, "month").startOf("month");

    for (; a < 24;) {
      var _t2 = s.format("MM/DD/YYYY").toString(),
          _e2 = {
        value: _t2,
        name: _t2
      };

      o.push(_e2), s.add(1, "month"), a += 1;
    }

    return o;
  }

  function P(t) {
    var e = "".concat(t);
    var n = " - v2";
    var o = e.match(/ - v\d*/g);

    if (o && Array.isArray(o)) {
      var _t3 = o[o.length - 1].split("v");

      return n = " - v".concat(parseInt(_t3[_t3.length - 1]) + 1), o.forEach(function (t) {
        e = e.replace(t, "");
      }), "".concat(e).concat(n);
    }

    return "".concat(e).concat(n);
  }

  function E(t, e, n) {
    var o = d()(),
        i = v();
    console.log("from array", i[0]);
    var s = d()(i[0].value).startOf("day").toString(),
        r = d()(n).add(1, "day").startOf("month").startOf("day").toString();
    return console.log("can optimize day after end month", r), console.log("can optimize next valid date", s), console.log("match firstdate can optimize", d()(r).isSameOrBefore(s)), d()(n).isBefore(o) || d()(r).isSameOrBefore(s) ? (console.log("cannot be optimized end date"), !1) : d()(e).isBefore(o) && !a.CONSTANTS.INVALID_OPTIMIZATION_STATUS.includes(t) ? (console.log("cab be only optimized"), !0) : t !== a.CONSTANTS.CAMPAIGN_STATUS.PUBLISHED ? (console.log("status is not published"), !1) : h(e) ? (console.log("can be locked optimized"), !1) : d()(e).isAfter(o) && d()(e).isAfter(g()) && d()(e).isBefore(p()) ? (console.log("can after cutoff, before the last day of the month = false"), !1) : t === a.CONSTANTS.CAMPAIGN_STATUS.PUBLISHED && d()(e).isBefore(o);
  }

  function x(t, e) {
    return !new RegExp(/^(lop-){1}/).test(t) || e !== a.CONSTANTS.USER_TYPE.CTP;
  }

  function k(t, e, n) {
    var o = d()();
    return !a.CONSTANTS.NO_MORE_CHANGES_CAMPAIGN.includes(t) && (h(e) ? (console.log("can be locked published"), !1) : !!(d()(e).isAfter(o) && d()(e).isAfter(p()) || d()(e).isAfter(o) && d()(e).isBefore(g())) || !!(d()(e).isAfter(o) && d()(e).isAfter(g()) && d()(e).isBefore(p()) && n !== a.CONSTANTS.USER_TYPE.CTP));
  }

  function R(t, e, n, o) {
    if ("SELF_SERVE" === o && "New" === a.CONSTANTS.CAMPAIGN_STATUS_MAP[t]) return !0;
    var i = d()();
    return d()(e).isBefore(i) ? (console.log("can not be edited"), !1) : a.CONSTANTS.NO_MORE_CHANGES_CAMPAIGN.includes(t) ? (console.log("campaign status cannot be edited"), !1) : h(e) ? (console.log("canbe edite false = locked edit"), !1) : d()(e).isAfter(m()) ? (console.log("start date is after the last day of the month = true can be edited One", e), !0) : d()(e).isAfter(i) && d()(e).isAfter(g()) && d()(e).isSameOrBefore(p()) && n !== a.CONSTANTS.USER_TYPE.CTP ? (console.log("start date is after the last day of the month = true no ctp", e), !0) : !!d()(e).isAfter(p()) && (console.log("start date is after the last day of the month = true can be edited two", e), !0);
  }

  var D = n(4),
      F = n.n(D),
      M = n(1),
      $ = n.n(M);

  function U(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  F.a.config.region = "us-east-1";

  var j =
  /*#__PURE__*/
  function () {
    function j(t) {
      _classCallCheck(this, j);

      if (U(this, "arn", void 0), U(this, "client", void 0), this.arn = t, !this.arn) throw new TypeError("Step Function ARN is required");
      this.client = new D.StepFunctions();
    }

    _createClass(j, [{
      key: "execute",
      value: function () {
        var _execute = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(t, e) {
          var _this = this;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", (console.log("Invoking Step Function with arn: ".concat(this.arn)), new Promise(function (n, o) {
                    var a = {
                      stateMachineArn: _this.arn,
                      input: JSON.stringify(e),
                      name: t
                    };

                    _this.client.startExecution(a, function (t, e) {
                      t ? (console.log("Failed to execute step function with params: ".concat(Object(M.inspect)(a, !1, 6))), o(t)) : (console.log("Succesfully invoked step function."), n(e));
                    });
                  })));

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function execute(_x, _x2) {
          return _execute.apply(this, arguments);
        }

        return execute;
      }()
    }, {
      key: "sendActivitySuccess",
      value: function () {
        var _sendActivitySuccess = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(t, e) {
          var _this2 = this;

          var n;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  console.log("Sending Task Success with token: ".concat(t, " for arn: ").concat(this.arn));
                  n = {
                    output: JSON.stringify(e),
                    taskToken: t
                  };
                  return _context2.abrupt("return", new Promise(function (t, e) {
                    _this2.client.sendTaskSuccess(n, function (o, a) {
                      o ? (console.log("Failed to sendActivitySuccess with params: ".concat(Object(M.inspect)(n, !1, 6))), e(o)) : (console.log("sendActivitySuccess succeeded"), t(a));
                    });
                  }));

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function sendActivitySuccess(_x3, _x4) {
          return _sendActivitySuccess.apply(this, arguments);
        }

        return sendActivitySuccess;
      }()
    }, {
      key: "sendActivityFailed",
      value: function () {
        var _sendActivityFailed = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(t, e, n) {
          var _this3 = this;

          var o;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  console.log("Sending Task Failure with token: ".concat(t, " for arn: ").concat(this.arn));
                  o = {
                    cause: e,
                    error: n,
                    taskToken: t
                  };
                  return _context3.abrupt("return", new Promise(function (t, e) {
                    _this3.client.sendTaskFailure(o, function (n, a) {
                      n ? (console.log("Failed to sendTaskFailure with params: ".concat(Object(M.inspect)(o, !1, 6))), e(n)) : (console.log("sendTaskFailure succeeded"), t(a));
                    });
                  }));

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function sendActivityFailed(_x5, _x6, _x7) {
          return _sendActivityFailed.apply(this, arguments);
        }

        return sendActivityFailed;
      }()
    }, {
      key: "getActivityTaskToken",
      value: function () {
        var _getActivityTaskToken = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4(t) {
          var _this4 = this;

          var e;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  console.log("Retrieving Activity Task Token for: ".concat(t, " from: ").concat(this.arn));
                  e = {
                    activityArn: this.arn,
                    workerName: t
                  };
                  return _context4.abrupt("return", new Promise(function (t, n) {
                    _this4.client.getActivityTask(e, function (o, a) {
                      o ? (console.log("Failed to getActivityTaskToken with params: ".concat(Object(M.inspect)(e, !1, 6))), n(o)) : (console.log("getActivityTaskToken succeeded"), t(a.taskToken || ""));
                    });
                  }));

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function getActivityTaskToken(_x8) {
          return _getActivityTaskToken.apply(this, arguments);
        }

        return getActivityTaskToken;
      }()
    }]);

    return j;
  }();

  function B(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  F.a.config.region = "us-east-1";

  var G,
      q =
  /*#__PURE__*/
  function () {
    function q(_ref) {
      var t = _ref.bucketName;

      _classCallCheck(this, q);

      B(this, "bucket", void 0), B(this, "client", void 0), this.bucket = t, this.client = new F.a.S3();
    }

    _createClass(q, [{
      key: "getPresignedPostConfig",
      value: function getPresignedPostConfig(_ref2) {
        var _this5 = this;

        var t = _ref2.key;
        if (!t) throw new Error("getPresignedUrl model is invalid");
        var e = {
          Bucket: this.bucket,
          Expires: 9e3,
          Fields: {
            key: t
          },
          conditions: [{
            acl: "private"
          }, ["starts-with", "$key", ""], ["content-length-range", 0, 1e5], {
            "x-amz-algorithm": "AWS4-HMAC-SHA256"
          }]
        };
        return new Promise(function (t, n) {
          _this5.client.createPresignedPost(e, function (o, a) {
            if (console.log("Presigned Post Config: ", a), o) {
              var _t4 = $.a.format("Error getting presigned config: %s/%s", e.Bucket, e.Fields.key);

              console.error(_t4), n(o);
            } else t(a);
          });
        });
      }
    }, {
      key: "getPresignedUrl",
      value: function getPresignedUrl(_ref3) {
        var _this6 = this;

        var t = _ref3.s3Method,
            e = _ref3.key,
            n = _objectWithoutProperties(_ref3, ["s3Method", "key"]);

        if (!e) throw new Error("getPresignedUrl model is invalid");

        var o = _objectSpread({
          Bucket: this.bucket,
          Key: e
        }, n);

        return console.log(o), new Promise(function (e, n) {
          _this6.client.getSignedUrl(t, o, function (t, a) {
            if (console.log("Signed Url: ", a), t) {
              var _e3 = $.a.format("Error getting presigned url: %s/%s", o.Bucket, o.Key);

              console.error(_e3), n(t);
            } else e(a);
          });
        });
      }
    }, {
      key: "getObject",
      value: function getObject(_ref4) {
        var _this7 = this;

        var t = _ref4.bucket,
            e = _ref4.key;
        if (!t || !e) throw new Error("getObject model is invalid");
        var n = {
          Bucket: t,
          Key: e
        };
        return new Promise(function (o, a) {
          _this7.client.getObject(n, function (n, i) {
            if (n) {
              var _o = $.a.format("Error downloading s3 object: %s/%s", t, e);

              console.error(_o), a(n);
            } else o(i);
          });
        });
      }
    }, {
      key: "getObjectTags",
      value: function getObjectTags(_ref5) {
        var _this8 = this;

        var t = _ref5.bucket,
            e = _ref5.key;
        if (!t || !e) throw new Error("getObjectTags model is invalid");
        var n = {
          Bucket: t,
          Key: e
        };
        return new Promise(function (o, a) {
          _this8.client.getObjectTagging(n, function (n, i) {
            if (n) {
              var _o2 = $.a.format("Error downloading s3 object tags: %s/%s", t, e);

              console.error(_o2), a(n);
            } else o(i);
          });
        });
      }
    }, {
      key: "putObject",
      value: function putObject(_ref6) {
        var _this9 = this;

        var t = _ref6.body,
            e = _ref6.key,
            n = _ref6.tags,
            o = _ref6.size;
        return new Promise(function (a, i) {
          var s = {
            Body: t,
            Bucket: _this9.bucket,
            Key: e
          };

          if (o && (s.ContentLength = o), n) {
            var _t5 = n.map(function (_ref7) {
              var t = _ref7.key,
                  e = _ref7.value;
              return "".concat(t, "=").concat(e);
            });

            s.Tagging = _t5.join("&");
          }

          _this9.client.putObject(s, function (t, e) {
            t ? i(t) : a(e);
          });
        });
      }
    }, {
      key: "deleteObject",
      value: function deleteObject(_ref8) {
        var _this10 = this;

        var t = _ref8.key;
        return new Promise(function (e, n) {
          var o = {
            Bucket: _this10.bucket,
            Key: t
          };

          _this10.client.deleteObject(o, function (t, o) {
            t ? n(t) : e(o);
          });
        });
      }
    }]);

    return q;
  }(),
      L = n(3),
      V = n.n(L);

  function H(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  F.a.config.region = "us-east-1", function (t) {
    t.STANDARD = "STANDARD", t.FIFO = "FIFO";
  }(G || (G = {}));

  var Y =
  /*#__PURE__*/
  function () {
    function Y(t, e) {
      _classCallCheck(this, Y);

      if (H(this, "url", void 0), H(this, "client", void 0), H(this, "queueType", G.STANDARD), this.url = t, !this.url) throw new TypeError("SQS url is required");
      e && e.queueType && (this.queueType = e.queueType), this.client = new F.a.SQS();
    }

    _createClass(Y, [{
      key: "handleResponse",
      value: function handleResponse(t, e, n, o, a, i) {
        a ? (console.log("Failed to execute SQS ".concat(t, " with params: ").concat(Object(M.inspect)(o, !1, 4))), n(a)) : (console.log("Finish SQS ".concat(t)), "VERBOSE" === process.env.DEBUG_MODE && console.log("SQS response: ", Object(M.inspect)(i, !1, 4)), e(i));
      }
    }, {
      key: "buildMessage",
      value: function buildMessage(t, e) {
        var n = {
          MessageBody: JSON.stringify(t)
        };
        return e && e.attributes && (n.MessageAttributes = e.attributes), e && e.dedupeId && this.queueType === G.FIFO && (n.MessageDeduplicationId = e.dedupeId), e && e.messageId && (n.Id = e.messageId), n;
      }
    }, {
      key: "sendMessage",
      value: function () {
        var _sendMessage = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5(t, e) {
          var _this11 = this;

          var n;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  console.log("Begin SQS sendMessage.");
                  n = this.buildMessage(t, e);
                  return _context5.abrupt("return", (n.QueueUrl = this.url, "VERBOSE" === process.env.DEBUG_MODE && console.log("Invoking SQS sendMessage with params ".concat(Object(M.inspect)(n, !1, 4))), new Promise(function (t, e) {
                    _this11.client.sendMessage(n, function (o, a) {
                      return _this11.handleResponse("sendMessage", t, e, n, o, a);
                    });
                  })));

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function sendMessage(_x9, _x10) {
          return _sendMessage.apply(this, arguments);
        }

        return sendMessage;
      }()
    }, {
      key: "batchSendMessage",
      value: function () {
        var _batchSendMessage = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6(t) {
          var _this12 = this;

          var e;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  console.log("Begin SQS batchSendMessage with messages: ".concat(Object(M.inspect)(t, !1, 10)));
                  e = {
                    Entries: t.map(function (t) {
                      return _this12.buildMessage(t.body, {
                        attributes: t.attributes,
                        dedupeId: t.dedupeId,
                        messageId: V()()
                      });
                    }),
                    QueueUrl: this.url
                  };
                  return _context6.abrupt("return", ("VERBOSE" === process.env.DEBUG_MODE && console.log("Invoking SQS batchSendMessage with params ".concat(Object(M.inspect)(e, !1, 4))), new Promise(function (t, n) {
                    _this12.client.sendMessageBatch(e, function (o, a) {
                      return _this12.handleResponse("batchSendMessage", t, n, e, o, a);
                    });
                  })));

                case 3:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function batchSendMessage(_x11) {
          return _batchSendMessage.apply(this, arguments);
        }

        return batchSendMessage;
      }()
    }, {
      key: "getMessage",
      value: function () {
        var _getMessage = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee7(t) {
          var _this13 = this;

          var e;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  console.log("Begin SQS getMessage.");
                  e = {
                    QueueUrl: this.url,
                    AttributeNames: ["All"],
                    MaxNumberOfMessages: 1
                  };
                  return _context7.abrupt("return", (t && (e.MessageAttributeNames = t), "VERBOSE" === process.env.DEBUG_MODE && console.log("Invoking SQS getMessage with params ".concat(Object(M.inspect)(e, !1, 4))), new Promise(function (t, n) {
                    _this13.client.receiveMessage(e, function (o, a) {
                      return _this13.handleResponse("getMessage", t, n, e, o, a);
                    });
                  })));

                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function getMessage(_x12) {
          return _getMessage.apply(this, arguments);
        }

        return getMessage;
      }()
    }, {
      key: "deleteMessage",
      value: function () {
        var _deleteMessage = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee8(t) {
          var _this14 = this;

          var e;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  console.log("Begin SQS deleteMessage.");
                  e = {
                    QueueUrl: this.url,
                    ReceiptHandle: t
                  };
                  return _context8.abrupt("return", ("VERBOSE" === process.env.DEBUG_MODE && console.log("Invoking SQS deleteMessage with params ".concat(Object(M.inspect)(e, !1, 4))), new Promise(function (t, n) {
                    _this14.client.deleteMessage(e, function (o, a) {
                      return _this14.handleResponse("deleteMessage", t, n, e, o, a);
                    });
                  })));

                case 3:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function deleteMessage(_x13) {
          return _deleteMessage.apply(this, arguments);
        }

        return deleteMessage;
      }()
    }, {
      key: "releaseMessage",
      value: function () {
        var _releaseMessage = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee9(t) {
          var _this15 = this;

          var e;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  console.log("Begin SQS releaseMessage.");
                  e = {
                    QueueUrl: this.url,
                    ReceiptHandle: t,
                    VisibilityTimeout: 0
                  };
                  return _context9.abrupt("return", ("VERBOSE" === process.env.DEBUG_MODE && console.log("Invoking SQS releaseMessage with params ".concat(Object(M.inspect)(e, !1, 4))), new Promise(function (t, n) {
                    _this15.client.changeMessageVisibility(e, function (o, a) {
                      return _this15.handleResponse("releaseMessage", t, n, e, o, a);
                    });
                  })));

                case 3:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));

        function releaseMessage(_x14) {
          return _releaseMessage.apply(this, arguments);
        }

        return releaseMessage;
      }()
    }, {
      key: "getMessageCounts",
      value: function () {
        var _getMessageCounts = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee10() {
          var _this16 = this;

          var t;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  console.log("Begin SQS getMessageCounts.");
                  t = {
                    QueueUrl: this.url,
                    AttributeNames: ["ApproximateNumberOfMessages", "ApproximateNumberOfMessagesDelayed", "ApproximateNumberOfMessagesNotVisible"]
                  };
                  return _context10.abrupt("return", ("VERBOSE" === process.env.DEBUG_MODE && console.log("Invoking SQS getMessageCounts with params ".concat(Object(M.inspect)(t, !1, 4))), new Promise(function (e, n) {
                    _this16.client.getQueueAttributes(t, function (o, a) {
                      return _this16.handleResponse("getMessageCounts", e, n, t, o, a);
                    });
                  }).then(function (t) {
                    var e = {
                      available: parseInt(t.Attributes.ApproximateNumberOfMessages),
                      delayed: parseInt(t.Attributes.ApproximateNumberOfMessagesDelayed),
                      inProgress: parseInt(t.Attributes.ApproximateNumberOfMessagesNotVisible)
                    };
                    return console.log("Message counts: ".concat(Object(M.inspect)(e, !1, 2))), e;
                  })));

                case 3:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));

        function getMessageCounts() {
          return _getMessageCounts.apply(this, arguments);
        }

        return getMessageCounts;
      }()
    }], [{
      key: "createClient",
      value: function createClient(t, e) {
        var n;

        try {
          if ("string" != typeof t) throw new TypeError("".concat(e, " is not a valid url."));
          n = new Y(t);
        } catch (t) {
          throw console.log("Failed to create SQSClient."), t;
        }

        return n;
      }
    }]);

    return Y;
  }();

  var z = Y,
      Q = n(9);

  function W(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var K =
  /*#__PURE__*/
  function (_Q$RedisClient) {
    _inherits(K, _Q$RedisClient);

    function K() {
      var _getPrototypeOf2;

      var _this17;

      _classCallCheck(this, K);

      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }

      _this17 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(K)).call.apply(_getPrototypeOf2, [this].concat(t))), W(_assertThisInitialized(_assertThisInitialized(_this17)), "getAsync", Object(M.promisify)(_this17.hget).bind(_assertThisInitialized(_assertThisInitialized(_this17)))), W(_assertThisInitialized(_assertThisInitialized(_this17)), "setAsync", Object(M.promisify)(_this17.hset).bind(_assertThisInitialized(_assertThisInitialized(_this17)))), W(_assertThisInitialized(_assertThisInitialized(_this17)), "quitAsync", Object(M.promisify)(_this17.quit).bind(_assertThisInitialized(_assertThisInitialized(_this17)))), W(_assertThisInitialized(_assertThisInitialized(_this17)), "rpushAsync", Object(M.promisify)(_this17.rpush).bind(_assertThisInitialized(_assertThisInitialized(_this17)))), W(_assertThisInitialized(_assertThisInitialized(_this17)), "blpopAsync", Object(M.promisify)(_this17.blpop).bind(_assertThisInitialized(_assertThisInitialized(_this17)))), W(_assertThisInitialized(_assertThisInitialized(_this17)), "flushdbAsync", Object(M.promisify)(_this17.flushdb).bind(_assertThisInitialized(_assertThisInitialized(_this17))));
      return _this17;
    }

    _createClass(K, [{
      key: "getData",
      value: function () {
        var _getData = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee11(t, e) {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  return _context11.abrupt("return", (console.log("redisKey getExportStatus", t), console.log("redis id", e), this.getAsync(t, e).then(function (t) {
                    return JSON.parse(t);
                  }).catch(function (t) {
                    throw console.log("redis get data error", t), t;
                  })));

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));

        function getData(_x15, _x16) {
          return _getData.apply(this, arguments);
        }

        return getData;
      }()
    }, {
      key: "setData",
      value: function () {
        var _setData = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee12(t, e, n) {
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  return _context12.abrupt("return", (console.log("redisKey setExportStatus", t), console.log("redis id", e), console.log("redis data", n), this.setAsync(t, e, JSON.stringify(n)).catch(function (t) {
                    throw console.log("redis setdatata error", t), t;
                  })));

                case 1:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, this);
        }));

        function setData(_x17, _x18, _x19) {
          return _setData.apply(this, arguments);
        }

        return setData;
      }()
    }, {
      key: "createKey",
      value: function createKey(t) {
        return t.join(":");
      }
    }, {
      key: "lazyGet",
      value: function () {
        var _lazyGet = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee13(t, e, n) {
          var o;
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.next = 2;
                  return this.getAsync(t, e);

                case 2:
                  o = _context13.sent;

                  if (!(null !== o)) {
                    _context13.next = 7;
                    break;
                  }

                  _context13.t0 = (console.log("[lazyGet] found \"".concat(t, "\" in cache.")), JSON.parse(o));
                  _context13.next = 14;
                  break;

                case 7:
                  _context13.next = 9;
                  return n();

                case 9:
                  o = _context13.sent;
                  console.log("[lazyGet] setting cache.");
                  _context13.next = 13;
                  return this.setAsync(t, e, JSON.stringify(o));

                case 13:
                  _context13.t0 = o;

                case 14:
                  return _context13.abrupt("return", _context13.t0);

                case 15:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));

        function lazyGet(_x20, _x21, _x22) {
          return _lazyGet.apply(this, arguments);
        }

        return lazyGet;
      }()
    }]);

    return K;
  }(Q.RedisClient);

  var J = K;

  var Z =
  /*#__PURE__*/
  function () {
    function Z(t) {
      _classCallCheck(this, Z);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Z, [{
      key: "duplicateCampaign",
      value: function () {
        var _duplicateCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee14(t, e) {
          var _n, _o3, _a;

          return _regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  _context14.prev = 0;
                  console.log("Duplicating campaign.");
                  _context14.next = 4;
                  return this.context.p3Campaign.get(t);

                case 4:
                  _n = _context14.sent;
                  _o3 = V()();
                  _a = {
                    p3_campaign_id: e,
                    tgrams_id: _n.tgrams_id,
                    p3_configuration_id: _n.p3_configuration_id ? _o3 : "",
                    name: r(_n.name),
                    start_date: _n.start_date,
                    end_date: _n.end_date,
                    entitled_rank_points: _n.entitled_rank_points,
                    entitled_coverage_areas: _n.entitled_coverage_areas,
                    entitled_preview_ads: _n.entitled_preview_ads
                  };
                  _context14.next = 9;
                  return this.context.p3Campaign.insert(_a);

                case 9:
                  _context14.t0 = _n.p3_configuration_id;

                  if (!_context14.t0) {
                    _context14.next = 13;
                    break;
                  }

                  _context14.next = 13;
                  return this.duplicateConfiguration(_n.p3_configuration_id, _o3, {
                    newCampaignId: e
                  });

                case 13:
                  _context14.next = 18;
                  break;

                case 15:
                  _context14.prev = 15;
                  _context14.t1 = _context14["catch"](0);
                  console.log("Failed to duplicate and save new P3 Campaign");

                case 18:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14, this, [[0, 15]]);
        }));

        function duplicateCampaign(_x23, _x24) {
          return _duplicateCampaign.apply(this, arguments);
        }

        return duplicateCampaign;
      }()
    }, {
      key: "duplicateConfigurationByCampaignAndTgrams",
      value: function () {
        var _duplicateConfigurationByCampaignAndTgrams = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee15(t, e) {
          var _n2, _o4;

          return _regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.prev = 0;
                  console.log("Duplicating campaign.");
                  _context15.next = 4;
                  return this.context.p3Campaign.get(t);

                case 4:
                  _n2 = _context15.sent;
                  _o4 = V()();
                  _context15.t0 = _n2 && _n2.p3_configuration_id;

                  if (!_context15.t0) {
                    _context15.next = 10;
                    break;
                  }

                  _context15.next = 10;
                  return this.duplicateConfiguration(_n2.p3_configuration_id, _o4, {
                    newTgramsId: e
                  });

                case 10:
                  _context15.next = 15;
                  break;

                case 12:
                  _context15.prev = 12;
                  _context15.t1 = _context15["catch"](0);
                  console.log("Failed to duplicate and save new P3 configuration by campaign and tgrams");

                case 15:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, this, [[0, 12]]);
        }));

        function duplicateConfigurationByCampaignAndTgrams(_x25, _x26) {
          return _duplicateConfigurationByCampaignAndTgrams.apply(this, arguments);
        }

        return duplicateConfigurationByCampaignAndTgrams;
      }()
    }, {
      key: "duplicateConfiguration",
      value: function () {
        var _duplicateConfiguration = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee16(t, e, n) {
          var o, _a2, _i, _s, _c, _l, _d;

          return _regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  o = this.context.userId;
                  _context16.prev = 1;
                  _context16.next = 4;
                  return this.context.p3Configuration.get(t);

                case 4:
                  _a2 = _context16.sent;
                  _i = {
                    p3_configuration_id: e,
                    p3_campaign_id: n && n.newCampaignId ? n.newCampaignId : "",
                    tgrams_id: n && n.newTgramsId ? n.newTgramsId : _a2.tgrams_id,
                    name: r(_a2.name),
                    owned_by: o,
                    created_by: o,
                    status_id: _a2.status_id,
                    description: _a2.description,
                    rank_points: _a2.rank_points,
                    coverage_areas: _a2.coverage_areas,
                    preview_ads: _a2.preview_ads,
                    program_value: _a2.program_value,
                    start_date: _a2.start_date,
                    end_date: _a2.end_date,
                    configuration_status_id: _a2.configuration_status_id
                  };
                  _context16.next = 8;
                  return this.context.p3Configuration.insert(_i);

                case 8:
                  _context16.next = 10;
                  return this.duplicateCategories(t, e);

                case 10:
                  _context16.next = 12;
                  return this.duplicateRegions(t, e);

                case 12:
                  _context16.next = 14;
                  return this.context.p3ConfigurationCategory.findAll(e);

                case 14:
                  _s = _context16.sent;
                  _context16.next = 17;
                  return this.context.p3ConfigurationRegion.findAll(e);

                case 17:
                  _c = _context16.sent;
                  _context16.next = 20;
                  return this.context.p3Configuration.get(e);

                case 20:
                  _l = _context16.sent;
                  _l.status_id = N(_s, _c) ? 1 : 0;
                  _d = _s.reduce(function (t, e) {
                    return t + e.national_purchased_rank_points + e.regional_purchased_rank_points;
                  }, 0);
                  _l.rank_points = _d;
                  0 !== _s.length && 0 !== _c.length || (_l.coverage_areas = 0);
                  _context16.next = 27;
                  return this.context.p3Configuration.update(_l);

                case 27:
                  return _context16.abrupt("return", _l);

                case 30:
                  _context16.prev = 30;
                  _context16.t0 = _context16["catch"](1);
                  return _context16.abrupt("return", (console.log("ERROR duplicating p3Configuration ".concat(_context16.t0)), null));

                case 33:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16, this, [[1, 30]]);
        }));

        function duplicateConfiguration(_x27, _x28, _x29) {
          return _duplicateConfiguration.apply(this, arguments);
        }

        return duplicateConfiguration;
      }()
    }, {
      key: "duplicateRegions",
      value: function () {
        var _duplicateRegions = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee17(t, e) {
          var _n3;

          return _regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  _context17.prev = 0;
                  _context17.next = 3;
                  return this.context.p3ConfigurationRegion.findAll(t);

                case 3:
                  _n3 = _context17.sent;
                  console.log("existing p3ConfigurationRegions: ", Object(M.inspect)(_n3, !1, 10));

                  _n3.forEach(function (t) {
                    t.p3_configuration_id = e;
                  });

                  console.log("new p3ConfigurationRegions: ", Object(M.inspect)(_n3, !1, 10));
                  _context17.next = 9;
                  return this.context.p3ConfigurationRegion.insert(_n3);

                case 9:
                  return _context17.abrupt("return", !0);

                case 12:
                  _context17.prev = 12;
                  _context17.t0 = _context17["catch"](0);
                  return _context17.abrupt("return", (console.log("error duplicating regions ".concat(_context17.t0)), !1));

                case 15:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17, this, [[0, 12]]);
        }));

        function duplicateRegions(_x30, _x31) {
          return _duplicateRegions.apply(this, arguments);
        }

        return duplicateRegions;
      }()
    }, {
      key: "duplicateCategories",
      value: function () {
        var _duplicateCategories = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee18(t, e) {
          var _n4;

          return _regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  _context18.prev = 0;
                  _context18.next = 3;
                  return this.context.p3ConfigurationCategory.findValidFromCategories(t);

                case 3:
                  _n4 = _context18.sent;
                  console.log("existing p3ConfigurationCategories: ", Object(M.inspect)(_n4, !1, 10));

                  _n4.forEach(function (t) {
                    t.p3_configuration_id = e;
                  });

                  console.log("new p3ConfigurationCategories: ", Object(M.inspect)(_n4, !1, 10));
                  _context18.t0 = _n4.length > 0;

                  if (!_context18.t0) {
                    _context18.next = 11;
                    break;
                  }

                  _context18.next = 11;
                  return this.context.p3ConfigurationCategory.insert(_n4);

                case 11:
                  return _context18.abrupt("return", !0);

                case 14:
                  _context18.prev = 14;
                  _context18.t1 = _context18["catch"](0);
                  return _context18.abrupt("return", (console.log("error duplicating categories ".concat(_context18.t1)), !1));

                case 17:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18, this, [[0, 14]]);
        }));

        function duplicateCategories(_x32, _x33) {
          return _duplicateCategories.apply(this, arguments);
        }

        return duplicateCategories;
      }()
    }]);

    return Z;
  }();

  var X =
  /*#__PURE__*/
  function () {
    function X(t) {
      _classCallCheck(this, X);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(X, [{
      key: "duplicateCampaign",
      value: function () {
        var _duplicateCampaign2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee19(t, e) {
          var n, o;
          return _regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  console.log("Duplicating campaign fired");
                  _context19.next = 3;
                  return this.context.pvsCampaign.get(t);

                case 3:
                  n = _context19.sent;
                  o = {
                    pvs_campaign_id: e,
                    tgrams_id: n.tgrams_id,
                    ad_server_campaign_id: "",
                    vertical_id: n.vertical_id,
                    weight: n.weight,
                    ad_server_name: n.ad_server_name,
                    start_date: "",
                    end_date: "",
                    is_active: !0,
                    last_sync_date: "",
                    is_dirty: !0
                  };
                  _context19.next = 7;
                  return this.context.pvsCampaign.insert(o);

                case 7:
                  _context19.next = 9;
                  return this.duplicateCreatives(t, e);

                case 9:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19, this);
        }));

        function duplicateCampaign(_x34, _x35) {
          return _duplicateCampaign2.apply(this, arguments);
        }

        return duplicateCampaign;
      }()
    }, {
      key: "duplicateCreatives",
      value: function () {
        var _duplicateCreatives = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee20(t, e) {
          var _this18 = this;

          var n;
          return _regeneratorRuntime.wrap(function _callee20$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  console.log("Duplicating creatives fired");
                  _context20.next = 3;
                  return this.context.pvsCreative.listByCampaignId(t);

                case 3:
                  n = _context20.sent;
                  _context20.next = 6;
                  return Promise.all(n.map(function (t) {
                    var n = {
                      pvs_campaign_id: e,
                      ad_server_parent_id: "",
                      bucket_key: "",
                      is_dirty: !0,
                      name: t.name,
                      platform_id: t.platform_id,
                      click_url: t.click_url,
                      is_active: t.is_active
                    };
                    return _this18.context.pvsCreative.insert(n);
                  }));

                case 6:
                case "end":
                  return _context20.stop();
              }
            }
          }, _callee20, this);
        }));

        function duplicateCreatives(_x36, _x37) {
          return _duplicateCreatives.apply(this, arguments);
        }

        return duplicateCreatives;
      }()
    }]);

    return X;
  }();

  var tt =
  /*#__PURE__*/
  function () {
    function tt(t) {
      _classCallCheck(this, tt);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(tt, [{
      key: "duplicate",
      value: function () {
        var _duplicate = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee21(t, e) {
          var n, o, _t6, _o5;

          return _regeneratorRuntime.wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  console.log("resolvers.query.thomas_campaign.duplicate fired");
                  new Date().toISOString();
                  _context21.next = 4;
                  return this.context.thomasCampaign.get(t);

                case 4:
                  n = _context21.sent;
                  e || (e = V()());
                  o = {
                    campaign_id: e,
                    tgrams_id: n.tgrams_id,
                    product_id: n.product_id,
                    name: r(n.name),
                    start_date: "",
                    end_date: "",
                    status_id: a.CONSTANTS.CAMPAIGN_STATUS.NEW
                  };
                  _context21.next = 9;
                  return this.context.thomasCampaign.insert(_o5);

                case 9:
                  _context21.t0 = n.product_id;
                  _context21.next = _context21.t0 === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS ? 12 : _context21.t0 === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS ? 17 : 22;
                  break;

                case 12:
                  console.log("Trying to duplicate PVS Campaign");
                  _t6 = new X(this.context);
                  _context21.next = 16;
                  return _t6.duplicateCampaign(n.campaign_id, e);

                case 16:
                  return _context21.abrupt("break", 23);

                case 17:
                  console.log("Trying to duplicate P3 Campaign");
                  _o5 = new Z(this.context);
                  _context21.next = 21;
                  return _o5.duplicateCampaign(n.campaign_id, e);

                case 21:
                  return _context21.abrupt("break", 23);

                case 22:
                  console.log("Could not find duplicate function for CONSTANTS.CAMPAIGN_PRODUCT_TYPE: ", n.product_id);

                case 23:
                  return _context21.abrupt("return", !0);

                case 24:
                case "end":
                  return _context21.stop();
              }
            }
          }, _callee21, this);
        }));

        function duplicate(_x38, _x39) {
          return _duplicate.apply(this, arguments);
        }

        return duplicate;
      }()
    }]);

    return tt;
  }();

  function et(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var nt =
  /*#__PURE__*/
  function () {
    function nt(t) {
      _classCallCheck(this, nt);

      et(this, "context", void 0), et(this, "thomasCampaign", void 0), et(this, "productFulfillment", void 0), this.context = t;
    }

    _createClass(nt, [{
      key: "getThomasCampaign",
      value: function () {
        var _getThomasCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee22(t) {
          return _regeneratorRuntime.wrap(function _callee22$(_context22) {
            while (1) {
              switch (_context22.prev = _context22.next) {
                case 0:
                  _context22.t0 = !this.thomasCampaign;

                  if (!_context22.t0) {
                    _context22.next = 6;
                    break;
                  }

                  _context22.next = 4;
                  return this.context.thomasCampaign.get(t);

                case 4:
                  this.thomasCampaign = _context22.sent;
                  _context22.t0 = !this.thomasCampaign;

                case 6:
                  if (!_context22.t0) {
                    _context22.next = 8;
                    break;
                  }

                  throw new Error("Failed to get thomasCampaign record for campaignId: ".concat(t));

                case 8:
                  return _context22.abrupt("return", this.thomasCampaign);

                case 9:
                case "end":
                  return _context22.stop();
              }
            }
          }, _callee22, this);
        }));

        function getThomasCampaign(_x40) {
          return _getThomasCampaign.apply(this, arguments);
        }

        return getThomasCampaign;
      }()
    }, {
      key: "getProductFulfillment",
      value: function () {
        var _getProductFulfillment = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee23(t) {
          return _regeneratorRuntime.wrap(function _callee23$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  _context23.t0 = !this.productFulfillment;

                  if (!_context23.t0) {
                    _context23.next = 6;
                    break;
                  }

                  _context23.next = 4;
                  return this.context.productFulfillment.findByCampaignId(t);

                case 4:
                  this.productFulfillment = _context23.sent;
                  _context23.t0 = !this.productFulfillment;

                case 6:
                  if (!_context23.t0) {
                    _context23.next = 8;
                    break;
                  }

                  throw new Error("Failed to find productFulfillment record for campaignId: ".concat(t));

                case 8:
                  return _context23.abrupt("return", this.productFulfillment);

                case 9:
                case "end":
                  return _context23.stop();
              }
            }
          }, _callee23, this);
        }));

        function getProductFulfillment(_x41) {
          return _getProductFulfillment.apply(this, arguments);
        }

        return getProductFulfillment;
      }()
    }, {
      key: "setProductFulfillment",
      value: function () {
        var _setProductFulfillment = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee24(t) {
          return _regeneratorRuntime.wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  console.log("productFulfillment arg: ", Object(M.inspect)(t, !1, 10)), this.productFulfillment = t;

                case 1:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee24, this);
        }));

        function setProductFulfillment(_x42) {
          return _setProductFulfillment.apply(this, arguments);
        }

        return setProductFulfillment;
      }()
    }, {
      key: "createNewFulfillment",
      value: function () {
        var _createNewFulfillment = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee25(t) {
          var e, n;
          return _regeneratorRuntime.wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  e = a.ResponseInfo.makeEmptyResponseInfo();
                  console.log("Begin creating new product fulfillment record from requestData.");
                  n = {
                    opportunity_id: t.opportunityId,
                    item_id: t.itemId,
                    tgrams_id: parseInt(t.tgramsId, 10).toString(),
                    product_sku: t.productSku,
                    quantity: t.quantity,
                    start_date: t.startDate,
                    end_date: t.endDate,
                    campaign_id: "",
                    source_campaign_id: t.sourceCampaignId,
                    configuration_workflow_arn: "",
                    configuration_activity_token: "",
                    is_configuration_workflow_ready: !1,
                    total_contract_value: t.totalContractValue,
                    order_source: t.orderSource
                  };
                  _context25.prev = 3;
                  console.log("Creating new product fulfillment.");
                  _context25.next = 7;
                  return this.context.productFulfillment.insert(n);

                case 7:
                  _context25.next = 12;
                  break;

                case 9:
                  _context25.prev = 9;
                  _context25.t0 = _context25["catch"](3);
                  return _context25.abrupt("return", (e.reportError(_context25.t0, {
                    errorMessage: "Failed to create new product fulfillment record.",
                    statusCode: 500
                  }), e));

                case 12:
                  return _context25.abrupt("return", (e.data.productFulfillment = n, console.log("Successfully created new product fulfillment record from requestData."), e));

                case 13:
                case "end":
                  return _context25.stop();
              }
            }
          }, _callee25, this, [[3, 9]]);
        }));

        function createNewFulfillment(_x43) {
          return _createNewFulfillment.apply(this, arguments);
        }

        return createNewFulfillment;
      }()
    }, {
      key: "getExistingCampaignData",
      value: function () {
        var _getExistingCampaignData = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee26(t) {
          var e, n, _o6, _a3, _i2, _s2;

          return _regeneratorRuntime.wrap(function _callee26$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  e = a.ResponseInfo.makeEmptyResponseInfo();
                  console.log("Begin getting existing campaign & configuration records.");
                  _context26.next = 4;
                  return this.getThomasCampaign(t);

                case 4:
                  n = _context26.sent;
                  _context26.prev = 5;

                  if (n) {
                    _context26.next = 8;
                    break;
                  }

                  throw new Error("Thomas campaign is somehow not available.");

                case 8:
                  _context26.next = 10;
                  return this.context.p3Campaign.get(t);

                case 10:
                  _o6 = _context26.sent;
                  _a3 = null;

                  if (!_o6.p3_configuration_id) {
                    _context26.next = 18;
                    break;
                  }

                  _context26.next = 15;
                  return this.context.p3Configuration.get(_o6.p3_configuration_id);

                case 15:
                  _a3 = _context26.sent;
                  _context26.next = 19;
                  break;

                case 18:
                  console.log("Existing p3 campaign is missing configuration id");

                case 19:
                  _context26.next = 21;
                  return this.context.thomasAdvertiser.get(n.tgrams_id);

                case 21:
                  _i2 = _context26.sent;
                  _s2 = {
                    existingStartDate: n.start_date,
                    existingEndDate: n.end_date,
                    existingThomasCampaign: n,
                    existingP3Campaign: _o6,
                    existingP3Configuration: _a3,
                    existingAdvertiser: _i2
                  };
                  e.data = _s2;
                  _context26.next = 29;
                  break;

                case 26:
                  _context26.prev = 26;
                  _context26.t0 = _context26["catch"](5);
                  e.reportError(_context26.t0, {
                    statusCode: 500,
                    errorMessage: "Failed to get existing campaign and configuration records. These should exist at this point."
                  });

                case 29:
                  return _context26.abrupt("return", (console.log("Successfully retrieved existing campaign & configuration records."), e));

                case 30:
                case "end":
                  return _context26.stop();
              }
            }
          }, _callee26, this, [[5, 26]]);
        }));

        function getExistingCampaignData(_x44) {
          return _getExistingCampaignData.apply(this, arguments);
        }

        return getExistingCampaignData;
      }()
    }, {
      key: "createNewRecords",
      value: function () {
        var _createNewRecords = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee27(t, e, n, o, i, s, r) {
          var c, l, _e4, _e5, _t7, _a4, _r, _e6, _e7, _n6, _n5, _e8;

          return _regeneratorRuntime.wrap(function _callee27$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  c = Object(a.makeEmptyResponseInfo)();
                  console.log("Begin creating new campaign and configuration records.");
                  l = V()();
                  _context27.prev = 3;
                  console.log("Attempting to duplicate campaign (".concat(t, ") with new campaignId ").concat(l));
                  _e4 = new tt(this.context);
                  _context27.next = 8;
                  return _e4.duplicate(t, l);

                case 8:
                  _context27.next = 14;
                  break;

                case 10:
                  _context27.prev = 10;
                  _context27.t0 = _context27["catch"](3);
                  _e5 = "Failed to duplicate campaign";
                  return _context27.abrupt("return", (console.log(_e5), console.log(_context27.t0), c.errors.push(_e5), c.statusCode = 500, c));

                case 14:
                  console.log("Successfully duplicated campaign (".concat(t, ") with new campaignId: ").concat(l));
                  _context27.prev = 15;
                  console.log("Updating new campaigns' startDates and names.");
                  _context27.next = 19;
                  return this.context.thomasCampaign.get(l);

                case 19:
                  _t7 = _context27.sent;
                  _context27.next = 22;
                  return this.context.p3Campaign.get(l);

                case 22:
                  _a4 = _context27.sent;

                  if (!_a4.p3_configuration_id) {
                    _context27.next = 34;
                    break;
                  }

                  _context27.next = 26;
                  return this.context.p3Configuration.get(_a4.p3_configuration_id);

                case 26:
                  _context27.t1 = _r = _context27.sent;

                  if (!_context27.t1) {
                    _context27.next = 32;
                    break;
                  }

                  _r.start_date = e;
                  _r.end_date = n;
                  _context27.next = 32;
                  return this.context.p3Configuration.update(_r);

                case 32:
                  _context27.next = 35;
                  break;

                case 34:
                  console.log("New p3 campaign is missing configuration id");

                case 35:
                  _t7.start_date = e;
                  _t7.end_date = n;
                  _a4.start_date = e;
                  _a4.end_date = n;
                  _t7.name = o;
                  _a4.name = o;
                  _t7.status_id = i;
                  "number" == typeof s && (_a4.entitled_rank_points = s);
                  _context27.next = 45;
                  return this.context.thomasCampaign.update(_t7);

                case 45:
                  _context27.next = 47;
                  return this.context.p3Campaign.update(_a4);

                case 47:
                  _context27.next = 53;
                  break;

                case 49:
                  _context27.prev = 49;
                  _context27.t2 = _context27["catch"](15);
                  _e6 = "Failed to update new campaign dates and names.";
                  return _context27.abrupt("return", (console.log(_e6), console.log(_context27.t2), c.errors.push(_e6), c.statusCode = 500, c));

                case 53:
                  console.log("Sucessfully updated new campaigns' startDates and names.");
                  _context27.prev = 54;

                  if (this.productFulfillment) {
                    _context27.next = 57;
                    break;
                  }

                  throw new Error("Product fulfillment is somehow not available when creating new version.");

                case 57:
                  _e7 = 1;

                  if (!("number" == typeof r)) {
                    _context27.next = 62;
                    break;
                  }

                  console.log("newVersion arg provided, setting version to: ", r), _e7 = r;
                  _context27.next = 67;
                  break;

                case 62:
                  console.log("Getting existing product fulfillment version record.");
                  _context27.next = 65;
                  return this.context.productFulfillmentVersion.findByCampaignId(t);

                case 65:
                  _n6 = _context27.sent;
                  _n6 ? (console.log("Existing version retreived. Incrementing version."), _e7 = _n6 && _n6.version + 1) : (console.log("Failed to find existing product fulfillment version. Defaulting to 1."), _e7 = 1);

                case 67:
                  _n5 = {
                    opportunity_id: this.productFulfillment.opportunity_id,
                    item_id: this.productFulfillment.item_id,
                    campaign_id: l,
                    version: _e7
                  };
                  console.log("Creating new product fulfillment version record.");
                  _context27.next = 71;
                  return this.context.productFulfillmentVersion.insert(_n5);

                case 71:
                  c.data.version = _e7;
                  _context27.next = 78;
                  break;

                case 74:
                  _context27.prev = 74;
                  _context27.t3 = _context27["catch"](54);
                  _e8 = "Failed to create new product fulfillment version record.";
                  return _context27.abrupt("return", (console.log(_e8), console.log(_context27.t3), c.errors.push(_e8), c.statusCode = 500, c));

                case 78:
                  return _context27.abrupt("return", (console.log("Successfully created new campaign and configuration records."), c.data.campaignId = l, c));

                case 79:
                case "end":
                  return _context27.stop();
              }
            }
          }, _callee27, this, [[3, 10], [15, 49], [54, 74]]);
        }));

        function createNewRecords(_x45, _x46, _x47, _x48, _x49, _x50, _x51) {
          return _createNewRecords.apply(this, arguments);
        }

        return createNewRecords;
      }()
    }, {
      key: "updateExistingRecords",
      value: function () {
        var _updateExistingRecords = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee28(t, e, n, o, i) {
          var s, _e9;

          return _regeneratorRuntime.wrap(function _callee28$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  s = Object(a.makeEmptyResponseInfo)();
                  console.log("Begin updating existing campaign records.");
                  _context28.prev = 2;
                  n.end_date = t;
                  o.end_date = t;
                  i && (i.end_date = t);
                  n.status_id = e;
                  console.log("amended existing thomas campaign with new end date", n);
                  _context28.next = 10;
                  return this.context.thomasCampaign.update(n);

                case 10:
                  _context28.next = 12;
                  return this.context.p3Campaign.update(o);

                case 12:
                  _context28.t0 = i;

                  if (!_context28.t0) {
                    _context28.next = 16;
                    break;
                  }

                  _context28.next = 16;
                  return this.context.p3Configuration.update(i);

                case 16:
                  _context28.next = 22;
                  break;

                case 18:
                  _context28.prev = 18;
                  _context28.t1 = _context28["catch"](2);
                  _e9 = "Failed to update existing campaign records.";
                  return _context28.abrupt("return", (console.log(_e9), console.log(_context28.t1), s.errors.push(_e9), s.statusCode = 500, s));

                case 22:
                  return _context28.abrupt("return", (console.log("Successfully updated existing campaign records."), s));

                case 23:
                case "end":
                  return _context28.stop();
              }
            }
          }, _callee28, this, [[2, 18]]);
        }));

        function updateExistingRecords(_x52, _x53, _x54, _x55, _x56) {
          return _updateExistingRecords.apply(this, arguments);
        }

        return updateExistingRecords;
      }()
    }], [{
      key: "campaignIsPublished",
      value: function campaignIsPublished(t) {
        var e = t === a.CONSTANTS.CAMPAIGN_STATUS.PUBLISHED || t === a.CONSTANTS.CAMPAIGN_STATUS.EDIT_NOT_PUBLISHED || t === a.CONSTANTS.CAMPAIGN_STATUS.OPTIMIZE_IN_PROGRESS;
        return console.log("Existing campaign is in status: ", t), console.log("Existing campaign is in published state: ", e), e;
      }
    }]);

    return nt;
  }();

  var ot =
  /*#__PURE__*/
  function (_nt) {
    _inherits(ot, _nt);

    function ot() {
      _classCallCheck(this, ot);

      return _possibleConstructorReturn(this, _getPrototypeOf(ot).apply(this, arguments));
    }

    _createClass(ot, [{
      key: "amend",
      value: function () {
        var _amend = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee29(t, e) {
          var n, o, i, r, _n$data, _e10, _c2, _l2, _u, _g, _p, _m, _h, _2;

          return _regeneratorRuntime.wrap(function _callee29$(_context29) {
            while (1) {
              switch (_context29.prev = _context29.next) {
                case 0:
                  n = Object(a.makeEmptyResponseInfo)();
                  console.log("Begin creating amendment.");
                  o = t.sourceCampaignId, i = t.startDate, r = t.endDate;
                  _context29.prev = 3;
                  _context29.next = 6;
                  return this.canAmendCampaign(o, i, e);

                case 6:
                  _context29.t0 = (n = _context29.sent).statusCode;

                  if (!(200 !== _context29.t0)) {
                    _context29.next = 9;
                    break;
                  }

                  return _context29.abrupt("return", n);

                case 9:
                  _context29.next = 14;
                  break;

                case 11:
                  _context29.prev = 11;
                  _context29.t1 = _context29["catch"](3);
                  throw console.log("Failed to validate campaign for amendment."), _context29.t1;

                case 14:
                  _context29.prev = 14;
                  _context29.next = 17;
                  return this.createNewFulfillment(t);

                case 17:
                  _context29.t2 = (n = _context29.sent).statusCode;

                  if (!(200 !== _context29.t2)) {
                    _context29.next = 20;
                    break;
                  }

                  return _context29.abrupt("return", n);

                case 20:
                  console.log("pre-set responseInfo.data.productFulfillment: ", Object(M.inspect)(n.data.productFulfillment, !1, 10));
                  _context29.next = 23;
                  return this.setProductFulfillment(_objectSpread({}, n.data.productFulfillment));

                case 23:
                  _context29.next = 25;
                  return this.getExistingCampaignData(o);

                case 25:
                  _context29.t3 = (n = _context29.sent).statusCode;

                  if (!(200 !== _context29.t3)) {
                    _context29.next = 28;
                    break;
                  }

                  return _context29.abrupt("return", n);

                case 28:
                  _n$data = n.data, _e10 = _n$data.existingThomasCampaign, _c2 = _n$data.existingP3Campaign, _l2 = _n$data.existingP3Configuration, _u = _n$data.existingAdvertiser, _g = s(a.ProductFulfillmentOrderTypes.AMENDMENT, _u.name, t.quantity, a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS);
                  _context29.next = 31;
                  return this.createNewRecords(o, i, r, _g, a.CONSTANTS.CAMPAIGN_STATUS.NEW, t.quantity, 1);

                case 31:
                  _context29.t4 = (n = _context29.sent).statusCode;

                  if (!(200 !== _context29.t4)) {
                    _context29.next = 34;
                    break;
                  }

                  return _context29.abrupt("return", n);

                case 34:
                  _p = n.data.campaignId, _m = n.data.version, _h = ot.calculateNewEndDate(i, _e10.start_date);

                  _2 = function (t) {
                    var e = d()();
                    return d()(t).isAfter(e) && d()(e).isSameOrBefore(f(t)) ? a.CONSTANTS.CAMPAIGN_STATUS.AMENDED_BEFORE_START : a.CONSTANTS.CAMPAIGN_STATUS.AMENDED;
                  }(_e10.start_date);

                  d()(_e10.start_date).isSameOrAfter(i) && (_2 = a.CONSTANTS.CAMPAIGN_STATUS.CANCELED);
                  _context29.next = 39;
                  return this.updateExistingRecords(_h, _2, _e10, _c2, _l2);

                case 39:
                  _context29.t5 = (n = _context29.sent).statusCode;

                  if (!(200 !== _context29.t5)) {
                    _context29.next = 42;
                    break;
                  }

                  return _context29.abrupt("return", n);

                case 42:
                  n.data.campaignId = _p, n.data.productFulfillment = this.productFulfillment, n.data.version = _m;
                  _context29.next = 48;
                  break;

                case 45:
                  _context29.prev = 45;
                  _context29.t6 = _context29["catch"](14);
                  throw console.log("Failed to amend campaign."), _context29.t6;

                case 48:
                  return _context29.abrupt("return", (console.log("Successfully created amendment."), n));

                case 49:
                case "end":
                  return _context29.stop();
              }
            }
          }, _callee29, this, [[3, 11], [14, 45]]);
        }));

        function amend(_x57, _x58) {
          return _amend.apply(this, arguments);
        }

        return amend;
      }()
    }, {
      key: "canAmendCampaign",
      value: function () {
        var _canAmendCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee30(t, e, n) {
          var o, _t8, i, _e11, _e12, s;

          return _regeneratorRuntime.wrap(function _callee30$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  o = Object(a.makeEmptyResponseInfo)();

                  if (!(console.log("Validating that campaign is ready to be amended."), !t)) {
                    _context30.next = 4;
                    break;
                  }

                  _t8 = "CampaignId is required for amendment.";
                  return _context30.abrupt("return", (console.log(_t8), o.errors.push(_t8), o.statusCode = 400, console.log("canAmendCampaign responseInfo: ", Object(M.inspect)(o, !1, 4)), o));

                case 4:
                  _context30.prev = 4;
                  console.log("Fetching productFulfillment and thomasCampaign for campaignId: ".concat(t));
                  _context30.next = 8;
                  return this.getProductFulfillment(t);

                case 8:
                  i = _context30.sent;
                  _context30.next = 11;
                  return this.getThomasCampaign(t);

                case 11:
                  this.thomasCampaign = _context30.sent;

                  if (i) {
                    _context30.next = 15;
                    break;
                  }

                  _e11 = "Failed to find product fulfillment record for campaignId: ".concat(t);
                  return _context30.abrupt("return", (console.log(_e11), o.statusCode = 400, o.errors.push(_e11), o));

                case 15:
                  if (this.thomasCampaign) {
                    _context30.next = 18;
                    break;
                  }

                  _e12 = "Failed to find thomas campagin record for campaignId: ".concat(t);
                  return _context30.abrupt("return", (console.log(_e12), o.statusCode = 400, o.errors.push(_e12), o));

                case 18:
                  _context30.next = 23;
                  break;

                case 20:
                  _context30.prev = 20;
                  _context30.t0 = _context30["catch"](4);
                  return _context30.abrupt("return", (console.log("Failed to get product fulfillment."), console.log(_context30.t0), o.statusCode = 500, o));

                case 23:
                  console.log("Successfully fetched productFulfillment and thomasCampaign for on Amender campaignId: ".concat(t)), console.log("Validating dates. new startDate: ".concat(e));
                  s = ot.validateStartDate(e, this.thomasCampaign.start_date, this.thomasCampaign.end_date);
                  return _context30.abrupt("return", s.length > 0 ? (console.log("There were date errors:\n", s.join(" ")), o.errors = s, o.statusCode = 400, o) : (console.log("Successfully validated dates"), console.log("Validated campaign is ready to be amended."), o));

                case 26:
                case "end":
                  return _context30.stop();
              }
            }
          }, _callee30, this, [[4, 20]]);
        }));

        function canAmendCampaign(_x59, _x60, _x61) {
          return _canAmendCampaign.apply(this, arguments);
        }

        return canAmendCampaign;
      }()
    }], [{
      key: "calculateNewEndDate",
      value: function calculateNewEndDate(t, e) {
        var n = d()(t).add(-1, "day").startOf("day").format("YYYY-MM-DD hh:mm:ss");
        return console.log(" new End Date: ", n), n;
      }
    }, {
      key: "validateStartDate",
      value: function validateStartDate(t, e, n) {
        var o = d()();
        return console.log("today: ", o), console.log("startDate: ", d()(t)), [];
      }
    }]);

    return ot;
  }(nt);

  var at = ot;

  var it =
  /*#__PURE__*/
  function (_nt2) {
    _inherits(it, _nt2);

    function it() {
      _classCallCheck(this, it);

      return _possibleConstructorReturn(this, _getPrototypeOf(it).apply(this, arguments));
    }

    _createClass(it, [{
      key: "optimize",
      value: function () {
        var _optimize = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee31(t, e) {
          var n, _n$data2, _o7, _i3, _r2, _c3, _l3, _d2, _u2, _g2, _p2;

          return _regeneratorRuntime.wrap(function _callee31$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  n = Object(a.makeEmptyResponseInfo)();
                  console.log("Begin creating optimization.");
                  _context31.prev = 2;
                  _context31.next = 5;
                  return this.canOptimizeCampaign(t, e);

                case 5:
                  _context31.t0 = (n = _context31.sent).statusCode;

                  if (!(200 !== _context31.t0)) {
                    _context31.next = 8;
                    break;
                  }

                  return _context31.abrupt("return", n);

                case 8:
                  _context31.next = 13;
                  break;

                case 10:
                  _context31.prev = 10;
                  _context31.t1 = _context31["catch"](2);
                  throw console.log("Failed to validate campaign for optimization."), _context31.t1;

                case 13:
                  _context31.prev = 13;
                  _context31.next = 16;
                  return this.getExistingCampaignData(t);

                case 16:
                  _context31.t2 = (n = _context31.sent).statusCode;

                  if (!(200 !== _context31.t2)) {
                    _context31.next = 19;
                    break;
                  }

                  return _context31.abrupt("return", n);

                case 19:
                  _n$data2 = n.data, _o7 = _n$data2.existingEndDate, _i3 = _n$data2.existingThomasCampaign, _r2 = _n$data2.existingP3Campaign, _c3 = _n$data2.existingP3Configuration, _l3 = _n$data2.existingAdvertiser, _d2 = s(a.ProductFulfillmentOrderTypes.OPTIMIZATION, _l3.name, _r2.entitled_rank_points, a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS);
                  _context31.next = 22;
                  return this.createNewRecords(t, e, _o7, _d2, a.CONSTANTS.CAMPAIGN_STATUS.OPTIMIZE_NEW);

                case 22:
                  _context31.t3 = (n = _context31.sent).statusCode;

                  if (!(200 !== _context31.t3)) {
                    _context31.next = 25;
                    break;
                  }

                  return _context31.abrupt("return", n);

                case 25:
                  _u2 = n.data.campaignId, _g2 = n.data.version, _p2 = it.calculateNewEndDate(e);
                  _context31.next = 28;
                  return this.updateExistingRecords(_p2, a.CONSTANTS.CAMPAIGN_STATUS.OPTIMIZE_IN_PROGRESS, _i3, _r2, _c3);

                case 28:
                  _context31.t4 = (n = _context31.sent).statusCode;

                  if (!(200 !== _context31.t4)) {
                    _context31.next = 31;
                    break;
                  }

                  return _context31.abrupt("return", n);

                case 31:
                  n.data.campaignId = _u2, n.data.productFulfillment = this.productFulfillment, n.data.version = _g2;
                  _context31.next = 37;
                  break;

                case 34:
                  _context31.prev = 34;
                  _context31.t5 = _context31["catch"](13);
                  throw console.log("Failed to optimize campaign."), _context31.t5;

                case 37:
                  return _context31.abrupt("return", (console.log("Successfully created optimization."), n));

                case 38:
                case "end":
                  return _context31.stop();
              }
            }
          }, _callee31, this, [[2, 10], [13, 34]]);
        }));

        function optimize(_x62, _x63) {
          return _optimize.apply(this, arguments);
        }

        return optimize;
      }()
    }, {
      key: "canOptimizeCampaign",
      value: function () {
        var _canOptimizeCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee32(t, e) {
          var n, _t9, o, _e13, _e14, _t10, i;

          return _regeneratorRuntime.wrap(function _callee32$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  n = Object(a.makeEmptyResponseInfo)();

                  if (!(console.log("Validating that campaign is ready to be optimized."), !t)) {
                    _context32.next = 4;
                    break;
                  }

                  _t9 = "CampaignId is required for optimization.";
                  return _context32.abrupt("return", (console.log(_t9), n.errors.push(_t9), n.statusCode = 400, console.log("canOptimizeCampaign responseInfo: ", Object(M.inspect)(n, !1, 4)), n));

                case 4:
                  _context32.prev = 4;
                  console.log("Fetching productFulfillment and thomasCampaign for campaignId: ".concat(t));
                  _context32.next = 8;
                  return this.getProductFulfillment(t);

                case 8:
                  o = _context32.sent;
                  _context32.next = 11;
                  return this.getThomasCampaign(t);

                case 11:
                  this.thomasCampaign = _context32.sent;

                  if (o) {
                    _context32.next = 15;
                    break;
                  }

                  _e13 = "Failed to find product fulfillment record for campaignId: ".concat(t);
                  return _context32.abrupt("return", (console.log(_e13), n.statusCode = 400, n.errors.push(_e13), n));

                case 15:
                  if (this.thomasCampaign) {
                    _context32.next = 18;
                    break;
                  }

                  _e14 = "Failed to find thomas campagin record for campaignId: ".concat(t);
                  return _context32.abrupt("return", (console.log(_e14), n.statusCode = 400, n.errors.push(_e14), n));

                case 18:
                  _context32.next = 23;
                  break;

                case 20:
                  _context32.prev = 20;
                  _context32.t0 = _context32["catch"](4);
                  return _context32.abrupt("return", (console.log("Failed to get product fulfillment."), console.log(_context32.t0), n.statusCode = 500, n));

                case 23:
                  if (!(console.log("Successfully fetched productFulfillment and thomasCampaign for on Optimizer campaignId: ".concat(t)), !E(this.thomasCampaign.status_id, this.thomasCampaign.start_date, this.thomasCampaign.end_date))) {
                    _context32.next = 26;
                    break;
                  }

                  _t10 = "Thomas campaign record is not in optimizable. Cannot optimize campaign in status: ".concat(this.thomasCampaign.status_id);
                  return _context32.abrupt("return", (console.log(_t10), n.statusCode = 400, n.errors.push(_t10), n));

                case 26:
                  console.log("Validating dates. new startDate: ".concat(e));
                  i = it.validateStartDate(e, this.thomasCampaign.start_date, this.thomasCampaign.end_date);
                  return _context32.abrupt("return", i.length > 0 ? (console.log("There were date errors:\n", i.join(" ")), n.errors = i, n.statusCode = 400, n) : (console.log("Successfully validated dates"), console.log("Validated campaign is ready to be optimized."), n));

                case 29:
                case "end":
                  return _context32.stop();
              }
            }
          }, _callee32, this, [[4, 20]]);
        }));

        function canOptimizeCampaign(_x64, _x65) {
          return _canOptimizeCampaign.apply(this, arguments);
        }

        return canOptimizeCampaign;
      }()
    }], [{
      key: "calculateNewEndDate",
      value: function calculateNewEndDate(t) {
        var e = d()(t).add(-1, "day").format("YYYY-MM-DD hh:mm:ss");
        return console.log("newEndDate: ", e), e;
      }
    }, {
      key: "validateStartDate",
      value: function validateStartDate(t, e, n) {
        var o = [],
            a = d()();
        return console.log("today: ", a), console.log("startDate: ", d()(t)), d()(t).isAfter(e) || o.push("New campaign start date must be after current campaign start date."), d()(t).isBefore(n) || o.push("New campaign start date must be before current campaign end date."), o;
      }
    }]);

    return it;
  }(nt);

  var st = it;

  var rt =
  /*#__PURE__*/
  function (_nt3) {
    _inherits(rt, _nt3);

    function rt() {
      _classCallCheck(this, rt);

      return _possibleConstructorReturn(this, _getPrototypeOf(rt).apply(this, arguments));
    }

    _createClass(rt, [{
      key: "renew",
      value: function () {
        var _renew = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee33(t) {
          var e, n, o, i, _r3, _c4, _l4;

          return _regeneratorRuntime.wrap(function _callee33$(_context33) {
            while (1) {
              switch (_context33.prev = _context33.next) {
                case 0:
                  e = Object(a.makeEmptyResponseInfo)();
                  console.log("Begin creating renewal.");
                  n = t.sourceCampaignId, o = t.startDate, i = t.endDate;
                  _context33.prev = 3;
                  _context33.next = 6;
                  return this.canRenewCampaign(n, o, i);

                case 6:
                  _context33.t0 = (e = _context33.sent).statusCode;

                  if (!(200 !== _context33.t0)) {
                    _context33.next = 9;
                    break;
                  }

                  return _context33.abrupt("return", e);

                case 9:
                  _context33.next = 14;
                  break;

                case 11:
                  _context33.prev = 11;
                  _context33.t1 = _context33["catch"](3);
                  throw console.log("Failed to validate campaign for renewal."), _context33.t1;

                case 14:
                  _context33.prev = 14;
                  _context33.next = 17;
                  return this.createNewFulfillment(t);

                case 17:
                  _context33.t2 = (e = _context33.sent).statusCode;

                  if (!(200 !== _context33.t2)) {
                    _context33.next = 20;
                    break;
                  }

                  return _context33.abrupt("return", e);

                case 20:
                  console.log("pre-set responseInfo.data.productFulfillment: ", Object(M.inspect)(e.data.productFulfillment, !1, 10));
                  _context33.next = 23;
                  return this.setProductFulfillment(_objectSpread({}, e.data.productFulfillment));

                case 23:
                  _context33.next = 25;
                  return this.context.thomasAdvertiser.get(e.data.productFulfillment.tgrams_id);

                case 25:
                  _r3 = _context33.sent;
                  _c4 = s(a.ProductFulfillmentOrderTypes.RENEWAL, _r3.name, t.quantity, a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS);
                  _context33.next = 29;
                  return this.createNewRecords(n, o, i, _c4, a.CONSTANTS.CAMPAIGN_STATUS.NEW, t.quantity, 1);

                case 29:
                  _context33.t3 = (e = _context33.sent).statusCode;

                  if (!(200 !== _context33.t3)) {
                    _context33.next = 32;
                    break;
                  }

                  return _context33.abrupt("return", e);

                case 32:
                  _l4 = e.data.campaignId;
                  e.data.campaignId = _l4, e.data.productFulfillment = this.productFulfillment;
                  _context33.next = 39;
                  break;

                case 36:
                  _context33.prev = 36;
                  _context33.t4 = _context33["catch"](14);
                  throw console.log("Failed to renew campaign."), _context33.t4;

                case 39:
                  return _context33.abrupt("return", (console.log("Successfully created renewal."), e));

                case 40:
                case "end":
                  return _context33.stop();
              }
            }
          }, _callee33, this, [[3, 11], [14, 36]]);
        }));

        function renew(_x66) {
          return _renew.apply(this, arguments);
        }

        return renew;
      }()
    }, {
      key: "canRenewCampaign",
      value: function () {
        var _canRenewCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee34(t, e, n) {
          var o, _t11, i, _e15, _e16, s, r;

          return _regeneratorRuntime.wrap(function _callee34$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  o = Object(a.makeEmptyResponseInfo)();

                  if (!(console.log("Validating that campaign is ready to be renewed."), !t)) {
                    _context34.next = 4;
                    break;
                  }

                  _t11 = "CampaignId is required for renewal.";
                  return _context34.abrupt("return", (console.log(_t11), o.errors.push(_t11), o.statusCode = 400, console.log("canRenewCampaign responseInfo: ", Object(M.inspect)(o, !1, 4)), o));

                case 4:
                  _context34.prev = 4;
                  console.log("Fetching productFulfillment and thomasCampaign for campaignId: ".concat(t));
                  _context34.next = 8;
                  return this.getProductFulfillment(t);

                case 8:
                  i = _context34.sent;
                  _context34.next = 11;
                  return this.getThomasCampaign(t);

                case 11:
                  this.thomasCampaign = _context34.sent;

                  if (i) {
                    _context34.next = 15;
                    break;
                  }

                  _e15 = "Failed to find product fulfillment record for campaignId: ".concat(t);
                  return _context34.abrupt("return", (console.log(_e15), o.statusCode = 400, o.errors.push(_e15), o));

                case 15:
                  if (this.thomasCampaign) {
                    _context34.next = 18;
                    break;
                  }

                  _e16 = "Failed to find thomas campagin record for campaignId: ".concat(t);
                  return _context34.abrupt("return", (console.log(_e16), o.statusCode = 400, o.errors.push(_e16), o));

                case 18:
                  _context34.next = 23;
                  break;

                case 20:
                  _context34.prev = 20;
                  _context34.t0 = _context34["catch"](4);
                  return _context34.abrupt("return", (console.log("Failed to get product fulfillment."), console.log(_context34.t0), o.statusCode = 500, o));

                case 23:
                  console.log("Successfully fetched productFulfillment and thomasCampaign on Renewer for campaignId: ".concat(t)), console.log("Validating dates. newStartDate: ".concat(e, " && newEndDate: ").concat(n));
                  s = [a.CONSTANTS.CAMPAIGN_STATUS.AMENDED, a.CONSTANTS.CAMPAIGN_STATUS.AMENDED_BEFORE_START, a.CONSTANTS.CAMPAIGN_STATUS.CANCELED, a.CONSTANTS.CAMPAIGN_STATUS.DELETED].includes(this.thomasCampaign.status_id), r = rt.validateDates(e, n, this.thomasCampaign.start_date, this.thomasCampaign.end_date);
                  return _context34.abrupt("return", s ? (console.log("Successfully validated Campaign Status"), console.log("Validated campaign is ready to be renewed."), o) : r.length > 0 ? (console.log("There were date errors:\n", r.join(" ")), o.errors = r, o.statusCode = 400, o) : (console.log("Successfully validated dates"), console.log("Validated campaign is ready to be renewed."), o));

                case 26:
                case "end":
                  return _context34.stop();
              }
            }
          }, _callee34, this, [[4, 20]]);
        }));

        function canRenewCampaign(_x67, _x68, _x69) {
          return _canRenewCampaign.apply(this, arguments);
        }

        return canRenewCampaign;
      }()
    }], [{
      key: "validateDates",
      value: function validateDates(t, e, n, o) {
        var a = [],
            i = d()();
        return console.log("today: ", i), console.log("startDate: ", d()(t)), d()(t).isAfter(n) || a.push("New campaign start date must be after current campaign start date."), d()(t).isAfter(o) || a.push("New campaign start date must be after current campaign end date."), d()(e).isAfter(n) || a.push("New campaign end date must be after current campaign end date."), d()(e).isAfter(o) || a.push("New campaign end date must be after current campaign end date."), a;
      }
    }]);

    return rt;
  }(nt);

  var ct = rt;

  function lt(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var dt =
  /*#__PURE__*/
  function () {
    function dt(t, e) {
      _classCallCheck(this, dt);

      lt(this, "campaignId", void 0), lt(this, "context", void 0), this.context = t, this.campaignId = e;
    }

    _createClass(dt, [{
      key: "getConfig",
      value: function () {
        var _getConfig = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee35() {
          var t, _t12, _e17;

          return _regeneratorRuntime.wrap(function _callee35$(_context35) {
            while (1) {
              switch (_context35.prev = _context35.next) {
                case 0:
                  console.log("Getting IThomasCampaign for campaignId: ", this.campaignId);
                  _context35.next = 3;
                  return this.context.thomasCampaign.get(this.campaignId);

                case 3:
                  t = _context35.sent;

                  if (!(console.log("Retrieved IThomasCampaign for campaignId: ", this.campaignId), !t)) {
                    _context35.next = 7;
                    break;
                  }

                  _t12 = "Thomas campaign does not exist for campaignId: ".concat(this.campaignId);
                  return _context35.abrupt("return", (console.log(_t12), null));

                case 7:
                  _context35.prev = 7;
                  _context35.next = 10;
                  return this.getConfigByProduct(this.campaignId, t.product_id);

                case 10:
                  _e17 = _context35.sent;
                  return _context35.abrupt("return", (console.log("Retrieved configuration: ", Object(M.inspect)(_e17, !1, 6)), _e17));

                case 14:
                  _context35.prev = 14;
                  _context35.t0 = _context35["catch"](7);
                  return _context35.abrupt("return", (console.log("Failed to retrieve configuration for campaignId: ", this.campaignId), null));

                case 17:
                case "end":
                  return _context35.stop();
              }
            }
          }, _callee35, this, [[7, 14]]);
        }));

        function getConfig() {
          return _getConfig.apply(this, arguments);
        }

        return getConfig;
      }()
    }, {
      key: "getConfigForAllocation",
      value: function () {
        var _getConfigForAllocation = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee36() {
          var t, _t13, _e18;

          return _regeneratorRuntime.wrap(function _callee36$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  console.log("Getting IThomasCampaign for campaignId for ALlocation: ", this.campaignId);
                  _context36.next = 3;
                  return this.context.thomasCampaign.get(this.campaignId);

                case 3:
                  t = _context36.sent;

                  if (!(console.log("Retrieved IThomasCampaign for campaignId: ", this.campaignId), !t)) {
                    _context36.next = 7;
                    break;
                  }

                  _t13 = "Thomas campaign does not exist for campaignId: ".concat(this.campaignId);
                  return _context36.abrupt("return", (console.log(_t13), null));

                case 7:
                  _context36.prev = 7;
                  _context36.next = 10;
                  return this.getConfigByProductForAllocation(this.campaignId, t.product_id);

                case 10:
                  _e18 = _context36.sent;
                  return _context36.abrupt("return", (console.log("Retrieved configuration: ", Object(M.inspect)(_e18, !1, 6)), _e18));

                case 14:
                  _context36.prev = 14;
                  _context36.t0 = _context36["catch"](7);
                  return _context36.abrupt("return", (console.log("Failed to retrieve configuration for campaignId: ", this.campaignId), null));

                case 17:
                case "end":
                  return _context36.stop();
              }
            }
          }, _callee36, this, [[7, 14]]);
        }));

        function getConfigForAllocation() {
          return _getConfigForAllocation.apply(this, arguments);
        }

        return getConfigForAllocation;
      }()
    }, {
      key: "getConfigByProduct",
      value: function () {
        var _getConfigByProduct = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee37(t, e) {
          return _regeneratorRuntime.wrap(function _callee37$(_context37) {
            while (1) {
              switch (_context37.prev = _context37.next) {
                case 0:
                  _context37.t0 = (console.log("Begin getting campaign module for productId: ", e), e);
                  _context37.next = _context37.t0 === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS ? 3 : _context37.t0 === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS ? 4 : 5;
                  break;

                case 3:
                  return _context37.abrupt("return", null);

                case 4:
                  return _context37.abrupt("return", this.getP3Configuration(t));

                case 5:
                  throw new Error("");

                case 6:
                case "end":
                  return _context37.stop();
              }
            }
          }, _callee37, this);
        }));

        function getConfigByProduct(_x70, _x71) {
          return _getConfigByProduct.apply(this, arguments);
        }

        return getConfigByProduct;
      }()
    }, {
      key: "getConfigByProductForAllocation",
      value: function () {
        var _getConfigByProductForAllocation = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee38(t, e) {
          return _regeneratorRuntime.wrap(function _callee38$(_context38) {
            while (1) {
              switch (_context38.prev = _context38.next) {
                case 0:
                  _context38.t0 = (console.log("Begin getting campaign module for productId: ", e), e);
                  _context38.next = _context38.t0 === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS ? 3 : _context38.t0 === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS ? 4 : 5;
                  break;

                case 3:
                  return _context38.abrupt("return", null);

                case 4:
                  return _context38.abrupt("return", this.getP3ConfigurationForAllocation(t));

                case 5:
                  throw new Error("");

                case 6:
                case "end":
                  return _context38.stop();
              }
            }
          }, _callee38, this);
        }));

        function getConfigByProductForAllocation(_x72, _x73) {
          return _getConfigByProductForAllocation.apply(this, arguments);
        }

        return getConfigByProductForAllocation;
      }()
    }, {
      key: "getConfiguration",
      value: function () {
        var _getConfiguration = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee39(t) {
          var e, n, _e19, _e20, _e21, o, _e22, a;

          return _regeneratorRuntime.wrap(function _callee39$(_context39) {
            while (1) {
              switch (_context39.prev = _context39.next) {
                case 0:
                  console.log("Getting IP3Campaign.");
                  _context39.next = 3;
                  return this.context.p3Campaign.get(t);

                case 3:
                  e = _context39.sent;
                  _context39.next = 6;
                  return this.context.thomasCampaign.get(t);

                case 6:
                  n = _context39.sent;

                  if (e) {
                    _context39.next = 10;
                    break;
                  }

                  _e19 = "Points Campaign module does not exist for campaignId: ".concat(t);
                  throw console.log(_e19), new Error(_e19);

                case 10:
                  if (n) {
                    _context39.next = 13;
                    break;
                  }

                  _e20 = "Thomas Campaign  does not exist for campaignId: ".concat(t);
                  throw console.log(_e20), new Error(_e20);

                case 13:
                  if (!(console.log("Retrieved IP3Campaign."), !e.p3_configuration_id)) {
                    _context39.next = 16;
                    break;
                  }

                  _e21 = "Points Campaign module is not configured campaignId: ".concat(t);
                  throw console.log(_e21), new Error(_e21);

                case 16:
                  console.log("Getting IP3Configuration.", e.p3_configuration_id);
                  _context39.next = 19;
                  return this.context.p3Configuration.get(e.p3_configuration_id);

                case 19:
                  o = _context39.sent;

                  if (o) {
                    _context39.next = 23;
                    break;
                  }

                  _e22 = "P3 Campaign module is not configured campaignId: ".concat(t);
                  throw console.log(_e22), new Error(_e22);

                case 23:
                  console.log("configuration ", Object(M.inspect)(o, !1, 5)), console.log("Retrieved IP3Configuration."), console.log("Setting configuration dates."), o.start_date = n.start_date, o.end_date = n.end_date, console.log("Getting P3ConfigurationCategories.");
                  _context39.next = 26;
                  return this.context.p3ConfigurationCategory.findAll(o.p3_configuration_id);

                case 26:
                  a = _context39.sent;
                  console.log("Retrieved P3ConfigurationCategories.");
                  console.log("Getting P3ConfigurationRegions.");
                  _context39.t0 = o;
                  _context39.t1 = a;
                  _context39.next = 33;
                  return this.context.p3ConfigurationRegion.findAll(o.p3_configuration_id);

                case 33:
                  _context39.t2 = _context39.sent;
                  return _context39.abrupt("return", {
                    configuration: _context39.t0,
                    categories: _context39.t1,
                    regions: _context39.t2
                  });

                case 35:
                case "end":
                  return _context39.stop();
              }
            }
          }, _callee39, this);
        }));

        function getConfiguration(_x74) {
          return _getConfiguration.apply(this, arguments);
        }

        return getConfiguration;
      }()
    }, {
      key: "getP3ConfigurationForAllocation",
      value: function () {
        var _getP3ConfigurationForAllocation = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee40(t) {
          var _ref9, e, n, o;

          return _regeneratorRuntime.wrap(function _callee40$(_context40) {
            while (1) {
              switch (_context40.prev = _context40.next) {
                case 0:
                  _context40.next = 2;
                  return this.getConfiguration(t);

                case 2:
                  _ref9 = _context40.sent;
                  e = _ref9.configuration;
                  n = _ref9.categories;
                  o = _ref9.regions;
                  return _context40.abrupt("return", {
                    configuration: e,
                    categories: n,
                    regions: o
                  });

                case 7:
                case "end":
                  return _context40.stop();
              }
            }
          }, _callee40, this);
        }));

        function getP3ConfigurationForAllocation(_x75) {
          return _getP3ConfigurationForAllocation.apply(this, arguments);
        }

        return getP3ConfigurationForAllocation;
      }()
    }, {
      key: "getP3Configuration",
      value: function () {
        var _getP3Configuration = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee41(t) {
          var _ref10, e, n, o, a, _e23, i;

          return _regeneratorRuntime.wrap(function _callee41$(_context41) {
            while (1) {
              switch (_context41.prev = _context41.next) {
                case 0:
                  _context41.next = 2;
                  return this.getConfiguration(t);

                case 2:
                  _ref10 = _context41.sent;
                  e = _ref10.configuration;
                  n = _ref10.categories;
                  o = _ref10.regions;
                  _context41.next = 8;
                  return this.context.p3Campaign.get(t);

                case 8:
                  a = _context41.sent;

                  if (a) {
                    _context41.next = 12;
                    break;
                  }

                  _e23 = "Points Campaign module does not exist for campaignId: ".concat(t);
                  throw console.log(_e23), new Error(_e23);

                case 12:
                  i = y(e, a) && O(n, o, a) && N(n, o);

                  if (!(console.log("configurationIsValid: ", i), !i)) {
                    _context41.next = 15;
                    break;
                  }

                  throw new Error("Configuration is not valid.");

                case 15:
                  return _context41.abrupt("return", {
                    configuration: e,
                    categories: n,
                    regions: o
                  });

                case 16:
                case "end":
                  return _context41.stop();
              }
            }
          }, _callee41, this);
        }));

        function getP3Configuration(_x76) {
          return _getP3Configuration.apply(this, arguments);
        }

        return getP3Configuration;
      }()
    }]);

    return dt;
  }(),
      ut = n(6),
      gt = n.n(ut);

  function pt(t) {
    var e = process.env[t];
    if ("string" != typeof e && "number" != typeof e && "boolean" != typeof e) throw new TypeError("".concat(t, " env var is not defined"));
    return e;
  }

  function mt(t) {
    var e = pt(t);
    if ("string" != typeof e) throw new TypeError("".concat(t, " env var is not defined as type string"));
    return e;
  }

  function ft(_x77, _x78) {
    return _ft.apply(this, arguments);
  }

  function _ft() {
    _ft = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee88(t, e) {
      var n, o, i, _e36, _e37, _t46, _t47;

      return _regeneratorRuntime.wrap(function _callee88$(_context88) {
        while (1) {
          switch (_context88.prev = _context88.next) {
            case 0:
              n = a.ResponseInfo.makeEmptyResponseInfo();
              console.log("Begin processing publish campaign request."), console.log("Fetching product fulfillment...");
              _context88.prev = 2;
              _context88.next = 5;
              return e.productFulfillment.findByCampaignId(t);

            case 5:
              o = _context88.sent;
              _context88.next = 8;
              return e.thomasCampaign.get(t);

            case 8:
              i = _context88.sent;
              _context88.next = 14;
              break;

            case 11:
              _context88.prev = 11;
              _context88.t0 = _context88["catch"](2);
              return _context88.abrupt("return", (console.log("Failed to get product fulfillment."), console.log(_context88.t0), n.addError(500, _context88.t0), n));

            case 14:
              if (o) {
                _context88.next = 17;
                break;
              }

              _e36 = "No product fulfillment exists for campaignId: ".concat(t);
              return _context88.abrupt("return", (console.log(_e36), n.addError(404, _e36), n));

            case 17:
              if (i) {
                _context88.next = 20;
                break;
              }

              _e37 = "No product thomasCampaign exists for campaignId: ".concat(t);
              return _context88.abrupt("return", (console.log(_e37), n.addError(404, _e37), n));

            case 20:
              if (![a.CONSTANTS.CAMPAIGN_STATUS.COMPLETED, a.CONSTANTS.CAMPAIGN_STATUS.OPTIMIZE_IN_PROGRESS, a.CONSTANTS.CAMPAIGN_STATUS.OPTIMIZED, a.CONSTANTS.CAMPAIGN_STATUS.AMENDED, a.CONSTANTS.CAMPAIGN_STATUS.AMENDED_BEFORE_START, a.CONSTANTS.CAMPAIGN_STATUS.CANCELED].includes(i.status_id)) {
                _context88.next = 23;
                break;
              }

              _t46 = "campaign already published status: ".concat(i.status_id);
              return _context88.abrupt("return", (console.log(_t46), n.addError(400, _t46), n));

            case 23:
              _context88.prev = 23;
              _context88.next = 26;
              return function () {
                var _ref16 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee87(t, e, n) {
                  var o, a, i;
                  return _regeneratorRuntime.wrap(function _callee87$(_context87) {
                    while (1) {
                      switch (_context87.prev = _context87.next) {
                        case 0:
                          console.log({
                            message: "Begin sending pubilsh request to Neptune",
                            opportunityId: t,
                            tgramsId: e,
                            orderType: n
                          });
                          o = "https://".concat(mt("NEPTUNE_PRIVATE_API_ENDPOINT"), "/api/orders/").concat(t, "/publish"), a = {
                            tgramsId: e,
                            orderType: n
                          };
                          console.log({
                            message: "Invoking Neptune API publish",
                            url: o,
                            postModel: a
                          });
                          _context87.next = 5;
                          return gt()(o, {
                            method: "post",
                            headers: {
                              "Content-type": "application/json"
                            },
                            body: JSON.stringify(a)
                          });

                        case 5:
                          i = _context87.sent;

                          if (!(console.log({
                            message: "Response received",
                            statusCode: i.status,
                            statusText: i.statusText
                          }), !i.ok)) {
                            _context87.next = 8;
                            break;
                          }

                          throw console.log({
                            message: "Http request failed",
                            url: o,
                            postModel: a
                          }), new Error("Failed to send Publish request ".concat(i.status, " - ").concat(i.statusText));

                        case 8:
                          return _context87.abrupt("return", {
                            statusCode: i.status,
                            statusText: i.statusText
                          });

                        case 9:
                        case "end":
                          return _context87.stop();
                      }
                    }
                  }, _callee87);
                }));

                return function (_x184, _x185, _x186) {
                  return _ref16.apply(this, arguments);
                };
              }()(o.opportunity_id, o.tgrams_id);

            case 26:
              _t47 = _context88.sent;

              if (!(!_t47 || 200 !== _t47.statusCode)) {
                _context88.next = 29;
                break;
              }

              throw new Error("Neptune publish response is not ok");

            case 29:
              i.status_id = a.CONSTANTS.CAMPAIGN_STATUS.PUBLISH_IN_PROGRESS;
              _context88.next = 32;
              return e.thomasCampaign.update(i);

            case 32:
              _context88.next = 37;
              break;

            case 34:
              _context88.prev = 34;
              _context88.t1 = _context88["catch"](23);
              return _context88.abrupt("return", (console.log("Failed to invoke Neptune publish request."), console.log(_context88.t1), n.addError(500, _context88.t1), n));

            case 37:
              return _context88.abrupt("return", (console.log("Finish processing publish campaign request."), n));

            case 38:
            case "end":
              return _context88.stop();
          }
        }
      }, _callee88, null, [[2, 11], [23, 34]]);
    }));
    return _ft.apply(this, arguments);
  }

  var ht =
  /*#__PURE__*/
  function () {
    function ht(_ref11) {
      var t = _ref11.url;

      _classCallCheck(this, ht);

      var e, n, o;
      o = void 0, (n = "sqs") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.sqs = new z(t);
    }

    _createClass(ht, [{
      key: "publish",
      value: function publish(t, e) {
        var n = {
          CampaignId: {
            DataType: "String",
            StringValue: e
          }
        };
        return console.log("publishData: ", Object(M.inspect)(t)), this.sqs.sendMessage(t, {
          attributes: n
        }).catch(function (t) {
          return ht.localErrorHandler(t, "SQSClient", "sendMessage");
        });
      }
    }], [{
      key: "localErrorHandler",
      value: function localErrorHandler(t, e, n) {
        console.log("".concat(e, ".").concat(n, " failed.")), console.log(Object(M.inspect)(t, !1, 4));
      }
    }]);

    return ht;
  }();

  var _t = ht;

  var Ct =
  /*#__PURE__*/
  function () {
    function Ct(t) {
      _classCallCheck(this, Ct);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Ct, [{
      key: "fulfillRequest",
      value: function () {
        var _fulfillRequest = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee42(t) {
          var e, _n7, _o8, _n8;

          return _regeneratorRuntime.wrap(function _callee42$(_context42) {
            while (1) {
              switch (_context42.prev = _context42.next) {
                case 0:
                  console.log("Begin fulfilling amend product request.");
                  e = a.ResponseInfo.makeEmptyResponseInfo();
                  _context42.prev = 2;
                  _n7 = "Points - Amendment of Active - ".concat(t.companyName), _o8 = new at(this.context);
                  _context42.next = 6;
                  return _o8.amend(t, _n7);

                case 6:
                  _context42.t0 = (e = _context42.sent).statusCode;

                  if (!(200 !== _context42.t0)) {
                    _context42.next = 9;
                    break;
                  }

                  return _context42.abrupt("return", e);

                case 9:
                  _context42.next = 15;
                  break;

                case 11:
                  _context42.prev = 11;
                  _context42.t1 = _context42["catch"](2);
                  _n8 = "Failed to amend campaign.";
                  return _context42.abrupt("return", (console.log(_n8), console.log(_context42.t1), e.statusCode = 500, e.errors.push(_n8), e));

                case 15:
                  return _context42.abrupt("return", (console.log("Succesfully completed amend product request."), e));

                case 16:
                case "end":
                  return _context42.stop();
              }
            }
          }, _callee42, this, [[2, 11]]);
        }));

        function fulfillRequest(_x79) {
          return _fulfillRequest.apply(this, arguments);
        }

        return fulfillRequest;
      }()
    }]);

    return Ct;
  }();

  var At =
  /*#__PURE__*/
  function () {
    function At(t) {
      _classCallCheck(this, At);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(At, [{
      key: "fulfillRequest",
      value: function () {
        var _fulfillRequest2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee43(t) {
          var e, _n9, _n10;

          return _regeneratorRuntime.wrap(function _callee43$(_context43) {
            while (1) {
              switch (_context43.prev = _context43.next) {
                case 0:
                  console.log("Begin fulfilling renewal product request.");
                  e = a.ResponseInfo.makeEmptyResponseInfo();
                  _context43.prev = 2;
                  _n9 = new ct(this.context);
                  _context43.next = 6;
                  return _n9.renew(t);

                case 6:
                  _context43.t0 = (e = _context43.sent).statusCode;

                  if (!(200 !== _context43.t0)) {
                    _context43.next = 9;
                    break;
                  }

                  return _context43.abrupt("return", e);

                case 9:
                  _context43.next = 15;
                  break;

                case 11:
                  _context43.prev = 11;
                  _context43.t1 = _context43["catch"](2);
                  _n10 = "Failed to renew campaign.";
                  return _context43.abrupt("return", (console.log(_n10), console.log(_context43.t1), e.statusCode = 500, e.errors.push(_n10), e));

                case 15:
                  return _context43.abrupt("return", (console.log("Succesfully completed renew product request."), e));

                case 16:
                case "end":
                  return _context43.stop();
              }
            }
          }, _callee43, this, [[2, 11]]);
        }));

        function fulfillRequest(_x80) {
          return _fulfillRequest2.apply(this, arguments);
        }

        return fulfillRequest;
      }()
    }]);

    return At;
  }(),
      yt = n(8),
      Tt = n.n(yt);

  var St =
  /*#__PURE__*/
  function () {
    function St(_ref12) {
      var t = _ref12.url;

      _classCallCheck(this, St);

      var e, n, o;
      o = void 0, (n = "sqs") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.sqs = new z(t);
    }

    _createClass(St, [{
      key: "push",
      value: function push(t) {
        var e = {
          CampaignId: {
            DataType: "String",
            StringValue: t.campaignId
          }
        };
        return console.log("publishData: ", Object(M.inspect)(t)), this.sqs.sendMessage(t, {
          attributes: e
        }).catch(function (t) {
          return St.localErrorHandler(t, "AutoAllcoationSqs", "sendMessage");
        });
      }
    }], [{
      key: "localErrorHandler",
      value: function localErrorHandler(t, e, n) {
        console.log("".concat(e, ".").concat(n, " failed.")), console.log(Object(M.inspect)(t, !1, 4));
      }
    }]);

    return St;
  }();

  var wt = St;

  var Ot =
  /*#__PURE__*/
  function () {
    function Ot(t) {
      _classCallCheck(this, Ot);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Ot, [{
      key: "initialAutoAllocation",
      value: function () {
        var _initialAutoAllocation = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee44(t) {
          var e, n, o, _t14, i, _t15, _t16, _o9, _i4;

          return _regeneratorRuntime.wrap(function _callee44$(_context44) {
            while (1) {
              switch (_context44.prev = _context44.next) {
                case 0:
                  console.log("Begin initialAutoAllocation.", t);
                  e = Object(a.makeEmptyResponseInfo)();
                  _context44.next = 4;
                  return this.context.p3Campaign.get(t);

                case 4:
                  n = _context44.sent;
                  o = !1;

                  if (n) {
                    _context44.next = 9;
                    break;
                  }

                  _t14 = "Failed to get existing autoAllocate p3 campaign from db.";
                  return _context44.abrupt("return", (e.errors.push(_t14), e.statusCode = 500, e));

                case 9:
                  _context44.next = 11;
                  return this.context.thomasCampaign.get(t);

                case 11:
                  i = _context44.sent;

                  if (i) {
                    _context44.next = 15;
                    break;
                  }

                  _t15 = "Failed to get existing autoAllocate campaign from db.";
                  return _context44.abrupt("return", (e.errors.push(_t15), e.statusCode = 500, e));

                case 15:
                  if (!(i.product_id !== a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS)) {
                    _context44.next = 18;
                    break;
                  }

                  _t16 = "Failed to get new campaign  for not Points campaign.";
                  return _context44.abrupt("return", (e.errors.push(_t16), e.statusCode = 500, e));

                case 18:
                  n.tgrams_id = i.tgrams_id;
                  _context44.t0 = "" === n.tgrams_id;

                  if (!_context44.t0) {
                    _context44.next = 24;
                    break;
                  }

                  n.tgrams_id = i.tgrams_id;
                  _context44.next = 24;
                  return this.context.p3Campaign.update(n);

                case 24:
                  _context44.next = 26;
                  return this.pickOldCampaignByVersion(n);

                case 26:
                  _context44.t1 = o = _context44.sent;

                  if (_context44.t1) {
                    _context44.next = 31;
                    break;
                  }

                  _context44.next = 30;
                  return this.pickConfigFromTemplates(n, !0);

                case 30:
                  o = _context44.sent;

                case 31:
                  _context44.t2 = o;

                  if (_context44.t2) {
                    _context44.next = 36;
                    break;
                  }

                  _context44.next = 35;
                  return this.pickOldUnrelatedCampaign(n);

                case 35:
                  o = _context44.sent;

                case 36:
                  _context44.t3 = o;

                  if (_context44.t3) {
                    _context44.next = 41;
                    break;
                  }

                  _context44.next = 40;
                  return this.pickConfigFromTemplates(n, !1);

                case 40:
                  o = _context44.sent;

                case 41:
                  if (!o) {
                    _context44.next = 48;
                    break;
                  }

                  console.log("END initial AutoAllocation. with assign new configuration", t);
                  _o9 = new dt(this.context, t);
                  _context44.next = 46;
                  return _o9.getConfigForAllocation();

                case 46:
                  _i4 = _context44.sent;
                  return _context44.abrupt("return", (console.log("auto allocation find configuration", Object(M.inspect)(_i4, !1, 5)), _i4 && y(_i4.configuration, n) ? (console.log("find config and match points end auto new allocation"), e.data.configResponse = a.CONSTANTS.AUTOALLOCATION_STATUS.CONFIGURATION_BALANCED) : e.data.configResponse = a.CONSTANTS.AUTOALLOCATION_STATUS.NO_BALANCED_CONFIGURATION, e.statusCode = 200, e));

                case 48:
                  return _context44.abrupt("return", (console.log("END initialAutoAllocation. with no assigned configuration", t), e.data.configResponse = a.CONSTANTS.AUTOALLOCATION_STATUS.NO_CONFIGURATION, e.statusCode = 200, e));

                case 49:
                case "end":
                  return _context44.stop();
              }
            }
          }, _callee44, this);
        }));

        function initialAutoAllocation(_x81) {
          return _initialAutoAllocation.apply(this, arguments);
        }

        return initialAutoAllocation;
      }()
    }, {
      key: "pickConfigFromTemplates",
      value: function () {
        var _pickConfigFromTemplates = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee45(t, e) {
          var n, o, _e24, _a5;

          return _regeneratorRuntime.wrap(function _callee45$(_context45) {
            while (1) {
              switch (_context45.prev = _context45.next) {
                case 0:
                  n = !1;
                  console.log("pickConfigFromTemplates flow with matchPoints", e), console.log("pickConfigFromTemplates flow with tgramsId", t.tgrams_id);
                  _context45.next = 4;
                  return this.context.p3Configuration.getConfigurationForAllocation(t.tgrams_id, e ? t.entitled_rank_points : 0);

                case 4:
                  o = _context45.sent;

                  if (!o) {
                    _context45.next = 16;
                    break;
                  }

                  console.log("Found from configuration template", Object(M.inspect)(o, !1, 5));
                  _e24 = Tt()(), _a5 = new Z(this.context);
                  _context45.next = 10;
                  return _a5.duplicateConfiguration(o.p3_configuration_id, _e24, {
                    newCampaignId: t.p3_campaign_id,
                    newTgramsId: t.tgrams_id
                  });

                case 10:
                  _context45.t0 = _context45.sent;

                  if (!_context45.t0) {
                    _context45.next = 16;
                    break;
                  }

                  t.p3_configuration_id = _e24;
                  _context45.next = 15;
                  return this.context.p3Campaign.update(t);

                case 15:
                  n = !0;

                case 16:
                  return _context45.abrupt("return", n);

                case 17:
                case "end":
                  return _context45.stop();
              }
            }
          }, _callee45, this);
        }));

        function pickConfigFromTemplates(_x82, _x83) {
          return _pickConfigFromTemplates.apply(this, arguments);
        }

        return pickConfigFromTemplates;
      }()
    }, {
      key: "autoAllocation",
      value: function () {
        var _autoAllocation = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee46(t) {
          var e, _n11, _t17, _o10, _t18, _i5, _s3, _r4, _t19, _c5, _n12;

          return _regeneratorRuntime.wrap(function _callee46$(_context46) {
            while (1) {
              switch (_context46.prev = _context46.next) {
                case 0:
                  console.log("Begin fulfilling autollcoation.", t);
                  e = Object(a.makeEmptyResponseInfo)();
                  _context46.prev = 2;
                  _context46.next = 5;
                  return this.context.productFulfillment.findByCampaignId(t);

                case 5:
                  _n11 = _context46.sent;

                  if (_n11) {
                    _context46.next = 9;
                    break;
                  }

                  _t17 = "Failed to get existing autoAllocate from db.";
                  return _context46.abrupt("return", (e.errors.push(_t17), e.statusCode = 500, e));

                case 9:
                  _context46.next = 11;
                  return this.context.p3Campaign.get(t);

                case 11:
                  _o10 = _context46.sent;

                  if (!(console.log("p3 campaign", Object(M.inspect)(_o10, !1, 5)), !_o10)) {
                    _context46.next = 15;
                    break;
                  }

                  _t18 = "Failed to get existing autoAllocate campaign from db.";
                  return _context46.abrupt("return", (e.errors.push(_t18), e.statusCode = 500, e));

                case 15:
                  _context46.t0 = "" === _o10.tgrams_id;

                  if (!_context46.t0) {
                    _context46.next = 20;
                    break;
                  }

                  _o10.tgrams_id = _n11.tgrams_id;
                  _context46.next = 20;
                  return this.context.p3Campaign.update(_o10);

                case 20:
                  _i5 = !1;
                  _s3 = new dt(this.context, t);
                  _context46.next = 24;
                  return _s3.getConfigForAllocation();

                case 24:
                  _r4 = _context46.sent;

                  if (!(console.log("auto allocation find configuration", Object(M.inspect)(_r4, !1, 5)), _r4 && y(_r4.configuration, _o10))) {
                    _context46.next = 27;
                    break;
                  }

                  return _context46.abrupt("return", (console.log("find config and match points end autoallocation"), e.data.configResponse = a.CONSTANTS.AUTOALLOCATION_STATUS.CONFIGURATION_BALANCED, e.statusCode = 200, e));

                case 27:
                  if (!(_r4 && !y(_r4.configuration, _o10))) {
                    _context46.next = 32;
                    break;
                  }

                  _context46.next = 30;
                  return this.balanceConfiguration(_o10);

                case 30:
                  _t19 = _context46.sent;
                  return _context46.abrupt("return", (console.log("find config and balance points end autoallocation"), e.data.configResponse = _t19, e.statusCode = 200, e));

                case 32:
                  _context46.next = 34;
                  return this.pickOldCampaignByVersion(_o10);

                case 34:
                  _context46.t1 = _i5 = _context46.sent;

                  if (_context46.t1) {
                    _context46.next = 39;
                    break;
                  }

                  _context46.next = 38;
                  return this.pickConfigFromTemplates(_o10, !0);

                case 38:
                  _i5 = _context46.sent;

                case 39:
                  _context46.t2 = _i5;

                  if (_context46.t2) {
                    _context46.next = 44;
                    break;
                  }

                  _context46.next = 43;
                  return this.pickOldUnrelatedCampaign(_o10);

                case 43:
                  _i5 = _context46.sent;

                case 44:
                  _context46.t3 = _i5;

                  if (_context46.t3) {
                    _context46.next = 49;
                    break;
                  }

                  _context46.next = 48;
                  return this.pickConfigFromTemplates(_o10, !1);

                case 48:
                  _i5 = _context46.sent;

                case 49:
                  _context46.next = 51;
                  return this.balanceConfiguration(_o10);

                case 51:
                  _c5 = _context46.sent;
                  e.data.configResponse = _c5;
                  _context46.next = 59;
                  break;

                case 55:
                  _context46.prev = 55;
                  _context46.t4 = _context46["catch"](2);
                  _n12 = "Failed to get existing autoAllocate from db.";
                  return _context46.abrupt("return", (console.log(_n12), console.log(_context46.t4), e.errors.push(_n12), e.statusCode = 500, e));

                case 59:
                  return _context46.abrupt("return", (console.log("END autoallocation", t), e.statusCode = 200, e));

                case 60:
                case "end":
                  return _context46.stop();
              }
            }
          }, _callee46, this, [[2, 55]]);
        }));

        function autoAllocation(_x84) {
          return _autoAllocation.apply(this, arguments);
        }

        return autoAllocation;
      }()
    }, {
      key: "followUpConfiguration",
      value: function () {
        var _followUpConfiguration = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee47(t, e) {
          var n, o;
          return _regeneratorRuntime.wrap(function _callee47$(_context47) {
            while (1) {
              switch (_context47.prev = _context47.next) {
                case 0:
                  n = new Z(this.context), o = Tt()();
                  _context47.t0 = !!e.p3_configuration_id;

                  if (!_context47.t0) {
                    _context47.next = 10;
                    break;
                  }

                  console.log("Duplicate Configuration", e.p3_configuration_id);
                  _context47.next = 6;
                  return n.duplicateConfiguration(e.p3_configuration_id, o, {
                    newCampaignId: t.p3_campaign_id,
                    newTgramsId: t.tgrams_id
                  });

                case 6:
                  t.p3_configuration_id = o;
                  _context47.next = 9;
                  return this.context.p3Campaign.update(t);

                case 9:
                  _context47.t0 = !0;

                case 10:
                  return _context47.abrupt("return", _context47.t0);

                case 11:
                case "end":
                  return _context47.stop();
              }
            }
          }, _callee47, this);
        }));

        function followUpConfiguration(_x85, _x86) {
          return _followUpConfiguration.apply(this, arguments);
        }

        return followUpConfiguration;
      }()
    }, {
      key: "pickOldUnrelatedCampaign",
      value: function () {
        var _pickOldUnrelatedCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee48(t) {
          var e, n, _o11;

          return _regeneratorRuntime.wrap(function _callee48$(_context48) {
            while (1) {
              switch (_context48.prev = _context48.next) {
                case 0:
                  e = !1;
                  _context48.next = 3;
                  return this.context.thomasCampaign.getCampaignForAllocation(t.tgrams_id, t.p3_campaign_id, 0);

                case 3:
                  n = _context48.sent;

                  if (!n) {
                    _context48.next = 14;
                    break;
                  }

                  _context48.next = 7;
                  return this.context.p3Campaign.get(n.campaign_id);

                case 7:
                  _o11 = _context48.sent;
                  _context48.t0 = _o11;

                  if (!_context48.t0) {
                    _context48.next = 14;
                    break;
                  }

                  console.log(" autolocation pickOldUnrelatedCampaign  found campaign from unrelated flow", Object(M.inspect)(_o11, !1, 5));
                  _context48.next = 13;
                  return this.followUpConfiguration(t, _o11);

                case 13:
                  e = _context48.sent;

                case 14:
                  return _context48.abrupt("return", e);

                case 15:
                case "end":
                  return _context48.stop();
              }
            }
          }, _callee48, this);
        }));

        function pickOldUnrelatedCampaign(_x87) {
          return _pickOldUnrelatedCampaign.apply(this, arguments);
        }

        return pickOldUnrelatedCampaign;
      }()
    }, {
      key: "pickOldCampaignByVersion",
      value: function () {
        var _pickOldCampaignByVersion = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee49(t) {
          var e, n, o, _t20, _e25, _e26;

          return _regeneratorRuntime.wrap(function _callee49$(_context49) {
            while (1) {
              switch (_context49.prev = _context49.next) {
                case 0:
                  console.log("pickOldCampaignByVersion", t.p3_campaign_id);
                  _context49.next = 3;
                  return this.context.productFulfillmentVersion.findByCampaignId(t.p3_campaign_id);

                case 3:
                  e = _context49.sent;
                  n = "", o = !1;

                  if (e) {
                    _context49.next = 7;
                    break;
                  }

                  return _context49.abrupt("return", !1);

                case 7:
                  if (!(e.version > 1)) {
                    _context49.next = 14;
                    break;
                  }

                  _context49.next = 10;
                  return this.context.productFulfillmentVersion.findByOpportunityAndVersion(e.opportunity_id, e.version - 1);

                case 10:
                  _t20 = _context49.sent;
                  _t20 && (console.log("Found campaing from old version", Object(M.inspect)(_t20, !1, 5)), n = _t20.campaign_id);
                  _context49.next = 19;
                  break;

                case 14:
                  console.log("pickOldCampaignByVersion  look unrelated old version", t.p3_campaign_id);
                  _context49.next = 17;
                  return this.context.thomasCampaign.getCampaignForAllocation(t.tgrams_id, t.p3_campaign_id, t.entitled_rank_points);

                case 17:
                  _e25 = _context49.sent;
                  _e25 && (console.log("Found campaing from last published campaign", Object(M.inspect)(_e25, !1, 5)), n = _e25.campaign_id);

                case 19:
                  if (!("" !== n)) {
                    _context49.next = 31;
                    break;
                  }

                  _context49.next = 22;
                  return this.context.p3Campaign.get(n);

                case 22:
                  _e26 = _context49.sent;
                  _context49.t0 = _e26;

                  if (!_context49.t0) {
                    _context49.next = 31;
                    break;
                  }

                  console.log("Found Configuration from version flow", Object(M.inspect)(_e26, !1, 5));
                  _context49.t1 = t.entitled_rank_points === _e26.entitled_rank_points;

                  if (!_context49.t1) {
                    _context49.next = 31;
                    break;
                  }

                  _context49.next = 30;
                  return this.followUpConfiguration(t, _e26);

                case 30:
                  o = _context49.sent;

                case 31:
                  return _context49.abrupt("return", o);

                case 32:
                case "end":
                  return _context49.stop();
              }
            }
          }, _callee49, this);
        }));

        function pickOldCampaignByVersion(_x88) {
          return _pickOldCampaignByVersion.apply(this, arguments);
        }

        return pickOldCampaignByVersion;
      }()
    }, {
      key: "setNewCampaignAlert",
      value: function () {
        var _setNewCampaignAlert = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee50(t) {
          var e, n, o, a;
          return _regeneratorRuntime.wrap(function _callee50$(_context50) {
            while (1) {
              switch (_context50.prev = _context50.next) {
                case 0:
                  e = process.env.ALLOCATE_NEW_CAMPAIGN_ALERTS_QUEUE_URL;

                  if (!("string" != typeof e)) {
                    _context50.next = 3;
                    break;
                  }

                  return _context50.abrupt("return", (console.log("missing process.env.ALLOCATE_NEW_CAMPAIGN_ALERTS_QUEUE_URL to create new campaign alert"), !1));

                case 3:
                  n = new wt({
                    url: e
                  });
                  o = {
                    campaignId: t,
                    tgramsId: "",
                    productType: "PPP"
                  };
                  _context50.next = 7;
                  return n.push(o);

                case 7:
                  a = _context50.sent;
                  return _context50.abrupt("return", (console.log("autoallocation new camapaign push alert response", a), a));

                case 9:
                case "end":
                  return _context50.stop();
              }
            }
          }, _callee50);
        }));

        function setNewCampaignAlert(_x89) {
          return _setNewCampaignAlert.apply(this, arguments);
        }

        return setNewCampaignAlert;
      }()
    }, {
      key: "sortCategories",
      value: function sortCategories(t, e) {
        return t.sort(function (t, n) {
          var o = t.national_purchased_rank_points + t.regional_purchased_rank_points,
              a = n.national_purchased_rank_points + n.regional_purchased_rank_points,
              i = t.category_name.toLowerCase(),
              s = n.category_name.toLowerCase();
          return e ? a - o == 0 ? i < s ? -1 : i > s ? 1 : 0 : a - o : o - a;
        }), console.log("autoallocation categories sorted:", t), t;
      }
    }, {
      key: "balanceConfiguration",
      value: function () {
        var _balanceConfiguration = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee51(t) {
          var e, n, o, i, s, r, c, l, d, u, g, p, _t21, m, f;

          return _regeneratorRuntime.wrap(function _callee51$(_context51) {
            while (1) {
              switch (_context51.prev = _context51.next) {
                case 0:
                  console.log("balance configuration", t.p3_campaign_id);
                  e = new dt(this.context, t.p3_campaign_id);
                  _context51.next = 4;
                  return e.getConfigForAllocation();

                case 4:
                  n = _context51.sent;

                  if (n) {
                    _context51.next = 7;
                    break;
                  }

                  return _context51.abrupt("return", a.CONSTANTS.AUTOALLOCATION_STATUS.NO_CONFIGURATION);

                case 7:
                  if (!(n && y(n.configuration, t))) {
                    _context51.next = 9;
                    break;
                  }

                  return _context51.abrupt("return", a.CONSTANTS.AUTOALLOCATION_STATUS.CONFIGURATION_BALANCED);

                case 9:
                  o = n.configuration, i = n.regions, s = n.categories, r = s.length, c = A(o), l = c < t.entitled_rank_points;
                  d = this.sortCategories(s, l), u = l ? t.entitled_rank_points - c : c - t.entitled_rank_points, g = 0, p = 0;
                  if (l) for (; u > 0;) {
                    a.CONSTANTS.EXCLUDED_HEADINGS.includes(d[g].category_id) || (d[g].national_purchased_rank_points += 1, u -= 1, (g += 1) >= r && (g = 0));
                  } else {
                    _t21 = u;

                    for (; u > 0;) {
                      if (!a.CONSTANTS.EXCLUDED_HEADINGS.includes(d[g].category_id)) {
                        d[g].national_purchased_rank_points > 1 && (d[g].national_purchased_rank_points -= 1, d[g].national_total_rank_points = 280 * d[g].national_purchased_rank_points, u -= 1, _t21 -= 1), d.find(function (t) {
                          return t.national_purchased_rank_points > 1;
                        }) || (console.log("break the loop by nothing else to remove national"), u = 0), g += 1, (p += 1) > 1e3 && (console.log("break the loop by count national"), u = 0), g >= r && (g = 0);
                      }
                    }

                    if (_t21 > 0) for (u = _t21, p = 0; u > 0;) {
                      if (!a.CONSTANTS.EXCLUDED_HEADINGS.includes(d[g].category_id)) {
                        1 === d[g].national_purchased_rank_points && d[g].regional_purchased_rank_points > 1 && (d[g].regional_purchased_rank_points -= 1, d[g].regional_total_rank_points = 280 * d[g].regional_purchased_rank_points, u -= 1, _t21 -= 1), d.find(function (t) {
                          return t.national_purchased_rank_points + t.regional_purchased_rank_points >= 2;
                        }) || (console.log("break the loop by nothing else to remove in regionals "), u = 0), g += 1, (p += 1) > 1e3 && (console.log("break the loop by count in regionals"), u = 0), g >= r && (g = 0);
                      }
                    }
                  }
                  d = d.filter(function (t) {
                    return t.national_purchased_rank_points + t.regional_purchased_rank_points >= 1;
                  });
                  m = this.context.userId, f = d.reduce(function (t, e) {
                    return t + e.national_purchased_rank_points + e.regional_purchased_rank_points;
                  }, 0);
                  o.rank_points = f;
                  o.owned_by = m;

                  if (!y(o, t)) {
                    _context51.next = 31;
                    break;
                  }

                  _context51.next = 19;
                  return this.context.p3ConfigurationCategory.deleteConfigCategories(o.p3_configuration_id);

                case 19:
                  _context51.next = 21;
                  return this.context.p3ConfigurationRegion.deleteConfigRegions(o.p3_configuration_id);

                case 21:
                  _context51.next = 23;
                  return this.context.p3ConfigurationCategory.insert(d);

                case 23:
                  _context51.next = 25;
                  return this.context.p3ConfigurationRegion.insert(i);

                case 25:
                  o.status_id = N(d, i) ? 1 : 0;
                  _context51.next = 28;
                  return this.context.p3Configuration.update(o);

                case 28:
                  _context51.t0 = a.CONSTANTS.AUTOALLOCATION_STATUS.CONFIGURATION_BALANCED;
                  _context51.next = 32;
                  break;

                case 31:
                  _context51.t0 = (console.log("configuration doesnt match: ", Object(M.inspect)(o, !1, 6)), console.log("configuration categories: ", Object(M.inspect)(d, !1, 6)), console.log("configuration regions: ", Object(M.inspect)(i, !1, 6)), a.CONSTANTS.AUTOALLOCATION_STATUS.NO_BALANCED_CONFIGURATION);

                case 32:
                  return _context51.abrupt("return", _context51.t0);

                case 33:
                case "end":
                  return _context51.stop();
              }
            }
          }, _callee51, this);
        }));

        function balanceConfiguration(_x90) {
          return _balanceConfiguration.apply(this, arguments);
        }

        return balanceConfiguration;
      }()
    }]);

    return Ot;
  }();

  var bt =
  /*#__PURE__*/
  function () {
    function bt(t) {
      _classCallCheck(this, bt);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(bt, [{
      key: "pushAllocateAlert",
      value: function () {
        var _pushAllocateAlert = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee52(t) {
          var e, n, _t22, o, _t23, i, s, r;

          return _regeneratorRuntime.wrap(function _callee52$(_context52) {
            while (1) {
              switch (_context52.prev = _context52.next) {
                case 0:
                  console.log("Begin fulfilling AllocationAlert.", t);
                  e = Object(a.makeEmptyResponseInfo)();
                  _context52.next = 4;
                  return this.context.thomasCampaign.get(t);

                case 4:
                  n = _context52.sent;

                  if (n) {
                    _context52.next = 8;
                    break;
                  }

                  _t22 = "Failed to get existing allocate alert campaign from db.";
                  return _context52.abrupt("return", (e.errors.push(_t22), e.statusCode = 500, e));

                case 8:
                  _context52.next = 10;
                  return this.context.thomasAdvertiser.get(n.tgrams_id);

                case 10:
                  o = _context52.sent;

                  if (o) {
                    _context52.next = 14;
                    break;
                  }

                  _t23 = "Failed to get existing allocate alert thomas advertiser from db.";
                  return _context52.abrupt("return", (e.errors.push(_t23), e.statusCode = 500, e));

                case 14:
                  i = {
                    message: "Company ".concat(o.name, ": ").concat(n.name, "\n      Point auto-allocation NOT possible due to lack of configuration - this campaign will NOT publish without Account Management intervention\n      "),
                    subject: "Point auto-allocation mismatch Alert: ".concat(o.name, " (").concat(n.tgrams_id, ")")
                  }, s = this.createHsTicket(i);
                  console.log("ticket", Object(M.inspect)(s, !1, 5));
                  _context52.next = 18;
                  return this.postHsTicket(s);

                case 18:
                  r = _context52.sent;
                  return _context52.abrupt("return", (console.log("Hubspot response: ", r), console.log("END AllocationAlert", t), e.statusCode = 200, e));

                case 20:
                case "end":
                  return _context52.stop();
              }
            }
          }, _callee52, this);
        }));

        function pushAllocateAlert(_x91) {
          return _pushAllocateAlert.apply(this, arguments);
        }

        return pushAllocateAlert;
      }()
    }, {
      key: "pushAllocateNewCampaignAlert",
      value: function () {
        var _pushAllocateNewCampaignAlert = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee53(t) {
          var e, n, _t24, _t25, o, _t26, i, s, r;

          return _regeneratorRuntime.wrap(function _callee53$(_context53) {
            while (1) {
              switch (_context53.prev = _context53.next) {
                case 0:
                  console.log("Begin fulfilling Allocation New Campaign Alert.", t);
                  e = Object(a.makeEmptyResponseInfo)();
                  _context53.next = 4;
                  return this.context.thomasCampaign.get(t);

                case 4:
                  n = _context53.sent;

                  if (n) {
                    _context53.next = 8;
                    break;
                  }

                  _t24 = "Failed to get existing allocate alert new campaign from db.";
                  return _context53.abrupt("return", (e.errors.push(_t24), e.statusCode = 500, e));

                case 8:
                  if (!(n.product_id !== a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS)) {
                    _context53.next = 11;
                    break;
                  }

                  _t25 = "Failed to get new campaign alert for not Points campaign.";
                  return _context53.abrupt("return", (e.errors.push(_t25), e.statusCode = 500, e));

                case 11:
                  _context53.next = 13;
                  return this.context.thomasAdvertiser.get(n.tgrams_id);

                case 13:
                  o = _context53.sent;

                  if (o) {
                    _context53.next = 17;
                    break;
                  }

                  _t26 = "Failed to get existing allocate alert new thomas advertiser from db.";
                  return _context53.abrupt("return", (e.errors.push(_t26), e.statusCode = 500, e));

                case 17:
                  i = {
                    message: "Incoming ".concat(n.name, "\n      The most recent campaign created for the company above has a different point total than the currently published campaign. "),
                    subject: "Change in Total Points on Incoming Campaign - Alert: ".concat(o.name, " (").concat(n.tgrams_id, ")")
                  }, s = this.createHsTicket(i);
                  console.log("ticket", Object(M.inspect)(s, !1, 5));
                  _context53.next = 21;
                  return this.postHsTicket(s);

                case 21:
                  r = _context53.sent;
                  return _context53.abrupt("return", (console.log("Hubspot response: ", r), console.log("END AllocationAlert New Campaign", t), e.statusCode = 200, e));

                case 23:
                case "end":
                  return _context53.stop();
              }
            }
          }, _callee53, this);
        }));

        function pushAllocateNewCampaignAlert(_x92) {
          return _pushAllocateNewCampaignAlert.apply(this, arguments);
        }

        return pushAllocateNewCampaignAlert;
      }()
    }, {
      key: "createHsTicket",
      value: function createHsTicket(t) {
        var e = t.message,
            n = {
          campaign_name: process.env.HUBSPOT_ALERT_CAMPAIGN_NAME,
          subject: t.subject,
          content: e,
          hs_pipeline_stage: process.env.HUBSPOT_ALERT_PIPELINE_STAGE
        };
        return Object.keys(n).reduce(function (t, e) {
          return [].concat(_toConsumableArray(t), [{
            name: e,
            value: n[e]
          }]);
        }, []);
      }
    }, {
      key: "postHsTicket",
      value: function postHsTicket(t) {
        return console.log("outgoing data ", JSON.stringify(t)), gt()("".concat(process.env.HUBSPOT_API_URL).concat(process.env.HUBSPOT_API_KEY), {
          method: "post",
          body: JSON.stringify(t),
          headers: {
            "Content-Type": "application/json"
          }
        }).then(function (t) {
          return t;
        }).then(function (t) {
          return t.json();
        });
      }
    }]);

    return bt;
  }();

  function Nt(t, e, n, o) {
    return console.log("Creating PVS Campaign object."), {
      pvs_campaign_id: t,
      tgrams_id: e,
      ad_server_campaign_id: "",
      vertical_id: "0",
      weight: 0,
      ad_server_name: "pvs--[page]--".concat(e, "--1"),
      is_active: !1,
      is_dirty: !1,
      start_date: n,
      end_date: o
    };
  }

  function It(t, e, n, o, a, i, s) {
    return console.log("Creating P3 Campaign object."), {
      p3_campaign_id: t,
      name: s,
      tgrams_id: i,
      entitled_rank_points: o,
      entitled_coverage_areas: 0,
      entitled_preview_ads: 0,
      start_date: e,
      end_date: n
    };
  }

  function vt(t, e) {
    return console.log("Creating Thomas Advertiser object."), {
      tgrams_id: t,
      name: e
    };
  }

  var Pt =
  /*#__PURE__*/
  function () {
    function Pt(t) {
      _classCallCheck(this, Pt);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Pt, [{
      key: "createAdvertiserIfNotExists",
      value: function () {
        var _createAdvertiserIfNotExists = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee54(t, e) {
          var n;
          return _regeneratorRuntime.wrap(function _callee54$(_context54) {
            while (1) {
              switch (_context54.prev = _context54.next) {
                case 0:
                  _context54.next = 2;
                  return this.context.thomasAdvertiser.get(t);

                case 2:
                  n = _context54.sent;

                  if (!n) {
                    _context54.next = 11;
                    break;
                  }

                  if (!(console.log("Thomas Advertiser object already exist for tgramsId: ".concat(t, ".")), console.log("Updating Thomas Advertiser name"), !e)) {
                    _context54.next = 6;
                    break;
                  }

                  throw new Error("Insufficient data provided to update Thomas Advertiser name for \n        tgramsId: ".concat(t));

                case 6:
                  n = vt(t, e);
                  _context54.next = 9;
                  return this.context.thomasAdvertiser.update(n);

                case 9:
                  _context54.next = 16;
                  break;

                case 11:
                  if (!(console.log("Thomas Advertiser object doesn't exist for tgramsId: ".concat(t, ".")), !t || !e)) {
                    _context54.next = 13;
                    break;
                  }

                  throw new Error("Insufficient data provided to create Thomas Advertiser for \n            tgramsId: ".concat(t, " & companyName: ").concat(e));

                case 13:
                  n = vt(t, e);
                  _context54.next = 16;
                  return this.context.thomasAdvertiser.insert(n);

                case 16:
                  return _context54.abrupt("return", n);

                case 17:
                case "end":
                  return _context54.stop();
              }
            }
          }, _callee54, this);
        }));

        function createAdvertiserIfNotExists(_x93, _x94) {
          return _createAdvertiserIfNotExists.apply(this, arguments);
        }

        return createAdvertiserIfNotExists;
      }()
    }]);

    return Pt;
  }();

  function Et(t, e, n) {
    return console.log("Creating Ad Server Advertiser object."), {
      tgrams_id: t,
      ad_server_id: n,
      ad_server_advertiser_id: "",
      ad_server_name: e,
      is_dirty: !1
    };
  }

  function xt(t, e, n, o, s, r) {
    console.log("Creating Thomas Campaign object");
    var c = V()(),
        l = e === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS ? i(a.CONSTANTS.PRODUCT_TYPE_MAP[e]) : a.CONSTANTS.PRODUCT_TYPE_MAP[e];
    return {
      campaign_id: c,
      tgrams_id: t,
      product_id: e,
      name: e === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS ? "".concat(l, " - [UNCONFIGURED] - ").concat(s) : r,
      status_id: a.CONSTANTS.CAMPAIGN_STATUS.NEW,
      start_date: n,
      end_date: o
    };
  }

  var kt =
  /*#__PURE__*/
  function () {
    function kt(t) {
      _classCallCheck(this, kt);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(kt, [{
      key: "createCampaign",
      value: function () {
        var _createCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee55(t) {
          var e, n, o, a, i, s, r, c, l;
          return _regeneratorRuntime.wrap(function _callee55$(_context55) {
            while (1) {
              switch (_context55.prev = _context55.next) {
                case 0:
                  console.log("Begin creating campaign objects CampaignFactoryConfig : \n".concat(Object(M.inspect)(t, !1, 4)));
                  e = t.tgramsId, n = t.productSku, o = t.startDate, a = t.endDate, i = t.quantity, s = t.campaignName;
                  r = t.companyName;
                  _context55.next = 5;
                  return this.createCampaignPrereqs(e, r, n);

                case 5:
                  c = _context55.sent;
                  r || (r = "".concat(e));
                  _context55.next = 9;
                  return this.createThomasCampaign(e, c.name, o, a, n, s);

                case 9:
                  l = _context55.sent;
                  _context55.next = 12;
                  return this.createCampaignModule(l.campaign_id, e, c.name, o, a, n, i, s);

                case 12:
                  console.log("Finished creating campaign objects.");
                  return _context55.abrupt("return", l.campaign_id);

                case 14:
                case "end":
                  return _context55.stop();
              }
            }
          }, _callee55, this);
        }));

        function createCampaign(_x95) {
          return _createCampaign.apply(this, arguments);
        }

        return createCampaign;
      }()
    }, {
      key: "createCampaignPrereqs",
      value: function () {
        var _createCampaignPrereqs = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee56(t, e, n) {
          var o, i, s, _e27;

          return _regeneratorRuntime.wrap(function _callee56$(_context56) {
            while (1) {
              switch (_context56.prev = _context56.next) {
                case 0:
                  o = new Pt(this.context);
                  _context56.next = 3;
                  return o.createAdvertiserIfNotExists(t, e);

                case 3:
                  i = _context56.sent;
                  s = a.CONSTANTS.SALES_ORDER_PRODUCT_TYPE_MAP.get(n);
                  _context56.t0 = s;
                  _context56.next = _context56.t0 === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS ? 8 : 21;
                  break;

                case 8:
                  _context56.next = 10;
                  return this.context.adServerAdvertiser.get(t, a.CONSTANTS.AD_SERVER_ID.SMART);

                case 10:
                  _e27 = _context56.sent;

                  if (!_e27) {
                    _context56.next = 15;
                    break;
                  }

                  console.log("Ad Server Advertiser object already exist for tgramsId: ".concat(t, ", adServerId: ").concat(a.CONSTANTS.AD_SERVER_ID.SMART, "."));
                  _context56.next = 20;
                  break;

                case 15:
                  console.log("Ad Server Advertiser object doesn't exist for tgramsId: ".concat(t, ", adServerId: ").concat(a.CONSTANTS.AD_SERVER_ID.SMART, "."));
                  _e27 = Et(t, c(i.name, i.tgrams_id), a.CONSTANTS.AD_SERVER_ID.SMART);
                  console.log("Inserting Ad Server Advertiser object.");
                  _context56.next = 20;
                  return this.context.adServerAdvertiser.insert(_e27);

                case 20:
                  return _context56.abrupt("break", 22);

                case 21:
                  console.log("No additional prereqs required to create campaign module for productTypeId: ".concat(s, "."));

                case 22:
                  return _context56.abrupt("return", i);

                case 23:
                case "end":
                  return _context56.stop();
              }
            }
          }, _callee56, this);
        }));

        function createCampaignPrereqs(_x96, _x97, _x98) {
          return _createCampaignPrereqs.apply(this, arguments);
        }

        return createCampaignPrereqs;
      }()
    }, {
      key: "createThomasCampaign",
      value: function () {
        var _createThomasCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee57(t, e, n, o, i, s) {
          var r;
          return _regeneratorRuntime.wrap(function _callee57$(_context57) {
            while (1) {
              switch (_context57.prev = _context57.next) {
                case 0:
                  r = xt(t, a.CONSTANTS.SALES_ORDER_PRODUCT_TYPE_MAP.get(i) || a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.OTHER, n, o, e, s);
                  console.log("Inserting Thomas Campaign object.");
                  _context57.next = 4;
                  return this.context.thomasCampaign.insert(r);

                case 4:
                  return _context57.abrupt("return", r);

                case 5:
                case "end":
                  return _context57.stop();
              }
            }
          }, _callee57, this);
        }));

        function createThomasCampaign(_x99, _x100, _x101, _x102, _x103, _x104) {
          return _createThomasCampaign.apply(this, arguments);
        }

        return createThomasCampaign;
      }()
    }, {
      key: "createCampaignModule",
      value: function () {
        var _createCampaignModule = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee58(t, e, n, o, i, s, r, c) {
          var l, _n13, _s4;

          return _regeneratorRuntime.wrap(function _callee58$(_context58) {
            while (1) {
              switch (_context58.prev = _context58.next) {
                case 0:
                  l = a.CONSTANTS.SALES_ORDER_PRODUCT_TYPE_MAP.get(s);
                  _context58.t0 = (console.log("Attempting to create campaign module for productTypeId: ".concat(l)), l);
                  _context58.next = _context58.t0 === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS ? 4 : _context58.t0 === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS ? 9 : 14;
                  break;

                case 4:
                  _n13 = Nt(t, e, o, i);
                  console.log("Inserting PVS Campaign object");
                  _context58.next = 8;
                  return this.context.pvsCampaign.insert(_n13);

                case 8:
                  return _context58.abrupt("break", 15);

                case 9:
                  _s4 = It(t, o, i, r, 0, e, c);
                  console.log("Inserting P3 Campaign object");
                  _context58.next = 13;
                  return this.context.p3Campaign.insert(_s4);

                case 13:
                  return _context58.abrupt("break", 15);

                case 14:
                  console.log("No module factory exists to create this campaign module.");

                case 15:
                case "end":
                  return _context58.stop();
              }
            }
          }, _callee58, this);
        }));

        function createCampaignModule(_x105, _x106, _x107, _x108, _x109, _x110, _x111, _x112) {
          return _createCampaignModule.apply(this, arguments);
        }

        return createCampaignModule;
      }()
    }]);

    return kt;
  }();

  var Rt =
  /*#__PURE__*/
  function () {
    function Rt(t) {
      _classCallCheck(this, Rt);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Rt, [{
      key: "fulfillRequest",
      value: function () {
        var _fulfillRequest3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee59(t) {
          var e, n, o, i, r, _n14, c, l, d, _n15, _t27, _n16;

          return _regeneratorRuntime.wrap(function _callee59$(_context59) {
            while (1) {
              switch (_context59.prev = _context59.next) {
                case 0:
                  console.log("Begin fulfilling new product request.");
                  e = Object(a.makeEmptyResponseInfo)();
                  o = {
                    opportunity_id: t.opportunityId,
                    item_id: t.itemId,
                    tgrams_id: parseInt(t.tgramsId, 10).toString(),
                    product_sku: t.productSku,
                    quantity: t.quantity,
                    start_date: t.startDate,
                    end_date: t.endDate,
                    campaign_id: "",
                    configuration_workflow_arn: "",
                    configuration_activity_token: "",
                    is_configuration_workflow_ready: !1,
                    total_contract_value: t.totalContractValue,
                    order_source: t.orderSource
                  }, i = t.companyName;
                  _context59.prev = 3;
                  _context59.next = 6;
                  return this.context.productFulfillment.get(o.item_id);

                case 6:
                  r = _context59.sent;
                  _context59.next = 13;
                  break;

                case 9:
                  _context59.prev = 9;
                  _context59.t0 = _context59["catch"](3);
                  _n14 = "Failed to get existing product fulfillment from db.";
                  return _context59.abrupt("return", (console.log(_n14), console.log(_context59.t0), e.errors.push(_n14), e.statusCode = 500, e));

                case 13:
                  if (!r) {
                    _context59.next = 19;
                    break;
                  }

                  console.log("A product fulfillment already exists for this opportunity & item. Updating...");
                  _context59.next = 17;
                  return this.context.productFulfillment.update(o);

                case 17:
                  _context59.next = 22;
                  break;

                case 19:
                  console.log("Creating new product fulfillment.", o);
                  _context59.next = 22;
                  return this.context.productFulfillment.insert(o);

                case 22:
                  _context59.t1 = s;
                  _context59.next = 25;
                  return this.context.thomasCampaign.getCampaignForRenewal(o.tgrams_id, o.start_date);

                case 25:
                  if (!_context59.sent) {
                    _context59.next = 29;
                    break;
                  }

                  _context59.t2 = a.ProductFulfillmentOrderTypes.RENEWAL;
                  _context59.next = 30;
                  break;

                case 29:
                  _context59.t2 = a.ProductFulfillmentOrderTypes.NEW;

                case 30:
                  _context59.t3 = _context59.t2;
                  _context59.t4 = i;
                  _context59.t5 = o.quantity;
                  _context59.t6 = a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS;
                  c = (0, _context59.t1)(_context59.t3, _context59.t4, _context59.t5, _context59.t6);
                  l = {
                    tgramsId: o.tgrams_id,
                    companyName: i,
                    productSku: o.product_sku,
                    startDate: o.start_date,
                    endDate: o.end_date,
                    quantity: o.quantity,
                    campaignName: c
                  };
                  d = new kt(this.context);
                  _context59.prev = 37;
                  _context59.next = 40;
                  return d.createCampaign(l);

                case 40:
                  n = _context59.sent;
                  _context59.next = 47;
                  break;

                case 43:
                  _context59.prev = 43;
                  _context59.t7 = _context59["catch"](37);
                  _n15 = "Failed to create campaign objects from productFulfillment";
                  return _context59.abrupt("return", (console.log(_n15), console.log(_context59.t7), e.errors.push(_n15), e.statusCode = 500, e));

                case 47:
                  o.campaign_id = n;
                  _context59.next = 50;
                  return this.context.productFulfillment.update(o);

                case 50:
                  _context59.prev = 50;
                  _t27 = {
                    opportunity_id: o.opportunity_id,
                    item_id: o.item_id,
                    campaign_id: n,
                    version: 1
                  };

                  if (!r) {
                    _context59.next = 57;
                    break;
                  }

                  _context59.next = 55;
                  return this.context.productFulfillmentVersion.update(_t27);

                case 55:
                  _context59.next = 59;
                  break;

                case 57:
                  _context59.next = 59;
                  return this.context.productFulfillmentVersion.insert(_t27);

                case 59:
                  _context59.next = 65;
                  break;

                case 61:
                  _context59.prev = 61;
                  _context59.t8 = _context59["catch"](50);
                  _n16 = "Failed to insert or update productFulfillmentVersion";
                  return _context59.abrupt("return", (console.log(_n16), console.log(_context59.t8), e.errors.push(_n16), e.statusCode = 500, e));

                case 65:
                  return _context59.abrupt("return", (e.data.campaignId = n, e));

                case 66:
                case "end":
                  return _context59.stop();
              }
            }
          }, _callee59, this, [[3, 9], [37, 43], [50, 61]]);
        }));

        function fulfillRequest(_x113) {
          return _fulfillRequest3.apply(this, arguments);
        }

        return fulfillRequest;
      }()
    }]);

    return Rt;
  }();

  var Dt =
  /*#__PURE__*/
  function () {
    function Dt(t) {
      _classCallCheck(this, Dt);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Dt, [{
      key: "fulfillRequest",
      value: function () {
        var _fulfillRequest4 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee60(t) {
          return _regeneratorRuntime.wrap(function _callee60$(_context60) {
            while (1) {
              switch (_context60.prev = _context60.next) {
                case 0:
                  return _context60.abrupt("return", this.executeOptimizationRequest(t.campaignId, t.startDate));

                case 1:
                case "end":
                  return _context60.stop();
              }
            }
          }, _callee60, this);
        }));

        function fulfillRequest(_x114) {
          return _fulfillRequest4.apply(this, arguments);
        }

        return fulfillRequest;
      }()
    }, {
      key: "executeOptimizationRequest",
      value: function () {
        var _executeOptimizationRequest = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee62(t, e) {
          var n, o, i, _a6, _e28, _t28, _e29;

          return _regeneratorRuntime.wrap(function _callee62$(_context62) {
            while (1) {
              switch (_context62.prev = _context62.next) {
                case 0:
                  console.log("Begin fulfilling optimize product request.");
                  i = Object(a.makeEmptyResponseInfo)();
                  _context62.prev = 2;
                  _a6 = new st(this.context);
                  _context62.next = 6;
                  return _a6.optimize(t, e);

                case 6:
                  _context62.t0 = (i = _context62.sent).statusCode;

                  if (!(200 !== _context62.t0)) {
                    _context62.next = 9;
                    break;
                  }

                  return _context62.abrupt("return", i);

                case 9:
                  n = i.data.productFulfillment, o = i.data.version;
                  _context62.next = 16;
                  break;

                case 12:
                  _context62.prev = 12;
                  _context62.t1 = _context62["catch"](2);
                  _e28 = "Failed to optimize campaign.";
                  return _context62.abrupt("return", (console.log(_e28), console.log(_context62.t1), i.statusCode = 500, i.errors.push(_e28), i));

                case 16:
                  _context62.prev = 16;
                  _context62.next = 19;
                  return function () {
                    var _ref13 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee61(t, e, n) {
                      var o, a, i;
                      return _regeneratorRuntime.wrap(function _callee61$(_context61) {
                        while (1) {
                          switch (_context61.prev = _context61.next) {
                            case 0:
                              o = "https://".concat(mt("NEPTUNE_PRIVATE_API_ENDPOINT"), "/api/orders/").concat(t.opportunity_id, "/version"), a = {
                                quoteOrderId: t.opportunity_id,
                                tgramsId: t.tgrams_id,
                                itemId: t.item_id,
                                itemVersion: n,
                                campaignId: e,
                                productSku: t.product_sku,
                                startDate: t.start_date,
                                endDate: t.end_date,
                                orderType: "optimization"
                              };
                              console.log({
                                message: "Begin sending optimization to Neptune",
                                url: o,
                                postModel: a
                              });
                              _context61.next = 4;
                              return gt()(o, {
                                method: "post",
                                headers: {
                                  "Content-type": "application/json"
                                },
                                body: JSON.stringify(a)
                              });

                            case 4:
                              i = _context61.sent;

                              if (!(console.log({
                                message: "Response received",
                                statusCode: i.status,
                                statusText: i.statusText
                              }), !i.ok)) {
                                _context61.next = 7;
                                break;
                              }

                              throw console.log({
                                message: "Http request failed",
                                url: o,
                                postModel: a
                              }), new Error("Failed to send new version request ".concat(i.status, " - ").concat(i.statusText));

                            case 7:
                              return _context61.abrupt("return", {
                                statusCode: i.status,
                                statusText: i.statusText
                              });

                            case 8:
                            case "end":
                              return _context61.stop();
                          }
                        }
                      }, _callee61);
                    }));

                    return function (_x117, _x118, _x119) {
                      return _ref13.apply(this, arguments);
                    };
                  }()(n, i.data.campaignId, o);

                case 19:
                  _t28 = _context62.sent;

                  if (!(!_t28 || 200 !== _t28.statusCode)) {
                    _context62.next = 22;
                    break;
                  }

                  throw new Error("Neptune optimize response is not ok");

                case 22:
                  _context62.next = 28;
                  break;

                case 24:
                  _context62.prev = 24;
                  _context62.t2 = _context62["catch"](16);
                  _e29 = "Failed to post optimization to Neptune.";
                  return _context62.abrupt("return", (console.log(_e29), console.log(_context62.t2), i.errors.push(_e29), i.statusCode = 500, i));

                case 28:
                  return _context62.abrupt("return", i);

                case 29:
                case "end":
                  return _context62.stop();
              }
            }
          }, _callee62, this, [[2, 12], [16, 24]]);
        }));

        function executeOptimizationRequest(_x115, _x116) {
          return _executeOptimizationRequest.apply(this, arguments);
        }

        return executeOptimizationRequest;
      }()
    }]);

    return Dt;
  }();

  var Ft =
  /*#__PURE__*/
  function () {
    function Ft(t) {
      _classCallCheck(this, Ft);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Ft, [{
      key: "createInvoker",
      value: function createInvoker(t) {
        console.log("Creating invoker for orderType: ", t);
        var e = a.ResponseInfo.makeEmptyResponseInfo();

        switch (t) {
          case a.ProductFulfillmentOrderTypes.NEW:
            e.data.invoker = new Rt(this.context);
            break;

          case a.ProductFulfillmentOrderTypes.OPTIMIZATION:
            e.data.invoker = new Dt(this.context);
            break;

          case a.ProductFulfillmentOrderTypes.AMENDMENT:
            e.data.invoker = new Ct(this.context);
            break;

          case a.ProductFulfillmentOrderTypes.RENEWAL:
            e.data.invoker = new At(this.context);
            break;

          default:
            e.addError(400, "orderType: ".concat(t, " not supported."));
        }

        return e.data.invoker ? console.log("Successfully created product fulfillment invoker for orderType: ".concat(t, ".")) : console.log("Failed to create product fulfillment invoker for orderType: ".concat(t, ".")), e;
      }
    }]);

    return Ft;
  }();

  var Mt =
  /*#__PURE__*/
  function () {
    function Mt(t) {
      _classCallCheck(this, Mt);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Mt, [{
      key: "processRequest",
      value: function () {
        var _processRequest = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee63(t) {
          var e, n, o, i, _t29;

          return _regeneratorRuntime.wrap(function _callee63$(_context63) {
            while (1) {
              switch (_context63.prev = _context63.next) {
                case 0:
                  e = a.ResponseInfo.makeEmptyResponseInfo(), n = Mt.makeProductFulfillmentRequestData(t), o = new Ft(this.context).createInvoker(t.body.orderType), i = o.data.invoker;

                  if (!(200 !== o.statusCode)) {
                    _context63.next = 3;
                    break;
                  }

                  return _context63.abrupt("return", o);

                case 3:
                  _context63.prev = 3;
                  console.log("fulfillRequest data: ", Object(M.inspect)(n, !1, 5));
                  _context63.next = 7;
                  return i.fulfillRequest(n);

                case 7:
                  _t29 = _context63.sent;
                  return _context63.abrupt("return", (console.log("fulfillmentResponseInfo: ", Object(M.inspect)(_t29, !1, 5)), _t29));

                case 11:
                  _context63.prev = 11;
                  _context63.t0 = _context63["catch"](3);
                  e.reportError(_context63.t0);

                case 14:
                  return _context63.abrupt("return", e);

                case 15:
                case "end":
                  return _context63.stop();
              }
            }
          }, _callee63, this, [[3, 11]]);
        }));

        function processRequest(_x120) {
          return _processRequest.apply(this, arguments);
        }

        return processRequest;
      }()
    }], [{
      key: "makeProductFulfillmentRequestData",
      value: function makeProductFulfillmentRequestData(t) {
        return console.log("Making IProductFulfillmentRequestData from request body."), {
          opportunityId: t.body.quoteOrderId,
          itemId: t.body.itemId,
          tgramsId: parseInt(t.body.tgramsId, 10).toString(),
          companyName: t.body.companyName,
          productSku: t.body.productSku,
          quantity: t.body.quantity,
          startDate: t.body.startDate,
          endDate: t.body.endDate,
          campaignId: t.params.campaignId || t.body.campaignId,
          sourceCampaignId: t.body.sourceCampaignId || "",
          totalContractValue: "",
          orderSource: t.body.orderSource
        };
      }
    }]);

    return Mt;
  }();

  var $t = Mt;

  var Ut =
  /*#__PURE__*/
  function () {
    function Ut(t) {
      _classCallCheck(this, Ut);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Ut, [{
      key: "publishCampaign",
      value: function () {
        var _publishCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee64(t) {
          var e, n, o, _n17, _t30, _e30, _n18;

          return _regeneratorRuntime.wrap(function _callee64$(_context64) {
            while (1) {
              switch (_context64.prev = _context64.next) {
                case 0:
                  e = Object(a.makeEmptyResponseInfo)();
                  _context64.next = 3;
                  return this.context.thomasCampaign.get(t);

                case 3:
                  n = _context64.sent;

                  if (![a.CONSTANTS.CAMPAIGN_STATUS.COMPLETED, a.CONSTANTS.CAMPAIGN_STATUS.CANCELED, a.CONSTANTS.CAMPAIGN_STATUS.DELETED, a.CONSTANTS.CAMPAIGN_STATUS.OPTIMIZED, a.CONSTANTS.CAMPAIGN_STATUS.OPTIMIZE_IN_PROGRESS, a.CONSTANTS.CAMPAIGN_STATUS.AMENDED, a.CONSTANTS.CAMPAIGN_STATUS.AMENDED_BEFORE_START].includes(n.status_id)) {
                    _context64.next = 6;
                    break;
                  }

                  return _context64.abrupt("return", (console.log({
                    message: "CAMPAING CANNOT BE UPDATED TO PUBLISSHED",
                    campaignId: t,
                    statusId: n.status_id
                  }), e.statusCode = 200, e));

                case 6:
                  _context64.next = 8;
                  return this.context.thomasCampaign.setStatus(t, a.CONSTANTS.CAMPAIGN_STATUS.PUBLISHED);

                case 8:
                  console.log("Successfully updated thomasCampaign status.");
                  _context64.next = 11;
                  return this.context.productFulfillment.findByCampaignId(t);

                case 11:
                  o = _context64.sent;
                  _context64.prev = 12;

                  if (!(console.log("Updating thomasCampaign status."), o)) {
                    _context64.next = 33;
                    break;
                  }

                  _context64.next = 16;
                  return this.context.productFulfillmentVersion.findByCampaignId(t);

                case 16:
                  _n17 = _context64.sent;

                  if (!(e.statusCode = 200, _n17 && _n17.version > 1)) {
                    _context64.next = 33;
                    break;
                  }

                  _context64.next = 20;
                  return this.context.productFulfillmentVersion.findByOpportunityAndVersion(_n17.opportunity_id, _n17.version - 1);

                case 20:
                  _t30 = _context64.sent;

                  if (!_t30) {
                    _context64.next = 33;
                    break;
                  }

                  _context64.next = 24;
                  return this.context.thomasCampaign.get(_t30.campaign_id);

                case 24:
                  _e30 = _context64.sent;
                  _context64.t0 = _e30;

                  if (!_context64.t0) {
                    _context64.next = 33;
                    break;
                  }

                  console.log("thomasSourceCampaign version: ", Object(M.inspect)(_t30, !1, 5));
                  console.log("thomasSourceCampaign: ", Object(M.inspect)(_e30, !1, 5));
                  _context64.t1 = _e30.status_id === a.CONSTANTS.CAMPAIGN_STATUS.OPTIMIZE_IN_PROGRESS;

                  if (!_context64.t1) {
                    _context64.next = 33;
                    break;
                  }

                  _context64.next = 33;
                  return this.context.thomasCampaign.setStatus(_e30.campaign_id, a.CONSTANTS.CAMPAIGN_STATUS.OPTIMIZED);

                case 33:
                  _context64.next = 39;
                  break;

                case 35:
                  _context64.prev = 35;
                  _context64.t2 = _context64["catch"](12);
                  _n18 = "Failed to  publish Campaign";
                  e.errors.push(_n18), e.statusCode = 500;

                case 39:
                  return _context64.abrupt("return", e);

                case 40:
                case "end":
                  return _context64.stop();
              }
            }
          }, _callee64, this, [[12, 35]]);
        }));

        function publishCampaign(_x121) {
          return _publishCampaign.apply(this, arguments);
        }

        return publishCampaign;
      }()
    }, {
      key: "cancelCampaign",
      value: function () {
        var _cancelCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee65(t, e) {
          var n, o, _t31, _t32;

          return _regeneratorRuntime.wrap(function _callee65$(_context65) {
            while (1) {
              switch (_context65.prev = _context65.next) {
                case 0:
                  n = Object(a.makeEmptyResponseInfo)();
                  _context65.next = 3;
                  return this.context.thomasCampaign.get(t);

                case 3:
                  o = _context65.sent;

                  if (o) {
                    _context65.next = 7;
                    break;
                  }

                  _t31 = "Failed to get existing endfullfilemnt campaign from db.";
                  return _context65.abrupt("return", (n.errors.push(_t31), n.statusCode = 500, n));

                case 7:
                  _context65.next = 9;
                  return this.updateCampaign(o, e, o.start_date, a.CONSTANTS.CAMPAIGN_STATUS.CANCELED);

                case 9:
                  if (!_context65.sent) {
                    _context65.next = 13;
                    break;
                  }

                  n.statusCode = 200;
                  _context65.next = 15;
                  break;

                case 13:
                  _t32 = "Failed to get cancelCampaign";
                  n.errors.push(_t32), n.statusCode = 500;

                case 15:
                  return _context65.abrupt("return", n);

                case 16:
                case "end":
                  return _context65.stop();
              }
            }
          }, _callee65, this);
        }));

        function cancelCampaign(_x122, _x123) {
          return _cancelCampaign.apply(this, arguments);
        }

        return cancelCampaign;
      }()
    }, {
      key: "endCampaign",
      value: function () {
        var _endCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee66(t, e) {
          var n, o, _t33, _t34;

          return _regeneratorRuntime.wrap(function _callee66$(_context66) {
            while (1) {
              switch (_context66.prev = _context66.next) {
                case 0:
                  n = Object(a.makeEmptyResponseInfo)();
                  _context66.next = 3;
                  return this.context.thomasCampaign.get(t);

                case 3:
                  o = _context66.sent;

                  if (o) {
                    _context66.next = 7;
                    break;
                  }

                  _t33 = "Failed to get existing end campaign from db.";
                  return _context66.abrupt("return", (n.errors.push(_t33), n.statusCode = 500, n));

                case 7:
                  _context66.next = 9;
                  return this.updateCampaign(o, e, o.start_date, o.status_id);

                case 9:
                  if (!_context66.sent) {
                    _context66.next = 13;
                    break;
                  }

                  n.statusCode = 200;
                  _context66.next = 15;
                  break;

                case 13:
                  _t34 = "Failed to end campaign";
                  n.errors.push(_t34), n.statusCode = 500;

                case 15:
                  return _context66.abrupt("return", n);

                case 16:
                case "end":
                  return _context66.stop();
              }
            }
          }, _callee66, this);
        }));

        function endCampaign(_x124, _x125) {
          return _endCampaign.apply(this, arguments);
        }

        return endCampaign;
      }()
    }, {
      key: "updateDatesOnlyCampaign",
      value: function () {
        var _updateDatesOnlyCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee67(t, e, n) {
          var o, i, _t35, _t36;

          return _regeneratorRuntime.wrap(function _callee67$(_context67) {
            while (1) {
              switch (_context67.prev = _context67.next) {
                case 0:
                  o = Object(a.makeEmptyResponseInfo)();
                  _context67.next = 3;
                  return this.context.thomasCampaign.get(t);

                case 3:
                  i = _context67.sent;

                  if (i) {
                    _context67.next = 7;
                    break;
                  }

                  _t35 = "Failed to get  updateDatesOnlyCampaign campaign from db.";
                  return _context67.abrupt("return", (o.errors.push(_t35), o.statusCode = 500, o));

                case 7:
                  _context67.next = 9;
                  return this.updateCampaign(i, e, n, i.status_id);

                case 9:
                  if (!_context67.sent) {
                    _context67.next = 13;
                    break;
                  }

                  o.statusCode = 200;
                  _context67.next = 15;
                  break;

                case 13:
                  _t36 = "Failed to get updateDatesOnlyCampaign";
                  o.errors.push(_t36), o.statusCode = 500;

                case 15:
                  return _context67.abrupt("return", o);

                case 16:
                case "end":
                  return _context67.stop();
              }
            }
          }, _callee67, this);
        }));

        function updateDatesOnlyCampaign(_x126, _x127, _x128) {
          return _updateDatesOnlyCampaign.apply(this, arguments);
        }

        return updateDatesOnlyCampaign;
      }()
    }, {
      key: "purgeFullfilmentByOppId",
      value: function () {
        var _purgeFullfilmentByOppId = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee69(t) {
          var _this19 = this;

          var e, n, _t37, o, _o12;

          return _regeneratorRuntime.wrap(function _callee69$(_context69) {
            while (1) {
              switch (_context69.prev = _context69.next) {
                case 0:
                  e = Object(a.makeEmptyResponseInfo)();
                  _context69.next = 3;
                  return this.context.productFulfillment.getFulfillmentToPurge(t);

                case 3:
                  n = _context69.sent;

                  if (!(!n || 0 === n.length)) {
                    _context69.next = 7;
                    break;
                  }

                  _t37 = "Failed to get fulfillments to purge for given opportunity id.";
                  return _context69.abrupt("return", (e.errors.push(_t37), e.statusCode = 400, e));

                case 7:
                  console.log("Found ".concat(n.length, " fulfillment records to purge."));
                  o = [];
                  n.forEach(function (t) {
                    o.push(
                    /*#__PURE__*/
                    _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee68() {
                      var e;
                      return _regeneratorRuntime.wrap(function _callee68$(_context68) {
                        while (1) {
                          switch (_context68.prev = _context68.next) {
                            case 0:
                              _context68.next = 2;
                              return _this19.context.productFulfillmentVersion.delete(t.opportunity_id, t.item_id, t.campaign_id);

                            case 2:
                              _context68.next = 4;
                              return _this19.context.productFulfillment.delete(t.opportunity_id, t.item_id);

                            case 4:
                              _context68.next = 6;
                              return _this19.context.p3Configuration.getByCampaign(t.campaign_id);

                            case 6:
                              e = _context68.sent;
                              _context68.t0 = e;

                              if (!_context68.t0) {
                                _context68.next = 12;
                                break;
                              }

                              e.p3_campaign_id = "";
                              _context68.next = 12;
                              return _this19.context.p3Configuration.update(e);

                            case 12:
                              _context68.next = 14;
                              return _this19.context.thomasCampaign.setStatus(t.campaign_id, a.CONSTANTS.CAMPAIGN_STATUS.DELETED);

                            case 14:
                            case "end":
                              return _context68.stop();
                          }
                        }
                      }, _callee68);
                    })));
                  });
                  _context69.prev = 10;
                  console.log("Begin purging");
                  _context69.next = 14;
                  return Promise.all(o.map(function (t) {
                    return t();
                  }));

                case 14:
                  e.statusCode = 200;
                  return _context69.abrupt("return", e);

                case 18:
                  _context69.prev = 18;
                  _context69.t0 = _context69["catch"](10);
                  _o12 = "Failed to purge opportunity ";
                  return _context69.abrupt("return", (console.log("error purged opp", t), e.errors.push(_o12), e.statusCode = 500, e));

                case 22:
                case "end":
                  return _context69.stop();
              }
            }
          }, _callee69, this, [[10, 18]]);
        }));

        function purgeFullfilmentByOppId(_x129) {
          return _purgeFullfilmentByOppId.apply(this, arguments);
        }

        return purgeFullfilmentByOppId;
      }()
    }, {
      key: "forceEndDateOpportunity",
      value: function () {
        var _forceEndDateOpportunity = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee70(t, e) {
          var n, o, _t38, _o13;

          return _regeneratorRuntime.wrap(function _callee70$(_context70) {
            while (1) {
              switch (_context70.prev = _context70.next) {
                case 0:
                  n = Object(a.makeEmptyResponseInfo)();
                  _context70.next = 3;
                  return this.context.productFulfillment.getFulfillmentToPurge(t);

                case 3:
                  o = _context70.sent;

                  if (o) {
                    _context70.next = 7;
                    break;
                  }

                  _t38 = "Failed to get   forcedobject from db.";
                  return _context70.abrupt("return", (n.errors.push(_t38), n.statusCode = 500, n));

                case 7:
                  _context70.prev = 7;
                  _context70.next = 10;
                  return this.context.productFulfillment.updateEndDate(e, o.opportunity_id, o.item_id);

                case 10:
                  _context70.next = 12;
                  return this.context.thomasCampaign.updateEndDate(e, o.campaign_id);

                case 12:
                  _context70.next = 14;
                  return this.context.p3Campaign.updateEndDate(e, o.campaign_id);

                case 14:
                  n.statusCode = 200;
                  return _context70.abrupt("return", n);

                case 18:
                  _context70.prev = 18;
                  _context70.t0 = _context70["catch"](7);
                  _o13 = "Failed to enddate opportunity ";
                  return _context70.abrupt("return", (console.log("error purged opp", t), n.errors.push(_o13), n.statusCode = 500, n));

                case 22:
                case "end":
                  return _context70.stop();
              }
            }
          }, _callee70, this, [[7, 18]]);
        }));

        function forceEndDateOpportunity(_x130, _x131) {
          return _forceEndDateOpportunity.apply(this, arguments);
        }

        return forceEndDateOpportunity;
      }()
    }, {
      key: "updateDatesAndStatusCampaign",
      value: function () {
        var _updateDatesAndStatusCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee71(t, e, n, o) {
          var i, s, _t39, r, _t40, _t41;

          return _regeneratorRuntime.wrap(function _callee71$(_context71) {
            while (1) {
              switch (_context71.prev = _context71.next) {
                case 0:
                  i = Object(a.makeEmptyResponseInfo)();
                  _context71.next = 3;
                  return this.context.thomasCampaign.get(t);

                case 3:
                  s = _context71.sent;

                  if (s) {
                    _context71.next = 7;
                    break;
                  }

                  _t39 = "Failed to get  updateDatesAndStatusCampaign campaign from db.";
                  return _context71.abrupt("return", (i.errors.push(_t39), i.statusCode = 500, i));

                case 7:
                  _context71.next = 9;
                  return this.updateCampaign(s, e, n, o);

                case 9:
                  r = _context71.sent;

                  if (!(o === a.CONSTANTS.CAMPAIGN_STATUS.DELETED)) {
                    _context71.next = 14;
                    break;
                  }

                  _t40 = new Z(this.context);
                  _context71.next = 14;
                  return _t40.duplicateConfigurationByCampaignAndTgrams(s.campaign_id, s.tgrams_id);

                case 14:
                  if (r) i.statusCode = 200;else {
                    _t41 = "Failed to get updateDatesAndStatusCampaign";
                    i.errors.push(_t41), i.statusCode = 500;
                  }
                  return _context71.abrupt("return", i);

                case 16:
                case "end":
                  return _context71.stop();
              }
            }
          }, _callee71, this);
        }));

        function updateDatesAndStatusCampaign(_x132, _x133, _x134, _x135) {
          return _updateDatesAndStatusCampaign.apply(this, arguments);
        }

        return updateDatesAndStatusCampaign;
      }()
    }, {
      key: "updateCampaign",
      value: function () {
        var _updateCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee72(t, e, n, o) {
          var i, s;
          return _regeneratorRuntime.wrap(function _callee72$(_context72) {
            while (1) {
              switch (_context72.prev = _context72.next) {
                case 0:
                  console.log("Begin  endFullfillment.", t.campaign_id), console.log("Begin  new status", a.CONSTANTS.CAMPAIGN_STATUS_MAP[o]);
                  _context72.next = 3;
                  return this.context.productFulfillment.findByCampaignId(t.campaign_id);

                case 3:
                  i = _context72.sent;
                  _context72.next = 6;
                  return this.context.p3Campaign.get(t.campaign_id);

                case 6:
                  s = _context72.sent;

                  if (s) {
                    _context72.next = 9;
                    break;
                  }

                  return _context72.abrupt("return", (console.log("Failed to get existing endfullfilemnt p3 campaign from db."), !1));

                case 9:
                  if (i) {
                    _context72.next = 11;
                    break;
                  }

                  return _context72.abrupt("return", (console.log("Failed to get existing endfullfilemnt productFulfillment from db."), !1));

                case 11:
                  _context72.prev = 11;
                  t.status_id = o;
                  t.end_date = e;
                  t.start_date = n;
                  i.end_date = e;
                  i.start_date = n;
                  s.end_date = e;
                  s.start_date = n;
                  _context72.next = 21;
                  return this.context.thomasCampaign.update(t);

                case 21:
                  _context72.next = 23;
                  return this.context.productFulfillment.update(i);

                case 23:
                  _context72.next = 25;
                  return this.context.p3Campaign.update(s);

                case 25:
                  return _context72.abrupt("return", !0);

                case 28:
                  _context72.prev = 28;
                  _context72.t0 = _context72["catch"](11);
                  return _context72.abrupt("return", !1);

                case 31:
                case "end":
                  return _context72.stop();
              }
            }
          }, _callee72, this, [[11, 28]]);
        }));

        function updateCampaign(_x136, _x137, _x138, _x139) {
          return _updateCampaign.apply(this, arguments);
        }

        return updateCampaign;
      }()
    }]);

    return Ut;
  }(),
      jt = n(10);

  var Bt =
  /*#__PURE__*/
  function () {
    function Bt(_ref15) {
      var t = _ref15.url;

      _classCallCheck(this, Bt);

      var e, n, o;
      o = void 0, (n = "sqs") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.sqs = new z(t);
    }

    _createClass(Bt, [{
      key: "push",
      value: function push(t) {
        var e = {
          configurationId: {
            DataType: "String",
            StringValue: t.configuration_id
          }
        };
        return console.log("publishData: ", Object(M.inspect)(t)), this.sqs.sendMessage(t, {
          attributes: e
        }).catch(function (t) {
          return Bt.localErrorHandler(t, "P3pdfExportSqs", "sendMessage");
        });
      }
    }], [{
      key: "localErrorHandler",
      value: function localErrorHandler(t, e, n) {
        console.log("".concat(e, ".").concat(n, " failed.")), console.log(Object(M.inspect)(t, !1, 4));
      }
    }]);

    return Bt;
  }();

  var Gt = Bt;

  function qt(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var Lt =
  /*#__PURE__*/
  function () {
    function Lt(t) {
      _classCallCheck(this, Lt);

      qt(this, "context", void 0), qt(this, "redisPort", void 0), qt(this, "redisHost", void 0), qt(this, "pdfBucket", void 0), qt(this, "pdfSqs", void 0), qt(this, "s3Region", void 0), qt(this, "baseUrl", void 0), qt(this, "asyncRedis", void 0), qt(this, "s3", void 0), qt(this, "pdfExporterSqs", void 0), this.context = t;
      var e = process.env.SATURN_PDF_REDIS_PORT,
          n = process.env.SATURN_PDF_REDIS_HOST,
          o = process.env.SATURN_PDF_BUCKET,
          a = process.env.PDF_EXPORT_QUEUE_URL,
          i = process.env.PDF_EXPORT_S3_REGION,
          s = process.env.PDF_EXPORT_BASE_URL;
      if ("string" != typeof e || "string" != typeof n || "string" != typeof o || "string" != typeof a || "string" != typeof i || "string" != typeof s) throw new TypeError("SATURN_PDF_REDIS_PORT or SATURN_PDF_REDIS_HOST or SATURN_PDF_BUCKET is not set.");
      this.redisPort = e, this.redisHost = n, this.pdfBucket = o, this.s3Region = i, this.pdfSqs = a, this.baseUrl = s, this.s3 = new F.a.S3({
        region: this.s3Region
      }), this.asyncRedis = new J({
        host: this.redisHost,
        port: parseInt(this.redisPort, 10)
      }), this.pdfExporterSqs = new Gt({
        url: this.pdfSqs
      });
    }

    _createClass(Lt, [{
      key: "setDownloadRequest",
      value: function () {
        var _setDownloadRequest = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee73(t) {
          var e, n;
          return _regeneratorRuntime.wrap(function _callee73$(_context73) {
            while (1) {
              switch (_context73.prev = _context73.next) {
                case 0:
                  e = {
                    print_background: !0,
                    print_header_footer: !0,
                    email: this.context.email,
                    download_url: "",
                    bucket_name: this.pdfBucket,
                    page_url: this.generatePageUrl(t),
                    file_name: this.generatePdfFileName(t),
                    campaign_id: t.campaign_id,
                    tgrams_id: t.tgrams_id,
                    configuration_id: t.configuration_id,
                    token_id: t.token_id,
                    redis_id: this.generateRedisId(t),
                    footer_template: this.renderFooter(),
                    status: "processing",
                    redis_key: this.generateRedisKey(t),
                    s3_info: {}
                  };
                  _context73.next = 3;
                  return this.setRedisData(e);

                case 3:
                  _context73.next = 5;
                  return this.pdfExporterSqs.push(e);

                case 5:
                  n = _context73.sent;
                  return _context73.abrupt("return", (console.log("exporter sqs push response", n), t.redis_id = e.redis_id, t.redis_key = e.redis_key, t.status = e.status, e));

                case 7:
                case "end":
                  return _context73.stop();
              }
            }
          }, _callee73, this);
        }));

        function setDownloadRequest(_x140) {
          return _setDownloadRequest.apply(this, arguments);
        }

        return setDownloadRequest;
      }()
    }, {
      key: "generateRedisKey",
      value: function generateRedisKey(t) {
        var e = "saturn:".concat(t.configuration_id, ":");
        return "" !== t.tgrams_id && (e += "".concat(t.tgrams_id, ":")), "" !== t.campaign_id && (e += "".concat(t.campaign_id, ":")), e += "pdf-config-export", console.log("rediskey:", e), e;
      }
    }, {
      key: "generateRedisId",
      value: function generateRedisId(t) {
        var e = Date.now(),
            n = "".concat(t.configuration_id).concat(e),
            o = jt.createHash("sha1").update(JSON.stringify(n)).digest("hex");
        return console.log("redis id", o), o;
      }
    }, {
      key: "generatePdfFileName",
      value: function generatePdfFileName(t) {
        var e = "config-export-".concat(t.configuration_id, ".pdf");
        return console.log("pdf file name", e), e;
      }
    }, {
      key: "generatePageUrl",
      value: function generatePageUrl(t) {
        var e = "".concat(this.baseUrl, "/").concat(t.configuration_id);
        return "" !== t.tgrams_id && (e += "/".concat(t.tgrams_id)), "" !== t.campaign_id && (e += "/".concat(t.campaign_id)), e += "?token=".concat(t.token_id), console.log("pdf client url ", e), e;
      }
    }, {
      key: "setBucketObject",
      value: function () {
        var _setBucketObject = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee74(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee74$(_context74) {
            while (1) {
              switch (_context74.prev = _context74.next) {
                case 0:
                  _context74.next = 2;
                  return this.s3.putObject(t).promise();

                case 2:
                  e = _context74.sent;
                  return _context74.abrupt("return", (console.log("S3 Object key: ", e), e));

                case 4:
                case "end":
                  return _context74.stop();
              }
            }
          }, _callee74, this);
        }));

        function setBucketObject(_x141) {
          return _setBucketObject.apply(this, arguments);
        }

        return setBucketObject;
      }()
    }, {
      key: "setRedisData",
      value: function () {
        var _setRedisData = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee75(t) {
          return _regeneratorRuntime.wrap(function _callee75$(_context75) {
            while (1) {
              switch (_context75.prev = _context75.next) {
                case 0:
                  _context75.next = 2;
                  return this.asyncRedis.setData(t.redis_key, t.redis_id, t);

                case 2:
                case "end":
                  return _context75.stop();
              }
            }
          }, _callee75, this);
        }));

        function setRedisData(_x142) {
          return _setRedisData.apply(this, arguments);
        }

        return setRedisData;
      }()
    }, {
      key: "getRedisData",
      value: function () {
        var _getRedisData = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee76(t) {
          return _regeneratorRuntime.wrap(function _callee76$(_context76) {
            while (1) {
              switch (_context76.prev = _context76.next) {
                case 0:
                  _context76.next = 2;
                  return this.getRedisFromKeys(t.redis_key, t.redis_id);

                case 2:
                  return _context76.abrupt("return", _context76.sent);

                case 3:
                case "end":
                  return _context76.stop();
              }
            }
          }, _callee76, this);
        }));

        function getRedisData(_x143) {
          return _getRedisData.apply(this, arguments);
        }

        return getRedisData;
      }()
    }, {
      key: "getRedisFromKeys",
      value: function () {
        var _getRedisFromKeys = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee77(t, e) {
          return _regeneratorRuntime.wrap(function _callee77$(_context77) {
            while (1) {
              switch (_context77.prev = _context77.next) {
                case 0:
                  if (!("" === e || "" === t)) {
                    _context77.next = 2;
                    break;
                  }

                  throw new TypeError("Missing redis key or redis id .");

                case 2:
                  _context77.next = 4;
                  return this.asyncRedis.getData(t, e).catch(function (t) {
                    throw console.error("Error getting Redis content:", t), t;
                  });

                case 4:
                  return _context77.abrupt("return", _context77.sent);

                case 5:
                case "end":
                  return _context77.stop();
              }
            }
          }, _callee77, this);
        }));

        function getRedisFromKeys(_x144, _x145) {
          return _getRedisFromKeys.apply(this, arguments);
        }

        return getRedisFromKeys;
      }()
    }, {
      key: "getRedisDataFromDownload",
      value: function () {
        var _getRedisDataFromDownload = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee78(t) {
          return _regeneratorRuntime.wrap(function _callee78$(_context78) {
            while (1) {
              switch (_context78.prev = _context78.next) {
                case 0:
                  _context78.next = 2;
                  return this.getRedisFromKeys(t.redis_key, t.redis_id);

                case 2:
                  return _context78.abrupt("return", _context78.sent);

                case 3:
                case "end":
                  return _context78.stop();
              }
            }
          }, _callee78, this);
        }));

        function getRedisDataFromDownload(_x146) {
          return _getRedisDataFromDownload.apply(this, arguments);
        }

        return getRedisDataFromDownload;
      }()
    }, {
      key: "renderFooter",
      value: function renderFooter() {
        var t = {
          code: ".pdf-layout__footer {text-transform: uppercase;font-family:Helvetica Neue, Arial, sans-serif;display: flex; justify-content: space-between; padding: 2mm 4mm 0; text-align: center; color:#dfe6ec; width: 100%; font-size: 8px; }",
          render: function render() {
            return "<style>".concat(this.code, "</style>");
          }
        },
            e = d()(),
            n = e.format("YYYY"),
            o = {
          email: this.context.email,
          date: e.format("MM/DD/YYYY"),
          copyright: "Copyright &copy; ".concat(n, " Thomas Publishing Company"),
          render: function render() {
            return "<div class=\"pdf-layout__footer\"><div class=\"pdf-layout__footer-creator\"><span>Created by: ".concat(this.email, " (").concat(this.date, ")</span></div><div class=\"pdf-layout__footer-pagination\"> Page <strong><span class=\"pageNumber\"></span></strong> of <strong><span class=\"totalPages\"></span></strong></div><div class=\"pdf-layout__footer-copyright\"><span>").concat(this.copyright, "</span></div></div>");
          }
        };
        return t.render() + o.render();
      }
    }, {
      key: "getDownloadRequest",
      value: function () {
        var _getDownloadRequest = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee79(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee79$(_context79) {
            while (1) {
              switch (_context79.prev = _context79.next) {
                case 0:
                  _context79.next = 2;
                  return this.getRedisDataFromDownload(t);

                case 2:
                  e = _context79.sent;
                  return _context79.abrupt("return", ("done" === e.status && this.s3.getSignedUrl("getObject", {
                    Bucket: e.bucket_name,
                    Key: e.file_name
                  }, function (n, o) {
                    if (n) throw n;
                    t.download_url = o, t.status = e.status;
                  }), t));

                case 4:
                case "end":
                  return _context79.stop();
              }
            }
          }, _callee79, this);
        }));

        function getDownloadRequest(_x147) {
          return _getDownloadRequest.apply(this, arguments);
        }

        return getDownloadRequest;
      }()
    }]);

    return Lt;
  }();

  var Vt =
  /*#__PURE__*/
  function () {
    function Vt(t) {
      _classCallCheck(this, Vt);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Vt, [{
      key: "getProgramPosition",
      value: function () {
        var _getProgramPosition = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee80(t) {
          var e, n, o, a, i, s, r, c, l, d;
          return _regeneratorRuntime.wrap(function _callee80$(_context80) {
            while (1) {
              switch (_context80.prev = _context80.next) {
                case 0:
                  e = [];
                  _context80.next = 3;
                  return this.context.p3Configuration.get(t);

                case 3:
                  n = _context80.sent;

                  if (n) {
                    _context80.next = 6;
                    break;
                  }

                  return _context80.abrupt("return", e);

                case 6:
                  _context80.next = 8;
                  return this.context.p3ConfigurationCategory.findAll(t);

                case 8:
                  o = _context80.sent;
                  _context80.next = 11;
                  return this.context.p3ConfigurationRegion.findAll(t);

                case 11:
                  a = _context80.sent;
                  i = [];
                  s = [];
                  i.push("NAT"), a && a.length > 0 && a.forEach(function (t) {
                    i.push(t.region_code);
                  }), o && o.length > 0 && o.forEach(function (t) {
                    var e = {
                      id: t.category_id,
                      nat: t.national_purchased_rank_points,
                      reg: t.regional_purchased_rank_points
                    };
                    s.push(e);
                  });
                  r = n.tgrams_id ? n.tgrams_id : "00000";
                  c = 280 * C(n.rank_points, n.coverage_areas);
                  l = {
                    account: r = r.toString().trim().padStart(8, "0"),
                    progVal: c,
                    covgAreas: i,
                    headings: s
                  };
                  _context80.next = 20;
                  return this.context.ranks.getProgram(l);

                case 20:
                  d = _context80.sent;
                  return _context80.abrupt("return", (d && (e = this.transformResults(d)), e));

                case 22:
                case "end":
                  return _context80.stop();
              }
            }
          }, _callee80, this);
        }));

        function getProgramPosition(_x148) {
          return _getProgramPosition.apply(this, arguments);
        }

        return getProgramPosition;
      }()
    }, {
      key: "transformResults",
      value: function transformResults(t) {
        var e = [];
        return t && Object.keys(t).forEach(function (n) {
          if (n && t[n]) {
            var _o14 = [];
            Object.keys(t[n]).forEach(function (e) {
              if (e && t[n][e]) {
                var _a8 = {
                  name: e,
                  position: "string" == typeof t[n][e] ? t[n][e] : t[n][e].toString()
                };

                _o14.push(_a8);
              }
            });
            var _a7 = {
              headingId: n,
              region: _o14
            };
            e.push(_a7);
          }
        }), e;
      }
    }]);

    return Vt;
  }();

  var Ht =
  /*#__PURE__*/
  function () {
    function Ht(t) {
      _classCallCheck(this, Ht);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Ht, [{
      key: "getByType",
      value: function () {
        var _getByType = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee81(t, e) {
          var _e31;

          return _regeneratorRuntime.wrap(function _callee81$(_context81) {
            while (1) {
              switch (_context81.prev = _context81.next) {
                case 0:
                  if (!(console.log("resolvers.query.p3Configuration.getByType fired"), "campaign" === e.toLowerCase())) {
                    _context81.next = 5;
                    break;
                  }

                  _context81.next = 3;
                  return this.context.p3Campaign.get(t);

                case 3:
                  _e31 = _context81.sent;
                  return _context81.abrupt("return", _e31 ? this.context.p3Configuration.get(_e31.p3_configuration_id) : null);

                case 5:
                  return _context81.abrupt("return", this.context.p3Configuration.get(t));

                case 6:
                case "end":
                  return _context81.stop();
              }
            }
          }, _callee81, this);
        }));

        function getByType(_x149, _x150) {
          return _getByType.apply(this, arguments);
        }

        return getByType;
      }()
    }, {
      key: "saveConfiguration",
      value: function () {
        var _saveConfiguration = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee82(t) {
          var _this20 = this;

          var e, _t42, _n19, _o15, _e32, _i6, _s5, _r5, _c6, _l5, _t43, _n20, _t44, _t45;

          return _regeneratorRuntime.wrap(function _callee82$(_context82) {
            while (1) {
              switch (_context82.prev = _context82.next) {
                case 0:
                  e = JSON.parse(t);

                  if (!(console.log("configuration from module", Object(M.inspect)(e, !1, 10)), !e)) {
                    _context82.next = 3;
                    break;
                  }

                  return _context82.abrupt("return", null);

                case 3:
                  _t42 = e.progInfo.campaign_id;
                  _n19 = "00000" !== e.progInfo.configuration_id ? e.progInfo.configuration_id : Tt()();

                  if (!("00000" !== _t42)) {
                    _context82.next = 11;
                    break;
                  }

                  _context82.next = 8;
                  return this.getByType(_t42, "campaign");

                case 8:
                  _context82.t0 = _context82.sent;
                  _context82.next = 14;
                  break;

                case 11:
                  _context82.next = 13;
                  return this.getByType(_n19, "config");

                case 13:
                  _context82.t0 = _context82.sent;

                case 14:
                  _o15 = _context82.t0;

                  if (!("00000" !== _t42)) {
                    _context82.next = 21;
                    break;
                  }

                  _context82.next = 18;
                  return this.context.thomasCampaign.get(_t42);

                case 18:
                  _e32 = _context82.sent;

                  if (!(_e32 && a.CONSTANTS.NO_MORE_CHANGES_CAMPAIGN.includes(_e32.status_id))) {
                    _context82.next = 21;
                    break;
                  }

                  return _context82.abrupt("return", "no changes allowed");

                case 21:
                  _i6 = {
                    p3_configuration_id: _n19 = _o15 ? _o15.p3_configuration_id : _n19,
                    p3_campaign_id: "00000" !== _t42 ? _t42 : "",
                    rank_points: e.progConfig.TotalPurchasedPoints,
                    coverage_areas: e.progConfig.CoverageAreas,
                    preview_ads: 0,
                    program_value: e.progInfo.calculatedTotal,
                    name: _o15 ? _o15.name : e.progInfo.name,
                    description: _o15 ? _o15.description : "".concat(_n19, " - ").concat(e.progInfo.name),
                    status_id: _o15 ? _o15.status_id : 1,
                    start_date: _o15 ? _o15.start_date : e.progInfo.configStart,
                    end_date: _o15 ? _o15.end_date : e.progInfo.configEnd,
                    configuration_status_id: a.CONSTANTS.CONFIGURATION_STATUS.UNCONFIGURED,
                    owned_by: _o15 ? _o15.owned_by : "".concat(this.context.userId)
                  }, _s5 = this.getRegionsFromPM(e, _n19), _r5 = this.getCategoriesFromPM(e, _n19), _c6 = T(_r5, _s5);
                  _i6.status_id = N(_r5, _s5) ? 1 : 0, _i6.coverage_areas = _s5.length, console.log("ranks points", Object(M.inspect)(_i6.rank_points, !0, 10, !0)), console.log("validate_points", _c6), console.log("coverage areas", _i6.coverage_areas), console.log("coverage areas validate", _s5.length), console.log("builded configuration", _i6);
                  _context82.next = 25;
                  return this.context.qb.campaignalyzerClient.transaction();

                case 25:
                  _l5 = _context82.sent;
                  _context82.prev = 26;

                  if (!("00000" !== e.progInfo.configuration_id)) {
                    _context82.next = 38;
                    break;
                  }

                  _context82.next = 30;
                  return this.getConfiguration(e.progInfo.configuration_id);

                case 30:
                  _t43 = _context82.sent;
                  _n20 = {
                    p3_configuration_id: e.progInfo.configuration_id,
                    p3_configuration_log: JSON.stringify(_t43)
                  };
                  _context82.next = 34;
                  return _l5.insert(this.context.p3Configuration.makeDbEntity(_n20, {
                    isCreate: !0
                  })).into("p3_configuration_log");

                case 34:
                  _context82.next = 36;
                  return this.context.qb.campaignalyzerClient.table("p3_configuration").update(this.context.p3Configuration.makeDbEntity(_i6)).where({
                    p3_configuration_id: _i6.p3_configuration_id
                  }).transacting(_l5);

                case 36:
                  _context82.next = 40;
                  break;

                case 38:
                  _context82.next = 40;
                  return _l5.insert(this.context.p3Configuration.makeDbEntity(_i6, {
                    isCreate: !0
                  })).into("p3_configuration");

                case 40:
                  console.log("delete categories");
                  _context82.next = 43;
                  return this.context.qb.campaignalyzerClient.from("p3_configuration_category").where({
                    p3_configuration_id: _n19
                  }).del().transacting(_l5);

                case 43:
                  console.log("delete regions");
                  _context82.next = 46;
                  return this.context.qb.campaignalyzerClient.from("p3_configuration_region").where({
                    p3_configuration_id: _n19
                  }).del();

                case 46:
                  if (!(_r5.length > 0)) {
                    _context82.next = 51;
                    break;
                  }

                  console.log("insert categories");
                  _t44 = _r5.map(function (t) {
                    return _this20.context.p3Configuration.makeDbEntity(t, {
                      isCreate: !0
                    });
                  });
                  _context82.next = 51;
                  return this.context.qb.campaignalyzerClient.table("p3_configuration_category").insert(_t44).transacting(_l5);

                case 51:
                  if (!(_s5.length > 0)) {
                    _context82.next = 56;
                    break;
                  }

                  console.log("insert regions");
                  _t45 = _s5.map(function (t) {
                    return _this20.context.p3Configuration.makeDbEntity(t, {
                      isCreate: !0
                    });
                  });
                  _context82.next = 56;
                  return this.context.qb.campaignalyzerClient.table("p3_configuration_region").insert(_t45).transacting(_l5);

                case 56:
                  _context82.t1 = "00000" !== _t42;

                  if (!_context82.t1) {
                    _context82.next = 60;
                    break;
                  }

                  _context82.next = 60;
                  return this.updateThomasCampaign(_t42);

                case 60:
                  _context82.next = 62;
                  return _l5.commit();

                case 62:
                  return _context82.abrupt("return", _n19);

                case 65:
                  _context82.prev = 65;
                  _context82.t2 = _context82["catch"](26);
                  _context82.next = 69;
                  return _l5.rollback();

                case 69:
                  console.log("Something went wrong saving the full configuration.");
                  throw _context82.t2;

                case 71:
                case "end":
                  return _context82.stop();
              }
            }
          }, _callee82, this, [[26, 65]]);
        }));

        function saveConfiguration(_x151) {
          return _saveConfiguration.apply(this, arguments);
        }

        return saveConfiguration;
      }()
    }, {
      key: "getConfiguration",
      value: function () {
        var _getConfiguration2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee83(t) {
          var e, _e33;

          return _regeneratorRuntime.wrap(function _callee83$(_context83) {
            while (1) {
              switch (_context83.prev = _context83.next) {
                case 0:
                  _context83.next = 2;
                  return this.context.p3Configuration.get(t);

                case 2:
                  e = _context83.sent;

                  if (e) {
                    _context83.next = 6;
                    break;
                  }

                  _e33 = "P3 Campaign module is not configured configuration_id: ".concat(t);
                  return _context83.abrupt("return", (console.log(_e33), null));

                case 6:
                  _context83.t0 = e;
                  _context83.next = 9;
                  return this.context.p3ConfigurationCategory.findAll(e.p3_configuration_id);

                case 9:
                  _context83.t1 = _context83.sent;
                  _context83.next = 12;
                  return this.context.p3ConfigurationRegion.findAll(e.p3_configuration_id);

                case 12:
                  _context83.t2 = _context83.sent;
                  return _context83.abrupt("return", {
                    configuration: _context83.t0,
                    categories: _context83.t1,
                    regions: _context83.t2
                  });

                case 14:
                case "end":
                  return _context83.stop();
              }
            }
          }, _callee83, this);
        }));

        function getConfiguration(_x152) {
          return _getConfiguration2.apply(this, arguments);
        }

        return getConfiguration;
      }()
    }, {
      key: "updateThomasCampaign",
      value: function () {
        var _updateThomasCampaign = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee84(t) {
          var _e34;

          return _regeneratorRuntime.wrap(function _callee84$(_context84) {
            while (1) {
              switch (_context84.prev = _context84.next) {
                case 0:
                  _context84.prev = 0;
                  console.log("Checking if campaign status needs to be set to EDIT_NOT_PUBLISHED.");
                  _context84.next = 4;
                  return this.context.thomasCampaign.get(t);

                case 4:
                  _e34 = _context84.sent;
                  _context84.t0 = _e34 && _e34.product_id === a.CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS && _e34.status_id === a.CONSTANTS.CAMPAIGN_STATUS.PUBLISHED;

                  if (!_context84.t0) {
                    _context84.next = 10;
                    break;
                  }

                  console.log("Setting campaign status to EDIT_NOT_PUBLISHED.");
                  _context84.next = 10;
                  return this.context.thomasCampaign.setStatus(_e34.campaign_id, a.CONSTANTS.CAMPAIGN_STATUS.EDIT_NOT_PUBLISHED);

                case 10:
                  console.log("Campaign status does not need to be set to to EDIT_NOT_PUBLISHED.");
                  _context84.next = 16;
                  break;

                case 13:
                  _context84.prev = 13;
                  _context84.t1 = _context84["catch"](0);
                  console.log("error updating campaign", _context84.t1);

                case 16:
                case "end":
                  return _context84.stop();
              }
            }
          }, _callee84, this, [[0, 13]]);
        }));

        function updateThomasCampaign(_x153) {
          return _updateThomasCampaign.apply(this, arguments);
        }

        return updateThomasCampaign;
      }()
    }, {
      key: "getRegionsFromPM",
      value: function getRegionsFromPM(t, e) {
        var n = [];
        return t.covAreas && t.covAreas.forEach(function (t) {
          var o = {
            p3_configuration_id: e,
            region_code: t.RegionCode,
            name: t.RegionName,
            estimated_rank: 1
          };
          n.push(o);
        }), n;
      }
    }, {
      key: "getCategoriesFromPM",
      value: function getCategoriesFromPM(t, e) {
        var n = [];
        return t.progCats && t.progCats.forEach(function (t) {
          var o = {
            p3_configuration_id: e,
            category_id: t.CategoryId,
            category_name: t.CategoryName,
            national_purchased_rank_points: t.National.Purchased,
            national_total_rank_points: t.National.Price,
            national_estimated_rank: t.National.EstimatedRank,
            regional_purchased_rank_points: t.Regional.Purchased,
            regional_total_rank_points: t.Regional.Price,
            national_earned_rank_points: 0,
            national_bonus_rank_points: 0,
            regional_earned_rank_points: 0,
            regional_bonus_rank_points: 0,
            regional_estimated_ranks: "",
            has_national_preview_ad: !1,
            has_regional_preview_ad: !1
          };
          n.push(o);
        }), n;
      }
    }]);

    return Ht;
  }();

  var Yt =
  /*#__PURE__*/
  function () {
    function Yt(t) {
      _classCallCheck(this, Yt);

      var e, n, o;
      o = void 0, (n = "context") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.context = t;
    }

    _createClass(Yt, [{
      key: "RemoveRestrictCategoriesCampaigns",
      value: function () {
        var _RemoveRestrictCategoriesCampaigns = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee85(t, e) {
          var n, o, _i7, _s6, _i8, _a9, _i9, _a10;

          return _regeneratorRuntime.wrap(function _callee85$(_context85) {
            while (1) {
              switch (_context85.prev = _context85.next) {
                case 0:
                  n = Object(a.makeEmptyResponseInfo)();
                  _context85.next = 3;
                  return this.context.thomasCampaign.get(t);

                case 3:
                  o = _context85.sent;

                  if (!o) {
                    _context85.next = 29;
                    break;
                  }

                  _i7 = d()(e).startOf("day"), _s6 = _i7.toISOString();

                  if (!d()(o.start_date).startOf("day").isSameOrAfter(_i7)) {
                    _context85.next = 21;
                    break;
                  }

                  _context85.next = 9;
                  return this.context.p3Campaign.get(t);

                case 9:
                  _i8 = _context85.sent;

                  if (!_i8.p3_configuration_id) {
                    _context85.next = 19;
                    break;
                  }

                  console.log({
                    campaign_id: t,
                    newStartDate: e,
                    fixConfig: !0,
                    removeHeading: !0,
                    newStartDate1: d()(e).startOf("day").toISOString(),
                    campaignStartDateSt: _s6
                  });
                  _context85.next = 14;
                  return this.removeRestrictedCategoriesFromConfiguration(_i8.p3_configuration_id);

                case 14:
                  _context85.t0 = o.status_id === a.CONSTANTS.CAMPAIGN_STATUS.PUBLISHED;

                  if (!_context85.t0) {
                    _context85.next = 18;
                    break;
                  }

                  _context85.next = 18;
                  return this.context.thomasCampaign.setStatus(o.campaign_id, a.CONSTANTS.CAMPAIGN_STATUS.EDIT_NOT_PUBLISHED);

                case 18:
                  return _context85.abrupt("return", n);

                case 19:
                  _context85.next = 29;
                  break;

                case 21:
                  _a9 = d()(e).startOf("day").endOf("month").subtract(2, "days"), _i9 = _a9.toString();

                  if (!d()(o.end_date).startOf("day").isSameOrAfter(_a9)) {
                    _context85.next = 28;
                    break;
                  }

                  console.log({
                    campaign_id: t,
                    newStartDate: e,
                    optimization: !0,
                    removeHeading: !0,
                    canEndDate: d()(o.end_date).startOf("day").toISOString(),
                    lasEst: _i9
                  });
                  _a10 = new Dt(this.context);
                  _context85.next = 27;
                  return _a10.executeOptimizationRequest(t, e);

                case 27:
                  return _context85.abrupt("return", n);

                case 28:
                  console.log({
                    campaign_id: t,
                    startDate: o.start_date,
                    endDate: o.end_date,
                    lasEst: _i9,
                    soonExpire: !0
                  });

                case 29:
                  return _context85.abrupt("return", n);

                case 30:
                case "end":
                  return _context85.stop();
              }
            }
          }, _callee85, this);
        }));

        function RemoveRestrictCategoriesCampaigns(_x154, _x155) {
          return _RemoveRestrictCategoriesCampaigns.apply(this, arguments);
        }

        return RemoveRestrictCategoriesCampaigns;
      }()
    }, {
      key: "removeRestrictedCategoriesFromConfiguration",
      value: function () {
        var _removeRestrictedCategoriesFromConfiguration = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee86(t) {
          var e, n, _n21, o, i, s;

          return _regeneratorRuntime.wrap(function _callee86$(_context86) {
            while (1) {
              switch (_context86.prev = _context86.next) {
                case 0:
                  e = Object(a.makeEmptyResponseInfo)();
                  _context86.next = 3;
                  return this.context.p3Configuration.get(t);

                case 3:
                  n = _context86.sent;

                  if (n) {
                    _context86.next = 7;
                    break;
                  }

                  _n21 = "P3 Campaign module is not configured configuration_id: ".concat(t);
                  return _context86.abrupt("return", (console.log(_n21), e));

                case 7:
                  _context86.next = 9;
                  return this.context.p3ConfigurationCategory.findValidFromCategories(n.p3_configuration_id);

                case 9:
                  o = _context86.sent;
                  _context86.next = 12;
                  return this.context.p3ConfigurationRegion.findAll(n.p3_configuration_id);

                case 12:
                  i = _context86.sent;
                  s = o.reduce(function (t, e) {
                    return t + e.national_purchased_rank_points + e.regional_purchased_rank_points;
                  }, 0);
                  n.rank_points = s;
                  _context86.next = 17;
                  return this.context.p3ConfigurationCategory.deleteConfigCategories(n.p3_configuration_id);

                case 17:
                  _context86.next = 19;
                  return this.context.p3ConfigurationRegion.deleteConfigRegions(n.p3_configuration_id);

                case 19:
                  _context86.t0 = o.length > 0;

                  if (!_context86.t0) {
                    _context86.next = 23;
                    break;
                  }

                  _context86.next = 23;
                  return this.context.p3ConfigurationCategory.insert(o);

                case 23:
                  _context86.t1 = s > 0;

                  if (!_context86.t1) {
                    _context86.next = 27;
                    break;
                  }

                  _context86.next = 27;
                  return this.context.p3ConfigurationRegion.insert(i);

                case 27:
                  n.status_id = N(o, i) ? 1 : 0;
                  _context86.next = 30;
                  return this.context.p3Configuration.update(n);

                case 30:
                  return _context86.abrupt("return", e);

                case 31:
                case "end":
                  return _context86.stop();
              }
            }
          }, _callee86, this);
        }));

        function removeRestrictedCategoriesFromConfiguration(_x156) {
          return _removeRestrictedCategoriesFromConfiguration.apply(this, arguments);
        }

        return removeRestrictedCategoriesFromConfiguration;
      }()
    }]);

    return Yt;
  }(),
      zt = n(7);

  function Qt() {
    var t = process.env.SMART_USERNAME,
        e = process.env.SMART_PASSWORD,
        n = process.env.SMART_NETWORK_ID,
        o = process.env.DEBUG_MODE;
    if ("string" != typeof t) throw new Error("SMART_USERNAME env var is not set");
    if ("string" != typeof e) throw new Error("SMART_PASSWORD env var is not set");
    if ("string" != typeof n) throw new Error("SMART_NETWORK_ID env var is not set");
    if ("string" != typeof o) throw new Error("DEBUG_MODE env var is not set");
    return {
      username: t,
      password: e,
      networkId: parseInt(n, 10),
      debugMode: o
    };
  }

  function Wt() {
    var t = _objectSpread({
      client: gt.a
    }, Qt());

    return new zt.SmartQuery(t);
  }

  function Kt() {
    var t = Wt(),
        _Qt = Qt(),
        e = _Qt.networkId;

    return new zt.CampaignsApi({
      client: t,
      networkId: e
    });
  }

  function Jt() {
    var t = Wt(),
        _Qt2 = Qt(),
        e = _Qt2.networkId;

    return new zt.AdvertisersApi({
      client: t,
      networkId: e
    });
  }

  function Zt() {
    var t = Wt(),
        _Qt3 = Qt(),
        e = _Qt3.networkId;

    return new zt.InsertionsApi({
      client: t,
      networkId: e
    });
  }

  function Xt() {
    var t = Wt(),
        _Qt4 = Qt(),
        e = _Qt4.networkId;

    return new zt.CreativesApi({
      client: t,
      networkId: e
    });
  }

  function te() {
    var t = Wt(),
        _Qt5 = Qt(),
        e = _Qt5.networkId;

    return new zt.PagesApi({
      client: t,
      networkId: e
    });
  }

  function ee(t, e) {
    var n = t.toLowerCase();
    return n = function (t, e) {
      var n = new RegExp(/(\/|\(|\)| +)/, "g");
      return t.replace(n, e);
    }(n = function (t) {
      var e = new RegExp(/(,|-|\.|&)/, "g");
      return t.replace(e, "");
    }(n), "_"), n += "--".concat(e);
  }

  function ne(t, e, n) {
    var o = "pvs--".concat(t);
    return e && (o += "--".concat(e)), n && (o += "--".concat(n)), o;
  }

  function oe(t) {
    var e = new RegExp(/[,\-\(\)_ \/]+/, "g");
    return t.toLowerCase().replace(e, "_").replace(/_and_/, "_").replace(/_&_/, "_").replace(/_$/, "").replace(/'/, "");
  }

  function ae(t, e, n) {
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return {
      id: o,
      externalId: parseInt(t, 10),
      name: e,
      isDirectAdvertiser: !0,
      isHouseAds: !1,
      isArchived: !1,
      userGroupId: n
    };
  }

  function ie(t, e, n, o, a, i) {
    var s = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    return {
      id: s,
      advertiserId: e,
      campaignId: s,
      name: t,
      externalCampaignId: n,
      startDate: a,
      endDate: i,
      campaignStatusId: o
    };
  }

  function se(t, e, n, o, a) {
    var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    return {
      id: i,
      name: t,
      campaignId: e,
      startDate: o,
      endDate: a,
      weight: 25,
      insertionTypeId: 0,
      deliveryTypeId: 0,
      timezoneId: 32,
      priorityId: 103,
      pageIds: [n],
      insertionStatusId: 0,
      isDeliveryRegulated: !1,
      isUsedByGuaranteedDeal: !1,
      isUsedByNonGuaranteedDeal: !1,
      isPersonalizedAd: !1,
      voiceShare: 0,
      eventId: 0,
      description: "",
      periodicCappingId: 0,
      groupCappingId: 0,
      maxImpressions: 0,
      maxClicks: 0,
      maxImpressionsPerDay: 0,
      maxClicksPerDay: 0,
      eventImpressions: 0,
      isHolisticYieldEnabled: !1,
      deliverLeftVolumeAfterEndDate: !1,
      globalCapping: 0,
      cappingPerVisit: 0,
      cappingPerClick: 0,
      autoCapping: 0,
      periodicCappingImpressions: 0,
      periodicCappingPeriod: 0,
      isObaIconEnabled: !1,
      formatId: 72597,
      externalDescription: "",
      isArchived: !1,
      rateTypeId: 0,
      rate: 0,
      rateNet: 0,
      discount: 0,
      currencyId: 1,
      insertionLinkId: 0,
      customizedScript: "",
      salesChannelId: 1
    };
  }

  function re(t, e) {
    return ce("".concat(t), "pv--".concat(e), "Thomasnet.com/pv--".concat(e), "https://www.thomasnet.com/nsearch.html", 371356);
  }

  function ce(t, e, n, o, a) {
    return {
      id: 0,
      externalId: t,
      name: e,
      fullName: n,
      url: o,
      pageGroupId: a,
      parentPageId: 0,
      isArchived: !1
    };
  }

  var le = n(5),
      de = n.n(le);

  function ue(_x157, _x158, _x159) {
    return _ue.apply(this, arguments);
  }

  function _ue() {
    _ue = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee90(t, e, n) {
      var o, a;
      return _regeneratorRuntime.wrap(function _callee90$(_context90) {
        while (1) {
          switch (_context90.prev = _context90.next) {
            case 0:
              console.log("Begin uploading smart advertiser.");
              o =
              /*#__PURE__*/
              function () {
                var _ref17 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee89() {
                  return _regeneratorRuntime.wrap(function _callee89$(_context89) {
                    while (1) {
                      switch (_context89.prev = _context89.next) {
                        case 0:
                          return _context89.abrupt("return", (console.log("Attempting to create advertiser: ".concat(t.name)), e.create(n, t)));

                        case 1:
                        case "end":
                          return _context89.stop();
                      }
                    }
                  }, _callee89);
                }));

                return function o() {
                  return _ref17.apply(this, arguments);
                };
              }(), a = function a(e) {
                console.log("Failed to create advertiser ".concat(t.name, ". ").concat(e.attemptNumber, " failed. There are ").concat(e.retriesLeft, " attempts left."));
              };
              _context90.next = 4;
              return function () {
                return de()(o, {
                  retries: 5,
                  onFailedAttempt: a
                });
              }();

            case 4:
              console.log("Finished uploading advertiser.");

            case 5:
            case "end":
              return _context90.stop();
          }
        }
      }, _callee90);
    }));
    return _ue.apply(this, arguments);
  }

  function ge(_x160, _x161, _x162, _x163) {
    return _ge.apply(this, arguments);
  }

  function _ge() {
    _ge = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee92(t, e, n, o) {
      var a, i, s;
      return _regeneratorRuntime.wrap(function _callee92$(_context92) {
        while (1) {
          switch (_context92.prev = _context92.next) {
            case 0:
              console.log("Begin uploading smart campaign.");

              a =
              /*#__PURE__*/
              function () {
                var _ref18 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee91() {
                  return _regeneratorRuntime.wrap(function _callee91$(_context91) {
                    while (1) {
                      switch (_context91.prev = _context91.next) {
                        case 0:
                          return _context91.abrupt("return", (console.log("Attempting to upload campaign: ".concat(t.name)), e ? n.update(o, t) : n.create(o, t)));

                        case 1:
                        case "end":
                          return _context91.stop();
                      }
                    }
                  }, _callee91);
                }));

                return function a() {
                  return _ref18.apply(this, arguments);
                };
              }();

              i = function i(e) {
                console.log("Failed to upload campaign ".concat(t.name, ". ").concat(e.attemptNumber, " failed. There are ").concat(e.retriesLeft, " attempts left."));
              };

              _context92.next = 5;
              return function () {
                return de()(a, {
                  retries: 5,
                  onFailedAttempt: i
                });
              }();

            case 5:
              s = _context92.sent;
              return _context92.abrupt("return", (console.log("Finished uploading campaign."), s));

            case 7:
            case "end":
              return _context92.stop();
          }
        }
      }, _callee92);
    }));
    return _ge.apply(this, arguments);
  }

  function pe(_x164, _x165, _x166, _x167) {
    return _pe.apply(this, arguments);
  }

  function _pe() {
    _pe = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee94(t, e, n, o) {
      var a, i, s;
      return _regeneratorRuntime.wrap(function _callee94$(_context94) {
        while (1) {
          switch (_context94.prev = _context94.next) {
            case 0:
              console.log("Begin uploading smart insertion.");

              a =
              /*#__PURE__*/
              function () {
                var _ref19 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee93() {
                  return _regeneratorRuntime.wrap(function _callee93$(_context93) {
                    while (1) {
                      switch (_context93.prev = _context93.next) {
                        case 0:
                          return _context93.abrupt("return", (console.log("Attempting to upload insertion: ".concat(t.name)), e ? n.update(o, t) : n.create(o, t)));

                        case 1:
                        case "end":
                          return _context93.stop();
                      }
                    }
                  }, _callee93);
                }));

                return function a() {
                  return _ref19.apply(this, arguments);
                };
              }();

              i = function i(e) {
                console.log("Failed to upload insertion ".concat(t.name, ". ").concat(e.attemptNumber, " failed. There are ").concat(e.retriesLeft, " attempts left."));
              };

              _context94.next = 5;
              return function () {
                return de()(a, {
                  retries: 5,
                  onFailedAttempt: i
                });
              }();

            case 5:
              s = _context94.sent;
              return _context94.abrupt("return", (console.log("Finished uploading insertion."), s));

            case 7:
            case "end":
              return _context94.stop();
          }
        }
      }, _callee94);
    }));
    return _pe.apply(this, arguments);
  }

  function me(_x168, _x169, _x170) {
    return _me.apply(this, arguments);
  }

  function _me() {
    _me = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee96(t, e, n) {
      var o, a, i;
      return _regeneratorRuntime.wrap(function _callee96$(_context96) {
        while (1) {
          switch (_context96.prev = _context96.next) {
            case 0:
              console.log("Begin uploading smart creative.");

              o =
              /*#__PURE__*/
              function () {
                var _ref20 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee95() {
                  return _regeneratorRuntime.wrap(function _callee95$(_context95) {
                    while (1) {
                      switch (_context95.prev = _context95.next) {
                        case 0:
                          return _context95.abrupt("return", (console.log("Attempting to upload creative: ".concat(t.fileName)), e.create(n, t)));

                        case 1:
                        case "end":
                          return _context95.stop();
                      }
                    }
                  }, _callee95);
                }));

                return function o() {
                  return _ref20.apply(this, arguments);
                };
              }();

              a = function a(e) {
                console.log("Failed to create creative ".concat(t.fileName, ". ").concat(e.attemptNumber, " failed. There are ").concat(e.retriesLeft, " attempts left."));
              };

              _context96.next = 5;
              return function () {
                return de()(o, {
                  retries: 5,
                  onFailedAttempt: a
                });
              }();

            case 5:
              i = _context96.sent;
              return _context96.abrupt("return", (console.log("Finished uploading creative."), i));

            case 7:
            case "end":
              return _context96.stop();
          }
        }
      }, _callee96);
    }));
    return _me.apply(this, arguments);
  }

  function fe(_x171, _x172, _x173) {
    return _fe.apply(this, arguments);
  }

  function _fe() {
    _fe = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee97(t, e, n) {
      var _o16;

      return _regeneratorRuntime.wrap(function _callee97$(_context97) {
        while (1) {
          switch (_context97.prev = _context97.next) {
            case 0:
              console.log("Attempting to create page: ".concat(t.externalId, " -- ").concat(t.name));
              _context97.prev = 1;
              _context97.next = 4;
              return e.create(n, t);

            case 4:
              _o16 = _context97.sent;

              if (!(201 !== _o16.status)) {
                _context97.next = 7;
                break;
              }

              throw console.log("Response: ", Object(M.inspect)(_o16, !1, 10)), new Error("Failed to create page: ".concat(t.externalId, " -- ").concat(t.name));

            case 7:
              console.log("Successfully created page: ".concat(t.externalId, " -- ").concat(t.name));
              _context97.next = 13;
              break;

            case 10:
              _context97.prev = 10;
              _context97.t0 = _context97["catch"](1);
              throw console.log(_context97.t0), _context97.t0;

            case 13:
            case "end":
              return _context97.stop();
          }
        }
      }, _callee97, null, [[1, 10]]);
    }));
    return _fe.apply(this, arguments);
  }

  function he(_x174, _x175) {
    return _he.apply(this, arguments);
  }

  function _he() {
    _he = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee99(t, e) {
      var n, o, a, i, s;
      return _regeneratorRuntime.wrap(function _callee99$(_context99) {
        while (1) {
          switch (_context99.prev = _context99.next) {
            case 0:
              console.log("Begin getting smart advertiser.");
              n = [{
                key: "name",
                value: t
              }];
              o = e.buildUrl({
                filters: n
              });

              a =
              /*#__PURE__*/
              function () {
                var _ref21 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee98() {
                  return _regeneratorRuntime.wrap(function _callee98$(_context98) {
                    while (1) {
                      switch (_context98.prev = _context98.next) {
                        case 0:
                          return _context98.abrupt("return", (console.log("Attempting to get advertiser: ".concat(t)), e.get(o)));

                        case 1:
                        case "end":
                          return _context98.stop();
                      }
                    }
                  }, _callee98);
                }));

                return function a() {
                  return _ref21.apply(this, arguments);
                };
              }();

              i = function i(e) {
                console.log("Failed to get advertiser ".concat(t, ". ").concat(e.attemptNumber, " failed. There are ").concat(e.retriesLeft, " attempts left."));
              };

              _context99.next = 7;
              return function () {
                return de()(a, {
                  retries: 5,
                  onFailedAttempt: i
                });
              }();

            case 7:
              s = _context99.sent;
              return _context99.abrupt("return", (console.log(Object(M.inspect)(s, !1, 4)), console.log("Finished getting advertiser."), s.body));

            case 9:
            case "end":
              return _context99.stop();
          }
        }
      }, _callee99);
    }));
    return _he.apply(this, arguments);
  }

  function _e(_x176, _x177) {
    return _e35.apply(this, arguments);
  }

  function _e35() {
    _e35 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee101(t, e) {
      var n, o, a, i, s;
      return _regeneratorRuntime.wrap(function _callee101$(_context101) {
        while (1) {
          switch (_context101.prev = _context101.next) {
            case 0:
              console.log("Begin getting smart campaign.");
              n = [{
                key: "name",
                value: t
              }];
              o = e.buildUrl({
                filters: n
              });

              a =
              /*#__PURE__*/
              function () {
                var _ref22 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee100() {
                  return _regeneratorRuntime.wrap(function _callee100$(_context100) {
                    while (1) {
                      switch (_context100.prev = _context100.next) {
                        case 0:
                          return _context100.abrupt("return", (console.log("Attempting to get campaign: ".concat(t)), e.get(o)));

                        case 1:
                        case "end":
                          return _context100.stop();
                      }
                    }
                  }, _callee100);
                }));

                return function a() {
                  return _ref22.apply(this, arguments);
                };
              }();

              i = function i(e) {
                console.log("Failed to get campaign ".concat(t, ". ").concat(e.attemptNumber, " failed. There are ").concat(e.retriesLeft, " attempts left."));
              };

              _context101.next = 7;
              return function () {
                return de()(a, {
                  retries: 5,
                  onFailedAttempt: i
                });
              }();

            case 7:
              s = _context101.sent;
              return _context101.abrupt("return", (console.log(Object(M.inspect)(s, !1, 4)), console.log("Finished getting campaign."), s.body));

            case 9:
            case "end":
              return _context101.stop();
          }
        }
      }, _callee101);
    }));
    return _e35.apply(this, arguments);
  }

  function Ce(_x178, _x179) {
    return _Ce.apply(this, arguments);
  }

  function _Ce() {
    _Ce = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee103(t, e) {
      var n, o, a, i, s;
      return _regeneratorRuntime.wrap(function _callee103$(_context103) {
        while (1) {
          switch (_context103.prev = _context103.next) {
            case 0:
              console.log("Begin getting smart insertion.");
              n = [{
                key: "name",
                value: t
              }];
              o = e.buildUrl({
                filters: n
              });

              a =
              /*#__PURE__*/
              function () {
                var _ref23 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee102() {
                  return _regeneratorRuntime.wrap(function _callee102$(_context102) {
                    while (1) {
                      switch (_context102.prev = _context102.next) {
                        case 0:
                          return _context102.abrupt("return", (console.log("Attempting to get insertion: ".concat(t)), e.get(o)));

                        case 1:
                        case "end":
                          return _context102.stop();
                      }
                    }
                  }, _callee102);
                }));

                return function a() {
                  return _ref23.apply(this, arguments);
                };
              }();

              i = function i(e) {
                console.log("Failed to get insertion ".concat(t, ". ").concat(e.attemptNumber, " failed. There are ").concat(e.retriesLeft, " attempts left."));
              };

              _context103.next = 7;
              return function () {
                return de()(a, {
                  retries: 5,
                  onFailedAttempt: i
                });
              }();

            case 7:
              s = _context103.sent;
              return _context103.abrupt("return", (console.log(Object(M.inspect)(s, !1, 4)), console.log("Finished getting insertion."), s.body));

            case 9:
            case "end":
              return _context103.stop();
          }
        }
      }, _callee103);
    }));
    return _Ce.apply(this, arguments);
  }

  function Ae(_x180, _x181) {
    return _Ae.apply(this, arguments);
  }

  function _Ae() {
    _Ae = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee105(t, e) {
      var n, o, a, i;
      return _regeneratorRuntime.wrap(function _callee105$(_context105) {
        while (1) {
          switch (_context105.prev = _context105.next) {
            case 0:
              console.log("Begin getting smart insertions.");
              n = e.buildUrl({
                campaignId: t,
                subResource: "insertions"
              });

              o =
              /*#__PURE__*/
              function () {
                var _ref24 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee104() {
                  return _regeneratorRuntime.wrap(function _callee104$(_context104) {
                    while (1) {
                      switch (_context104.prev = _context104.next) {
                        case 0:
                          return _context104.abrupt("return", (console.log("Attempting to get insertions for campaignId: ".concat(t)), e.get(n)));

                        case 1:
                        case "end":
                          return _context104.stop();
                      }
                    }
                  }, _callee104);
                }));

                return function o() {
                  return _ref24.apply(this, arguments);
                };
              }();

              a = function a(e) {
                console.log("Failed to get insertions for campaignId: ".concat(t, ". ").concat(e.attemptNumber, " failed. There are ").concat(e.retriesLeft, " attempts left."));
              };

              _context105.next = 6;
              return function () {
                return de()(o, {
                  retries: 5,
                  onFailedAttempt: a
                });
              }();

            case 6:
              i = _context105.sent;
              return _context105.abrupt("return", (console.log(Object(M.inspect)(i, !1, 4)), console.log("Finished getting insertions."), i.body));

            case 8:
            case "end":
              return _context105.stop();
          }
        }
      }, _callee105);
    }));
    return _Ae.apply(this, arguments);
  }

  function ye(_x182, _x183) {
    return _ye.apply(this, arguments);
  }

  function _ye() {
    _ye = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee106(t, e) {
      var n, _o17, _a11, _i10, _s7;

      return _regeneratorRuntime.wrap(function _callee106$(_context106) {
        while (1) {
          switch (_context106.prev = _context106.next) {
            case 0:
              console.log("Attempting to retrieve page by externalId: ".concat(t));
              _context106.prev = 1;
              _o17 = [{
                key: "externalId",
                value: t
              }];
              _a11 = e.buildUrl({
                filters: _o17
              });
              _context106.next = 6;
              return e.get(_a11);

            case 6:
              _i10 = _context106.sent;
              _s7 = _i10.body ? _i10.body : [];

              if (!(200 !== _i10.status || 0 === _s7.length)) {
                _context106.next = 10;
                break;
              }

              throw console.log("Response: ", Object(M.inspect)(_i10, !1, 10)), new Error("Failed to retrieve page: ".concat(t));

            case 10:
              if (!(_s7.length > 1)) {
                _context106.next = 12;
                break;
              }

              throw new Error("Unexpected result. More than one page returned.");

            case 12:
              n = _objectSpread({}, _s7[0]), console.log("Successfully retrieved page: ".concat(t));
              _context106.next = 18;
              break;

            case 15:
              _context106.prev = 15;
              _context106.t0 = _context106["catch"](1);
              throw console.log(_context106.t0), _context106.t0;

            case 18:
              return _context106.abrupt("return", n);

            case 19:
            case "end":
              return _context106.stop();
          }
        }
      }, _callee106, null, [[1, 15]]);
    }));
    return _ye.apply(this, arguments);
  }

  n.d(e, "P3Amender", function () {
    return at;
  }), n.d(e, "P3Optimizer", function () {
    return st;
  }), n.d(e, "P3Renewer", function () {
    return ct;
  }), n.d(e, "P3pdfExporter", function () {
    return Lt;
  }), n.d(e, "P3pdfExporterSqs", function () {
    return Gt;
  }), n.d(e, "BaseP3CampaignUpdater", function () {
    return nt;
  }), n.d(e, "ConfigRetriever", function () {
    return dt;
  }), n.d(e, "publishCampaign", function () {
    return ft;
  }), n.d(e, "PvsPublisher", function () {
    return _t;
  }), n.d(e, "AmendProductInvoker", function () {
    return Ct;
  }), n.d(e, "RenewalProductInvoker", function () {
    return At;
  }), n.d(e, "NewProductInvoker", function () {
    return Rt;
  }), n.d(e, "OptimizeProductInvoker", function () {
    return Dt;
  }), n.d(e, "FulfillmentRequestHandler", function () {
    return $t;
  }), n.d(e, "FulfillmentRequestInvokerFactory", function () {
    return Ft;
  }), n.d(e, "createAdServerAdvertiser", function () {
    return Et;
  }), n.d(e, "CampaignFactory", function () {
    return kt;
  }), n.d(e, "ICampaignFactoryConfig", function () {}), n.d(e, "createThomasAdvertiser", function () {
    return vt;
  }), n.d(e, "createP3Campaign", function () {
    return It;
  }), n.d(e, "AdvertiserFactory", function () {
    return Pt;
  }), n.d(e, "createPvsCampaign", function () {
    return Nt;
  }), n.d(e, "createThomasCampaign", function () {
    return xt;
  }), n.d(e, "tranformCompanyName", function () {
    return c;
  }), n.d(e, "capitalizeFirstCharacter", function () {
    return i;
  }), n.d(e, "configurationValidPoints", function () {
    return A;
  }), n.d(e, "validateConfiguration", function () {
    return y;
  }), n.d(e, "p3CampaignNameVersionGenerator", function () {
    return P;
  }), n.d(e, "canBeOptimized", function () {
    return E;
  }), n.d(e, "canBeEdited", function () {
    return R;
  }), n.d(e, "canBePublished", function () {
    return k;
  }), n.d(e, "listOfValidOptimizationDates", function () {
    return v;
  }), n.d(e, "pointsAreValid", function () {
    return I;
  }), n.d(e, "CampaignDuplicator", function () {
    return tt;
  }), n.d(e, "P3Duplicator", function () {
    return Z;
  }), n.d(e, "PvsDuplicator", function () {
    return X;
  }), n.d(e, "StepFunctionClient", function () {
    return j;
  }), n.d(e, "S3Client", function () {
    return q;
  }), n.d(e, "SQSClient", function () {
    return z;
  }), n.d(e, "SmartUtils", function () {
    return o;
  }), n.d(e, "AutoAllocation", function () {
    return Ot;
  }), n.d(e, "AutoAllocationSqs", function () {
    return wt;
  }), n.d(e, "AutoAllocationAlert", function () {
    return bt;
  }), n.d(e, "AsyncRedis", function () {
    return J;
  }), n.d(e, "getRankPublishableDate", function () {
    return _;
  }), n.d(e, "getThisMonthLastDay", function () {
    return p;
  }), n.d(e, "getThisMonthCutOffDate", function () {
    return g;
  }), n.d(e, "canBeLocked", function () {
    return h;
  }), n.d(e, "p3PoitnsAlgorithm", function () {
    return C;
  }), n.d(e, "canAccessLegacyOpportunity", function () {
    return x;
  }), n.d(e, "campaignNameBuilder", function () {
    return s;
  }), n.d(e, "createNameByDuplication", function () {
    return r;
  }), n.d(e, "P3ConfigPositioner", function () {
    return Vt;
  }), n.d(e, "getNextMonthFirstDay", function () {
    return m;
  }), n.d(e, "rawAllocatedPoints", function () {
    return T;
  }), n.d(e, "validateConfigurationFromCatAndReg", function () {
    return O;
  }), n.d(e, "FulfillmentForcedWorker", function () {
    return Ut;
  }), n.d(e, "rawPurchasedPoints", function () {
    return w;
  }), n.d(e, "hasRegPointsAndCov", function () {
    return N;
  }), n.d(e, "getLastDayToPublish", function () {
    return f;
  }), n.d(e, "P3Configurator", function () {
    return Ht;
  }), n.d(e, "P3ConfiguratorRemover", function () {
    return Yt;
  });
}]);